/* eslint-disable prettier/prettier */
/* eslint-disable max-len */
/* eslint-disable key-spacing */

/**
 * 이 파일은 toolkit/generate-api 에 의해 자동으로 생성됩니다.
 *
 * - ACLOSET_ENV : qa
 * - 생성일 : 2025. 1. 23. 오후 4:42:52
 */


// ************************************************************************************************

/**
 * ai-description - writing-style 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_WRITING_STYLE_CODE_LIST = [
  'AI-DESCRIPTION_WRITING-STYLE_BASIC',      // 기본 설명체
  'AI-DESCRIPTION_WRITING-STYLE_EMOTIONAL',  // 감성문체
  'AI-DESCRIPTION_WRITING-STYLE_NICE',       // 친절 설명체
  'AI-DESCRIPTION_WRITING-STYLE_SIMPLE',     // 요약 단답문체
  'AI-DESCRIPTION_WRITING-STYLE_SMART',      // 스마트 제안문체
] as const;

/**
 * ai-description - writing-style 타입.
 */
export type AclosetAiDescriptionWritingStyleCode = (typeof ACLOSET_AI_DESCRIPTION_WRITING_STYLE_CODE_LIST)[number];

/**
 * ai-description - writing-style Short 코드 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_WRITING_STYLE_SHORT_CODE_LIST = [
  'basic',      // 기본 설명체
  'emotional',  // 감성문체
  'nice',       // 친절 설명체
  'simple',     // 요약 단답문체
  'smart',      // 스마트 제안문체
] as const;

/**
 * ai-description - writing-style Short 코드 타입.
 */
export type AclosetAiDescriptionWritingStyleShortCode = (typeof ACLOSET_AI_DESCRIPTION_WRITING_STYLE_SHORT_CODE_LIST)[number];

/**
 * ai-description - writing-style Short 코드 매핑.
 */
export const ACLOSET_AI_DESCRIPTION_WRITING_STYLE_SHORT_CODE_MAP: Readonly<Record<AclosetAiDescriptionWritingStyleShortCode, AclosetAiDescriptionWritingStyleCode>> = {
  'basic'    : 'AI-DESCRIPTION_WRITING-STYLE_BASIC',
  'emotional': 'AI-DESCRIPTION_WRITING-STYLE_EMOTIONAL',
  'nice'     : 'AI-DESCRIPTION_WRITING-STYLE_NICE',
  'simple'   : 'AI-DESCRIPTION_WRITING-STYLE_SIMPLE',
  'smart'    : 'AI-DESCRIPTION_WRITING-STYLE_SMART',
};

/**
 * ai-description - writing-style Short 코드 역매핑.
 */
export const ACLOSET_AI_DESCRIPTION_WRITING_STYLE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAiDescriptionWritingStyleCode, AclosetAiDescriptionWritingStyleShortCode>> = {
  'AI-DESCRIPTION_WRITING-STYLE_BASIC'    : 'basic',
  'AI-DESCRIPTION_WRITING-STYLE_EMOTIONAL': 'emotional',
  'AI-DESCRIPTION_WRITING-STYLE_NICE'     : 'nice',
  'AI-DESCRIPTION_WRITING-STYLE_SIMPLE'   : 'simple',
  'AI-DESCRIPTION_WRITING-STYLE_SMART'    : 'smart',
};

// ************************************************************************************************

/**
 * ai-description - status 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_STATUS_CODE_LIST = [
  'AI-DESCRIPTION_STATUS_DONE',         // 완료
  'AI-DESCRIPTION_STATUS_FAILED',       // 실패
  'AI-DESCRIPTION_STATUS_IDLE',         // 대기중
  'AI-DESCRIPTION_STATUS_IN-PROGRESS',  // 진행중
] as const;

/**
 * ai-description - status 타입.
 */
export type AclosetAiDescriptionStatusCode = (typeof ACLOSET_AI_DESCRIPTION_STATUS_CODE_LIST)[number];

/**
 * ai-description - status Short 코드 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_STATUS_SHORT_CODE_LIST = [
  'done',         // 완료
  'failed',       // 실패
  'idle',         // 대기중
  'in-progress',  // 진행중
] as const;

/**
 * ai-description - status Short 코드 타입.
 */
export type AclosetAiDescriptionStatusShortCode = (typeof ACLOSET_AI_DESCRIPTION_STATUS_SHORT_CODE_LIST)[number];

/**
 * ai-description - status Short 코드 매핑.
 */
export const ACLOSET_AI_DESCRIPTION_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetAiDescriptionStatusShortCode, AclosetAiDescriptionStatusCode>> = {
  'done'       : 'AI-DESCRIPTION_STATUS_DONE',
  'failed'     : 'AI-DESCRIPTION_STATUS_FAILED',
  'idle'       : 'AI-DESCRIPTION_STATUS_IDLE',
  'in-progress': 'AI-DESCRIPTION_STATUS_IN-PROGRESS',
};

/**
 * ai-description - status Short 코드 역매핑.
 */
export const ACLOSET_AI_DESCRIPTION_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAiDescriptionStatusCode, AclosetAiDescriptionStatusShortCode>> = {
  'AI-DESCRIPTION_STATUS_DONE'       : 'done',
  'AI-DESCRIPTION_STATUS_FAILED'     : 'failed',
  'AI-DESCRIPTION_STATUS_IDLE'       : 'idle',
  'AI-DESCRIPTION_STATUS_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * ai-description - info 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_INFO_CODE_LIST = [
  'AI-DESCRIPTION_INFO_BASIC',         // 상품 기본 정보
  'AI-DESCRIPTION_INFO_BRAND',         // 브랜드 간단 소개 (프리미엄, 해외 브랜드만)
  'AI-DESCRIPTION_INFO_DETAIL-POINT',  // 디테일한 포인트
  'AI-DESCRIPTION_INFO_STYLING-TIP',   // 코디/스타일링 팁
  'AI-DESCRIPTION_INFO_TPO-USAGE',     // TPO 측면의 활용도
] as const;

/**
 * ai-description - info 타입.
 */
export type AclosetAiDescriptionInfoCode = (typeof ACLOSET_AI_DESCRIPTION_INFO_CODE_LIST)[number];

/**
 * ai-description - info Short 코드 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_INFO_SHORT_CODE_LIST = [
  'basic',         // 상품 기본 정보
  'brand',         // 브랜드 간단 소개 (프리미엄, 해외 브랜드만)
  'detail-point',  // 디테일한 포인트
  'styling-tip',   // 코디/스타일링 팁
  'tpo-usage',     // TPO 측면의 활용도
] as const;

/**
 * ai-description - info Short 코드 타입.
 */
export type AclosetAiDescriptionInfoShortCode = (typeof ACLOSET_AI_DESCRIPTION_INFO_SHORT_CODE_LIST)[number];

/**
 * ai-description - info Short 코드 매핑.
 */
export const ACLOSET_AI_DESCRIPTION_INFO_SHORT_CODE_MAP: Readonly<Record<AclosetAiDescriptionInfoShortCode, AclosetAiDescriptionInfoCode>> = {
  'basic'       : 'AI-DESCRIPTION_INFO_BASIC',
  'brand'       : 'AI-DESCRIPTION_INFO_BRAND',
  'detail-point': 'AI-DESCRIPTION_INFO_DETAIL-POINT',
  'styling-tip' : 'AI-DESCRIPTION_INFO_STYLING-TIP',
  'tpo-usage'   : 'AI-DESCRIPTION_INFO_TPO-USAGE',
};

/**
 * ai-description - info Short 코드 역매핑.
 */
export const ACLOSET_AI_DESCRIPTION_INFO_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAiDescriptionInfoCode, AclosetAiDescriptionInfoShortCode>> = {
  'AI-DESCRIPTION_INFO_BASIC'       : 'basic',
  'AI-DESCRIPTION_INFO_BRAND'       : 'brand',
  'AI-DESCRIPTION_INFO_DETAIL-POINT': 'detail-point',
  'AI-DESCRIPTION_INFO_STYLING-TIP' : 'styling-tip',
  'AI-DESCRIPTION_INFO_TPO-USAGE'   : 'tpo-usage',
};

// ************************************************************************************************

/**
 * ai-description - example 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_EXAMPLE_CODE_LIST = [
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-BASIC-NO-EMOJI',               // 폴로 랄프로렌 남성용 셔츠입니다. 면 소재로 제작되어 착용감이 부드러우며, 하늘색 바탕에 얇은 스트라이프 패턴이 특징입니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-BASIC-WITH-EMOJI',             // 폴로 랄프로렌 남성용 셔츠입니다. 면 소재로 제작되어 착용감이 부드러우며, 하늘색 바탕에 얇은 스트라이프 패턴이 특징입니다. 😊
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-EMOTIONAL-NO-EMOJI',           // 폴로 랄프로렌의 남성용 셔츠입니다. 부드러운 면 혼방 소재로 만들어져 편안한 착용감을 제공하며, 은은한 하늘색 바탕에 섬세한 스트라이프 패턴이 시원한 느낌을 더합니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',         // 폴로 랄프로렌의 남성용 셔츠입니다. 부드러운 면 혼방 소재로 만들어져 편안한 착용감을 제공하며, 은은한 하늘색 바탕에 섬세한 스트라이프 패턴이 시원한 느낌을 더합니다. 😊
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-NICE-NO-EMOJI',                // 폴로 랄프로렌의 남성용 셔츠에요. 시원한 하늘색 바탕에 얇은 스트라이프 패턴이 들어가있어요. 또한, 면 소재여서 착용감도 부드러워요.
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-NICE-WITH-EMOJI',              // 폴로 랄프로렌의 남성용 셔츠에요. 시원한 하늘색 바탕에 얇은 스트라이프 패턴이 들어가있어요. 또한, 면 소재여서 착용감도 부드러워요. 😊
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SIMPLE-NO-EMOJI',              // 남성 셔츠, 폴로 랄프로렌, 면 혼방 소재, 하늘색, 세련된 핏
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SIMPLE-WITH-EMOJI',            // 남성 셔츠, 폴로 랄프로렌, 면 혼방 소재, 하늘색, 세련된 핏 👔
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SMART-NO-EMOJI',               // 폴로 랄프로렌 남성용 셔츠입니다. 면 혼방 소재로 제작되어 부드러운 착용감을 제공하며, 하늘색 바탕에 가는 스트라이프 패턴이 특징입니다. 어깨 42cm, 가슴단면 57cm, 총장 77cm의 L 사이즈입니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SMART-WITH-EMOJI',             // 폴로 랄프로렌 남성용 셔츠입니다. 면 혼방 소재로 제작되어 부드러운 착용감을 제공하며, 하늘색 바탕에 가는 스트라이프 패턴이 특징입니다. 어깨 42cm, 가슴단면 57cm, 총장 77cm의 L 사이즈입니다. 👔
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-BASIC-NO-EMOJI',               // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질 소재로 유명한 미국 브랜드입니다. 미국 전통의 아메리칸 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보이고 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-BASIC-WITH-EMOJI',             // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질의 소재로 유명한, 미국을 대표하는 브랜드입니다. 미국 전통의 아메리칸 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보이고 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-EMOTIONAL-NO-EMOJI',           // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 전 세계적으로 많은 사랑을 받고 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',         // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 전 세계적으로 많은 사랑을 받고 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-NICE-NO-EMOJI',                // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질 소재로 유명한 미국 브랜드에요. 특히, 폴로 셔츠는 브랜드의 상징적인 아이템으로 전 세계적으로 많은 사랑받고 있답니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-NICE-WITH-EMOJI',              // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질 소재로 유명한 미국 브랜드에요. 특히, 폴로 셔츠는 브랜드의 상징적인 아이템으로 전 세계적으로 많은 사랑받고 있답니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SIMPLE-NO-EMOJI',              // RALPH LAUREN, 미국 프리미엄 브랜드, 클래식하고 고급스러운 디자인, 높은 품질
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SIMPLE-WITH-EMOJI',            // RALPH LAUREN, 미국 프리미엄 브랜드, 클래식하고 고급스러운 디자인, 높은 품질 👍
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SMART-NO-EMOJI',               // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 패션 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 유명합니다. 미국 전통적인 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보입니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SMART-WITH-EMOJI',             // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 패션 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 유명합니다. 미국 전통적인 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보입니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-BASIC-NO-EMOJI',        // 셔츠 가슴 부분에 작은 포켓이 있으며, 전체적으로 얇고 촘촘한 스트라이프 패턴이 세련된 느낌을 더하고 있습니다. 소매 부분과 밑단 마감이 깔끔하게 처리되어 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-BASIC-WITH-EMOJI',      // 셔츠 가슴 부분에 작은 포켓이 있으며, 전체적으로 얇고 촘촘한 스트라이프 패턴이 세련된 느낌을 더하고 있습니다. 소매 부분과 밑단 마감이 깔끔하게 처리되어 있습니다. 👍
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-EMOTIONAL-NO-EMOJI',    // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감으로, 빈티지 특유의 매력이 더욱 돋보이는 아이템입니다. 또한, 왼쪽 가슴에 위치한 작은 포켓은 실용적이면서도 디자인적으로 포인트가 됩니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',  // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감으로, 빈티지 특유의 매력이 더욱 돋보이는 아이템입니다. 또한, 왼쪽 가슴에 위치한 작은 포켓은 실용적이면서도 디자인적으로 포인트가 됩니다. 👍
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-NICE-NO-EMOJI',         // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감이 돋보여요. 또한, 가슴 부분에 작은 포켓이 있어 실용성까지 갖추었답니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-NICE-WITH-EMOJI',       // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감이 돋보여요. 또한, 가슴 부분에 작은 포켓이 있어 실용성까지 갖추었답니다. 👍
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SIMPLE-NO-EMOJI',       // 스트라이프 패턴, 깔끔한 디자인, 왼쪽 가슴 포켓, 섬세한 봉제 마감
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SIMPLE-WITH-EMOJI',     // 스트라이프 패턴, 깔끔한 디자인, 왼쪽 가슴 포켓, 섬세한 봉제 마감 ✨
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SMART-NO-EMOJI',        // 전체적으로 얇은 스트라이프 패턴이 특징이며, 왼쪽 가슴에는 작은 포켓이 부착되어 있습니다. 셔츠의 밑단과 소매 부분은 깔끔하고 꼼꼼하게 마감 처리되어 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SMART-WITH-EMOJI',      // 전체적으로 얇은 스트라이프 패턴이 특징이며, 왼쪽 가슴에는 작은 포켓이 부착되어 있습니다. 셔츠의 밑단과 소매 부분은 깔끔하고 꼼꼼하게 마감 처리되어 있습니다. ✨
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-BASIC-NO-EMOJI',         // 청바지나 베이지 면바지와 캐주얼하게 코디하거나, 슬랙스와 착용하여 세미 포멀 느낌을 줄 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 팬츠나 액세서리를 매치하는 것이 좋습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-BASIC-WITH-EMOJI',       // 청바지나 베이지 면바지와 캐주얼하게 코디하거나, 슬랙스와 착용하여 세미 포멀 느낌을 줄 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 팬츠나 액세서리를 매치하는 것이 좋습니다. 👔
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-EMOTIONAL-NO-EMOJI',     // 청바지나 베이지 면바지와 함께 코디해, 캐주얼하고 세련된 미니멀 룩을 연출해보세요. 소매를 롤업하거나, 셔츠의 깃을 살짝 세우면 스타일리시함을 더할 수 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',   // 청바지나 베이지 면바지와 함께 코디해, 캐주얼하고 세련된 미니멀 룩을 연출해보세요. 소매를 롤업하거나, 셔츠의 깃을 살짝 세우면 스타일리시함을 더할 수 있습니다. 👔
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-NICE-NO-EMOJI',          // 청바지나 베이지 면바지와 함께 캐주얼하게 코디하거나, 슬랙스와 착용하여 댄디한 스타일을 연출해 보세요. 소매를 롤업해서 입으면 더욱 스타일리쉬해 보일 거예요.
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-NICE-WITH-EMOJI',        // 청바지나 베이지 면바지와 함께 캐주얼하게 코디하거나, 슬랙스와 착용하여 댄디한 스타일을 연출해 보세요. 소매를 롤업해서 입으면 더욱 스타일리쉬해 보일 거예요. 👔
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SIMPLE-NO-EMOJI',        // 청바지나 베이지 팬츠와 코디, 캐주얼/댄디룩, 봄 가을 코디
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SIMPLE-WITH-EMOJI',      // 청바지나 베이지 팬츠와 코디, 캐주얼/댄디룩, 봄 가을 코디 🍂
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SMART-NO-EMOJI',         // 청바지나 베이지 면바지와 매치하여 캐주얼하면서도 깔끔한 스타일을 연출할 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 바지나 악세사리를 선택하는 것이 좋습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SMART-WITH-EMOJI',       // 청바지나 베이지 면바지와 매치하여 캐주얼하면서도 깔끔한 스타일을 연출할 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 바지나 악세사리를 선택하는 것이 좋습니다. 👖
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-BASIC-NO-EMOJI',           // 봄이나 가을철에 입기 좋은 셔츠입니다. 비즈니스 캐주얼 상황이나 데이트 등에서 깔끔하면서도 스타일리시하게 입기 좋습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-BASIC-WITH-EMOJI',         // 봄이나 가을철에 입기 좋은 셔츠입니다. 비즈니스 캐주얼 상황이나 데이트 등에서 깔끔하면서도 스타일리시하게 입기 좋습니다. ✨
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-EMOTIONAL-NO-EMOJI',       // 가을, 봄 시즌에 입기 좋으며, 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에서 편안하게 스타일링 할 수 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',     // 가을, 봄 시즌에 입기 좋으며, 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에서 편안하게 스타일링 할 수 있습니다. ✨
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-NICE-NO-EMOJI',            // 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에 깔끔하면서도 스타일리시하게 입을 수 있어요. 특히, 봄, 가을 시즌에 활용하기 좋답니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-NICE-WITH-EMOJI',          // 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에 깔끔하면서도 스타일리시하게 입을 수 있어요. 특히, 봄, 가을 시즌에 활용하기 좋답니다. ✨
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SIMPLE-NO-EMOJI',          // 캐주얼 데이트, 친구들과의 모임, 비즈니스 캐주얼, 캠퍼스룩
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SIMPLE-WITH-EMOJI',        // 캐주얼 데이트, 친구들과의 모임, 비즈니스 캐주얼, 캠퍼스룩 👍
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SMART-NO-EMOJI',           // 비즈니스 캐주얼 상황이나, 약간의 격식을 갖춰야 하는 자리에도 적합합니다. 세련된 디자인과 고급 소재로 깔끔한 인상을 줄 수 있습니다.
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SMART-WITH-EMOJI',         // 비즈니스 캐주얼 상황이나, 약간의 격식을 갖춰야 하는 자리에도 적합합니다. 세련된 디자인과 고급 소재로 깔끔한 인상을 줄 수 있습니다. 👍
] as const;

/**
 * ai-description - example 타입.
 */
export type AclosetAiDescriptionExampleCode = (typeof ACLOSET_AI_DESCRIPTION_EXAMPLE_CODE_LIST)[number];

/**
 * ai-description - example Short 코드 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_EXAMPLE_SHORT_CODE_LIST = [
  'info-basic-writing-style-basic-no-emoji',               // 폴로 랄프로렌 남성용 셔츠입니다. 면 소재로 제작되어 착용감이 부드러우며, 하늘색 바탕에 얇은 스트라이프 패턴이 특징입니다.
  'info-basic-writing-style-basic-with-emoji',             // 폴로 랄프로렌 남성용 셔츠입니다. 면 소재로 제작되어 착용감이 부드러우며, 하늘색 바탕에 얇은 스트라이프 패턴이 특징입니다. 😊
  'info-basic-writing-style-emotional-no-emoji',           // 폴로 랄프로렌의 남성용 셔츠입니다. 부드러운 면 혼방 소재로 만들어져 편안한 착용감을 제공하며, 은은한 하늘색 바탕에 섬세한 스트라이프 패턴이 시원한 느낌을 더합니다.
  'info-basic-writing-style-emotional-with-emoji',         // 폴로 랄프로렌의 남성용 셔츠입니다. 부드러운 면 혼방 소재로 만들어져 편안한 착용감을 제공하며, 은은한 하늘색 바탕에 섬세한 스트라이프 패턴이 시원한 느낌을 더합니다. 😊
  'info-basic-writing-style-nice-no-emoji',                // 폴로 랄프로렌의 남성용 셔츠에요. 시원한 하늘색 바탕에 얇은 스트라이프 패턴이 들어가있어요. 또한, 면 소재여서 착용감도 부드러워요.
  'info-basic-writing-style-nice-with-emoji',              // 폴로 랄프로렌의 남성용 셔츠에요. 시원한 하늘색 바탕에 얇은 스트라이프 패턴이 들어가있어요. 또한, 면 소재여서 착용감도 부드러워요. 😊
  'info-basic-writing-style-simple-no-emoji',              // 남성 셔츠, 폴로 랄프로렌, 면 혼방 소재, 하늘색, 세련된 핏
  'info-basic-writing-style-simple-with-emoji',            // 남성 셔츠, 폴로 랄프로렌, 면 혼방 소재, 하늘색, 세련된 핏 👔
  'info-basic-writing-style-smart-no-emoji',               // 폴로 랄프로렌 남성용 셔츠입니다. 면 혼방 소재로 제작되어 부드러운 착용감을 제공하며, 하늘색 바탕에 가는 스트라이프 패턴이 특징입니다. 어깨 42cm, 가슴단면 57cm, 총장 77cm의 L 사이즈입니다.
  'info-basic-writing-style-smart-with-emoji',             // 폴로 랄프로렌 남성용 셔츠입니다. 면 혼방 소재로 제작되어 부드러운 착용감을 제공하며, 하늘색 바탕에 가는 스트라이프 패턴이 특징입니다. 어깨 42cm, 가슴단면 57cm, 총장 77cm의 L 사이즈입니다. 👔
  'info-brand-writing-style-basic-no-emoji',               // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질 소재로 유명한 미국 브랜드입니다. 미국 전통의 아메리칸 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보이고 있습니다.
  'info-brand-writing-style-basic-with-emoji',             // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질의 소재로 유명한, 미국을 대표하는 브랜드입니다. 미국 전통의 아메리칸 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보이고 있습니다.
  'info-brand-writing-style-emotional-no-emoji',           // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 전 세계적으로 많은 사랑을 받고 있습니다.
  'info-brand-writing-style-emotional-with-emoji',         // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 전 세계적으로 많은 사랑을 받고 있습니다.
  'info-brand-writing-style-nice-no-emoji',                // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질 소재로 유명한 미국 브랜드에요. 특히, 폴로 셔츠는 브랜드의 상징적인 아이템으로 전 세계적으로 많은 사랑받고 있답니다.
  'info-brand-writing-style-nice-with-emoji',              // 랄프로렌(RALPH LAUREN)은 클래식하면서도 세련된 디자인과 고품질 소재로 유명한 미국 브랜드에요. 특히, 폴로 셔츠는 브랜드의 상징적인 아이템으로 전 세계적으로 많은 사랑받고 있답니다.
  'info-brand-writing-style-simple-no-emoji',              // RALPH LAUREN, 미국 프리미엄 브랜드, 클래식하고 고급스러운 디자인, 높은 품질
  'info-brand-writing-style-simple-with-emoji',            // RALPH LAUREN, 미국 프리미엄 브랜드, 클래식하고 고급스러운 디자인, 높은 품질 👍
  'info-brand-writing-style-smart-no-emoji',               // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 패션 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 유명합니다. 미국 전통적인 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보입니다.
  'info-brand-writing-style-smart-with-emoji',             // 랄프로렌(RALPH LAUREN)은 미국을 대표하는 고급 패션 브랜드로, 클래식하면서도 세련된 디자인과 고품질의 소재로 유명합니다. 미국 전통적인 스타일을 현대적으로 재해석하여 다양한 의류 및 액세서리를 선보입니다.
  'info-detail-point-writing-style-basic-no-emoji',        // 셔츠 가슴 부분에 작은 포켓이 있으며, 전체적으로 얇고 촘촘한 스트라이프 패턴이 세련된 느낌을 더하고 있습니다. 소매 부분과 밑단 마감이 깔끔하게 처리되어 있습니다.
  'info-detail-point-writing-style-basic-with-emoji',      // 셔츠 가슴 부분에 작은 포켓이 있으며, 전체적으로 얇고 촘촘한 스트라이프 패턴이 세련된 느낌을 더하고 있습니다. 소매 부분과 밑단 마감이 깔끔하게 처리되어 있습니다. 👍
  'info-detail-point-writing-style-emotional-no-emoji',    // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감으로, 빈티지 특유의 매력이 더욱 돋보이는 아이템입니다. 또한, 왼쪽 가슴에 위치한 작은 포켓은 실용적이면서도 디자인적으로 포인트가 됩니다.
  'info-detail-point-writing-style-emotional-with-emoji',  // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감으로, 빈티지 특유의 매력이 더욱 돋보이는 아이템입니다. 또한, 왼쪽 가슴에 위치한 작은 포켓은 실용적이면서도 디자인적으로 포인트가 됩니다. 👍
  'info-detail-point-writing-style-nice-no-emoji',         // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감이 돋보여요. 또한, 가슴 부분에 작은 포켓이 있어 실용성까지 갖추었답니다.
  'info-detail-point-writing-style-nice-with-emoji',       // 섬세한 스트라이프 패턴과 깔끔한 봉제 마감이 돋보여요. 또한, 가슴 부분에 작은 포켓이 있어 실용성까지 갖추었답니다. 👍
  'info-detail-point-writing-style-simple-no-emoji',       // 스트라이프 패턴, 깔끔한 디자인, 왼쪽 가슴 포켓, 섬세한 봉제 마감
  'info-detail-point-writing-style-simple-with-emoji',     // 스트라이프 패턴, 깔끔한 디자인, 왼쪽 가슴 포켓, 섬세한 봉제 마감 ✨
  'info-detail-point-writing-style-smart-no-emoji',        // 전체적으로 얇은 스트라이프 패턴이 특징이며, 왼쪽 가슴에는 작은 포켓이 부착되어 있습니다. 셔츠의 밑단과 소매 부분은 깔끔하고 꼼꼼하게 마감 처리되어 있습니다.
  'info-detail-point-writing-style-smart-with-emoji',      // 전체적으로 얇은 스트라이프 패턴이 특징이며, 왼쪽 가슴에는 작은 포켓이 부착되어 있습니다. 셔츠의 밑단과 소매 부분은 깔끔하고 꼼꼼하게 마감 처리되어 있습니다. ✨
  'info-styling-tip-writing-style-basic-no-emoji',         // 청바지나 베이지 면바지와 캐주얼하게 코디하거나, 슬랙스와 착용하여 세미 포멀 느낌을 줄 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 팬츠나 액세서리를 매치하는 것이 좋습니다.
  'info-styling-tip-writing-style-basic-with-emoji',       // 청바지나 베이지 면바지와 캐주얼하게 코디하거나, 슬랙스와 착용하여 세미 포멀 느낌을 줄 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 팬츠나 액세서리를 매치하는 것이 좋습니다. 👔
  'info-styling-tip-writing-style-emotional-no-emoji',     // 청바지나 베이지 면바지와 함께 코디해, 캐주얼하고 세련된 미니멀 룩을 연출해보세요. 소매를 롤업하거나, 셔츠의 깃을 살짝 세우면 스타일리시함을 더할 수 있습니다.
  'info-styling-tip-writing-style-emotional-with-emoji',   // 청바지나 베이지 면바지와 함께 코디해, 캐주얼하고 세련된 미니멀 룩을 연출해보세요. 소매를 롤업하거나, 셔츠의 깃을 살짝 세우면 스타일리시함을 더할 수 있습니다. 👔
  'info-styling-tip-writing-style-nice-no-emoji',          // 청바지나 베이지 면바지와 함께 캐주얼하게 코디하거나, 슬랙스와 착용하여 댄디한 스타일을 연출해 보세요. 소매를 롤업해서 입으면 더욱 스타일리쉬해 보일 거예요.
  'info-styling-tip-writing-style-nice-with-emoji',        // 청바지나 베이지 면바지와 함께 캐주얼하게 코디하거나, 슬랙스와 착용하여 댄디한 스타일을 연출해 보세요. 소매를 롤업해서 입으면 더욱 스타일리쉬해 보일 거예요. 👔
  'info-styling-tip-writing-style-simple-no-emoji',        // 청바지나 베이지 팬츠와 코디, 캐주얼/댄디룩, 봄 가을 코디
  'info-styling-tip-writing-style-simple-with-emoji',      // 청바지나 베이지 팬츠와 코디, 캐주얼/댄디룩, 봄 가을 코디 🍂
  'info-styling-tip-writing-style-smart-no-emoji',         // 청바지나 베이지 면바지와 매치하여 캐주얼하면서도 깔끔한 스타일을 연출할 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 바지나 악세사리를 선택하는 것이 좋습니다.
  'info-styling-tip-writing-style-smart-with-emoji',       // 청바지나 베이지 면바지와 매치하여 캐주얼하면서도 깔끔한 스타일을 연출할 수 있습니다. 셔츠의 스트라이프 패턴을 고려하여 단색의 바지나 악세사리를 선택하는 것이 좋습니다. 👖
  'info-tpo-usage-writing-style-basic-no-emoji',           // 봄이나 가을철에 입기 좋은 셔츠입니다. 비즈니스 캐주얼 상황이나 데이트 등에서 깔끔하면서도 스타일리시하게 입기 좋습니다.
  'info-tpo-usage-writing-style-basic-with-emoji',         // 봄이나 가을철에 입기 좋은 셔츠입니다. 비즈니스 캐주얼 상황이나 데이트 등에서 깔끔하면서도 스타일리시하게 입기 좋습니다. ✨
  'info-tpo-usage-writing-style-emotional-no-emoji',       // 가을, 봄 시즌에 입기 좋으며, 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에서 편안하게 스타일링 할 수 있습니다.
  'info-tpo-usage-writing-style-emotional-with-emoji',     // 가을, 봄 시즌에 입기 좋으며, 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에서 편안하게 스타일링 할 수 있습니다. ✨
  'info-tpo-usage-writing-style-nice-no-emoji',            // 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에 깔끔하면서도 스타일리시하게 입을 수 있어요. 특히, 봄, 가을 시즌에 활용하기 좋답니다.
  'info-tpo-usage-writing-style-nice-with-emoji',          // 가벼운 미팅이나 데이트, 친구들과의 모임 등 다양한 상황에 깔끔하면서도 스타일리시하게 입을 수 있어요. 특히, 봄, 가을 시즌에 활용하기 좋답니다. ✨
  'info-tpo-usage-writing-style-simple-no-emoji',          // 캐주얼 데이트, 친구들과의 모임, 비즈니스 캐주얼, 캠퍼스룩
  'info-tpo-usage-writing-style-simple-with-emoji',        // 캐주얼 데이트, 친구들과의 모임, 비즈니스 캐주얼, 캠퍼스룩 👍
  'info-tpo-usage-writing-style-smart-no-emoji',           // 비즈니스 캐주얼 상황이나, 약간의 격식을 갖춰야 하는 자리에도 적합합니다. 세련된 디자인과 고급 소재로 깔끔한 인상을 줄 수 있습니다.
  'info-tpo-usage-writing-style-smart-with-emoji',         // 비즈니스 캐주얼 상황이나, 약간의 격식을 갖춰야 하는 자리에도 적합합니다. 세련된 디자인과 고급 소재로 깔끔한 인상을 줄 수 있습니다. 👍
] as const;

/**
 * ai-description - example Short 코드 타입.
 */
export type AclosetAiDescriptionExampleShortCode = (typeof ACLOSET_AI_DESCRIPTION_EXAMPLE_SHORT_CODE_LIST)[number];

/**
 * ai-description - example Short 코드 매핑.
 */
export const ACLOSET_AI_DESCRIPTION_EXAMPLE_SHORT_CODE_MAP: Readonly<Record<AclosetAiDescriptionExampleShortCode, AclosetAiDescriptionExampleCode>> = {
  'info-basic-writing-style-basic-no-emoji'             : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-BASIC-NO-EMOJI',
  'info-basic-writing-style-basic-with-emoji'           : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-BASIC-WITH-EMOJI',
  'info-basic-writing-style-emotional-no-emoji'         : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-EMOTIONAL-NO-EMOJI',
  'info-basic-writing-style-emotional-with-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',
  'info-basic-writing-style-nice-no-emoji'              : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-NICE-NO-EMOJI',
  'info-basic-writing-style-nice-with-emoji'            : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-NICE-WITH-EMOJI',
  'info-basic-writing-style-simple-no-emoji'            : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SIMPLE-NO-EMOJI',
  'info-basic-writing-style-simple-with-emoji'          : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SIMPLE-WITH-EMOJI',
  'info-basic-writing-style-smart-no-emoji'             : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SMART-NO-EMOJI',
  'info-basic-writing-style-smart-with-emoji'           : 'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SMART-WITH-EMOJI',
  'info-brand-writing-style-basic-no-emoji'             : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-BASIC-NO-EMOJI',
  'info-brand-writing-style-basic-with-emoji'           : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-BASIC-WITH-EMOJI',
  'info-brand-writing-style-emotional-no-emoji'         : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-EMOTIONAL-NO-EMOJI',
  'info-brand-writing-style-emotional-with-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',
  'info-brand-writing-style-nice-no-emoji'              : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-NICE-NO-EMOJI',
  'info-brand-writing-style-nice-with-emoji'            : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-NICE-WITH-EMOJI',
  'info-brand-writing-style-simple-no-emoji'            : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SIMPLE-NO-EMOJI',
  'info-brand-writing-style-simple-with-emoji'          : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SIMPLE-WITH-EMOJI',
  'info-brand-writing-style-smart-no-emoji'             : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SMART-NO-EMOJI',
  'info-brand-writing-style-smart-with-emoji'           : 'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SMART-WITH-EMOJI',
  'info-detail-point-writing-style-basic-no-emoji'      : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-BASIC-NO-EMOJI',
  'info-detail-point-writing-style-basic-with-emoji'    : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-BASIC-WITH-EMOJI',
  'info-detail-point-writing-style-emotional-no-emoji'  : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-EMOTIONAL-NO-EMOJI',
  'info-detail-point-writing-style-emotional-with-emoji': 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',
  'info-detail-point-writing-style-nice-no-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-NICE-NO-EMOJI',
  'info-detail-point-writing-style-nice-with-emoji'     : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-NICE-WITH-EMOJI',
  'info-detail-point-writing-style-simple-no-emoji'     : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SIMPLE-NO-EMOJI',
  'info-detail-point-writing-style-simple-with-emoji'   : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SIMPLE-WITH-EMOJI',
  'info-detail-point-writing-style-smart-no-emoji'      : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SMART-NO-EMOJI',
  'info-detail-point-writing-style-smart-with-emoji'    : 'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SMART-WITH-EMOJI',
  'info-styling-tip-writing-style-basic-no-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-BASIC-NO-EMOJI',
  'info-styling-tip-writing-style-basic-with-emoji'     : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-BASIC-WITH-EMOJI',
  'info-styling-tip-writing-style-emotional-no-emoji'   : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-EMOTIONAL-NO-EMOJI',
  'info-styling-tip-writing-style-emotional-with-emoji' : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',
  'info-styling-tip-writing-style-nice-no-emoji'        : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-NICE-NO-EMOJI',
  'info-styling-tip-writing-style-nice-with-emoji'      : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-NICE-WITH-EMOJI',
  'info-styling-tip-writing-style-simple-no-emoji'      : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SIMPLE-NO-EMOJI',
  'info-styling-tip-writing-style-simple-with-emoji'    : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SIMPLE-WITH-EMOJI',
  'info-styling-tip-writing-style-smart-no-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SMART-NO-EMOJI',
  'info-styling-tip-writing-style-smart-with-emoji'     : 'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SMART-WITH-EMOJI',
  'info-tpo-usage-writing-style-basic-no-emoji'         : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-BASIC-NO-EMOJI',
  'info-tpo-usage-writing-style-basic-with-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-BASIC-WITH-EMOJI',
  'info-tpo-usage-writing-style-emotional-no-emoji'     : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-EMOTIONAL-NO-EMOJI',
  'info-tpo-usage-writing-style-emotional-with-emoji'   : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-EMOTIONAL-WITH-EMOJI',
  'info-tpo-usage-writing-style-nice-no-emoji'          : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-NICE-NO-EMOJI',
  'info-tpo-usage-writing-style-nice-with-emoji'        : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-NICE-WITH-EMOJI',
  'info-tpo-usage-writing-style-simple-no-emoji'        : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SIMPLE-NO-EMOJI',
  'info-tpo-usage-writing-style-simple-with-emoji'      : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SIMPLE-WITH-EMOJI',
  'info-tpo-usage-writing-style-smart-no-emoji'         : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SMART-NO-EMOJI',
  'info-tpo-usage-writing-style-smart-with-emoji'       : 'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SMART-WITH-EMOJI',
};

/**
 * ai-description - example Short 코드 역매핑.
 */
export const ACLOSET_AI_DESCRIPTION_EXAMPLE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAiDescriptionExampleCode, AclosetAiDescriptionExampleShortCode>> = {
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-BASIC-NO-EMOJI'             : 'info-basic-writing-style-basic-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-BASIC-WITH-EMOJI'           : 'info-basic-writing-style-basic-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-EMOTIONAL-NO-EMOJI'         : 'info-basic-writing-style-emotional-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-EMOTIONAL-WITH-EMOJI'       : 'info-basic-writing-style-emotional-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-NICE-NO-EMOJI'              : 'info-basic-writing-style-nice-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-NICE-WITH-EMOJI'            : 'info-basic-writing-style-nice-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SIMPLE-NO-EMOJI'            : 'info-basic-writing-style-simple-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SIMPLE-WITH-EMOJI'          : 'info-basic-writing-style-simple-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SMART-NO-EMOJI'             : 'info-basic-writing-style-smart-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BASIC-WRITING-STYLE-SMART-WITH-EMOJI'           : 'info-basic-writing-style-smart-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-BASIC-NO-EMOJI'             : 'info-brand-writing-style-basic-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-BASIC-WITH-EMOJI'           : 'info-brand-writing-style-basic-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-EMOTIONAL-NO-EMOJI'         : 'info-brand-writing-style-emotional-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-EMOTIONAL-WITH-EMOJI'       : 'info-brand-writing-style-emotional-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-NICE-NO-EMOJI'              : 'info-brand-writing-style-nice-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-NICE-WITH-EMOJI'            : 'info-brand-writing-style-nice-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SIMPLE-NO-EMOJI'            : 'info-brand-writing-style-simple-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SIMPLE-WITH-EMOJI'          : 'info-brand-writing-style-simple-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SMART-NO-EMOJI'             : 'info-brand-writing-style-smart-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-BRAND-WRITING-STYLE-SMART-WITH-EMOJI'           : 'info-brand-writing-style-smart-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-BASIC-NO-EMOJI'      : 'info-detail-point-writing-style-basic-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-BASIC-WITH-EMOJI'    : 'info-detail-point-writing-style-basic-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-EMOTIONAL-NO-EMOJI'  : 'info-detail-point-writing-style-emotional-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-EMOTIONAL-WITH-EMOJI': 'info-detail-point-writing-style-emotional-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-NICE-NO-EMOJI'       : 'info-detail-point-writing-style-nice-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-NICE-WITH-EMOJI'     : 'info-detail-point-writing-style-nice-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SIMPLE-NO-EMOJI'     : 'info-detail-point-writing-style-simple-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SIMPLE-WITH-EMOJI'   : 'info-detail-point-writing-style-simple-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SMART-NO-EMOJI'      : 'info-detail-point-writing-style-smart-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-DETAIL-POINT-WRITING-STYLE-SMART-WITH-EMOJI'    : 'info-detail-point-writing-style-smart-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-BASIC-NO-EMOJI'       : 'info-styling-tip-writing-style-basic-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-BASIC-WITH-EMOJI'     : 'info-styling-tip-writing-style-basic-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-EMOTIONAL-NO-EMOJI'   : 'info-styling-tip-writing-style-emotional-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-EMOTIONAL-WITH-EMOJI' : 'info-styling-tip-writing-style-emotional-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-NICE-NO-EMOJI'        : 'info-styling-tip-writing-style-nice-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-NICE-WITH-EMOJI'      : 'info-styling-tip-writing-style-nice-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SIMPLE-NO-EMOJI'      : 'info-styling-tip-writing-style-simple-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SIMPLE-WITH-EMOJI'    : 'info-styling-tip-writing-style-simple-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SMART-NO-EMOJI'       : 'info-styling-tip-writing-style-smart-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-STYLING-TIP-WRITING-STYLE-SMART-WITH-EMOJI'     : 'info-styling-tip-writing-style-smart-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-BASIC-NO-EMOJI'         : 'info-tpo-usage-writing-style-basic-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-BASIC-WITH-EMOJI'       : 'info-tpo-usage-writing-style-basic-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-EMOTIONAL-NO-EMOJI'     : 'info-tpo-usage-writing-style-emotional-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-EMOTIONAL-WITH-EMOJI'   : 'info-tpo-usage-writing-style-emotional-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-NICE-NO-EMOJI'          : 'info-tpo-usage-writing-style-nice-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-NICE-WITH-EMOJI'        : 'info-tpo-usage-writing-style-nice-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SIMPLE-NO-EMOJI'        : 'info-tpo-usage-writing-style-simple-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SIMPLE-WITH-EMOJI'      : 'info-tpo-usage-writing-style-simple-with-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SMART-NO-EMOJI'         : 'info-tpo-usage-writing-style-smart-no-emoji',
  'AI-DESCRIPTION_EXAMPLE_INFO-TPO-USAGE-WRITING-STYLE-SMART-WITH-EMOJI'       : 'info-tpo-usage-writing-style-smart-with-emoji',
};

// ************************************************************************************************

/**
 * ai-description - emoji 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_EMOJI_CODE_LIST = [
  'AI-DESCRIPTION_EMOJI_FACIAL',  // 사람과 표정 (😀, 😃, 😄, 😆, 🥰, 😍, 🤩, 😘)
  'AI-DESCRIPTION_EMOJI_HEART',   // 하트 (💘, 💝, 💛, ❣️, ❤️‍🔥, 💞)
  'AI-DESCRIPTION_EMOJI_NATURE',  // 장소와 자연 (🏖, 🏕, 🌸, 🌱, 🍂, 🌷, ⛅, ☃️, ⭐️, ✨)
  'AI-DESCRIPTION_EMOJI_THINGS',  // 사물과 물체 (🎀, 🕶️, 👕, 👚, 💎)
] as const;

/**
 * ai-description - emoji 타입.
 */
export type AclosetAiDescriptionEmojiCode = (typeof ACLOSET_AI_DESCRIPTION_EMOJI_CODE_LIST)[number];

/**
 * ai-description - emoji Short 코드 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_EMOJI_SHORT_CODE_LIST = [
  'facial',  // 사람과 표정 (😀, 😃, 😄, 😆, 🥰, 😍, 🤩, 😘)
  'heart',   // 하트 (💘, 💝, 💛, ❣️, ❤️‍🔥, 💞)
  'nature',  // 장소와 자연 (🏖, 🏕, 🌸, 🌱, 🍂, 🌷, ⛅, ☃️, ⭐️, ✨)
  'things',  // 사물과 물체 (🎀, 🕶️, 👕, 👚, 💎)
] as const;

/**
 * ai-description - emoji Short 코드 타입.
 */
export type AclosetAiDescriptionEmojiShortCode = (typeof ACLOSET_AI_DESCRIPTION_EMOJI_SHORT_CODE_LIST)[number];

/**
 * ai-description - emoji Short 코드 매핑.
 */
export const ACLOSET_AI_DESCRIPTION_EMOJI_SHORT_CODE_MAP: Readonly<Record<AclosetAiDescriptionEmojiShortCode, AclosetAiDescriptionEmojiCode>> = {
  'facial': 'AI-DESCRIPTION_EMOJI_FACIAL',
  'heart' : 'AI-DESCRIPTION_EMOJI_HEART',
  'nature': 'AI-DESCRIPTION_EMOJI_NATURE',
  'things': 'AI-DESCRIPTION_EMOJI_THINGS',
};

/**
 * ai-description - emoji Short 코드 역매핑.
 */
export const ACLOSET_AI_DESCRIPTION_EMOJI_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAiDescriptionEmojiCode, AclosetAiDescriptionEmojiShortCode>> = {
  'AI-DESCRIPTION_EMOJI_FACIAL': 'facial',
  'AI-DESCRIPTION_EMOJI_HEART' : 'heart',
  'AI-DESCRIPTION_EMOJI_NATURE': 'nature',
  'AI-DESCRIPTION_EMOJI_THINGS': 'things',
};

// ************************************************************************************************

/**
 * ai-description - bullet-point-type 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_BULLET_POINT_TYPE_CODE_LIST = [
  'AI-DESCRIPTION_BULLET-POINT-TYPE_BASIC',    // 기본
  'AI-DESCRIPTION_BULLET-POINT-TYPE_CHECKED',  // 체크
  'AI-DESCRIPTION_BULLET-POINT-TYPE_CUSTOM',   // 커스텀
  'AI-DESCRIPTION_BULLET-POINT-TYPE_SQUARE',   // 사각형
] as const;

/**
 * ai-description - bullet-point-type 타입.
 */
export type AclosetAiDescriptionBulletPointTypeCode = (typeof ACLOSET_AI_DESCRIPTION_BULLET_POINT_TYPE_CODE_LIST)[number];

/**
 * ai-description - bullet-point-type Short 코드 리스트.
 */
export const ACLOSET_AI_DESCRIPTION_BULLET_POINT_TYPE_SHORT_CODE_LIST = [
  'basic',    // 기본
  'checked',  // 체크
  'custom',   // 커스텀
  'square',   // 사각형
] as const;

/**
 * ai-description - bullet-point-type Short 코드 타입.
 */
export type AclosetAiDescriptionBulletPointTypeShortCode = (typeof ACLOSET_AI_DESCRIPTION_BULLET_POINT_TYPE_SHORT_CODE_LIST)[number];

/**
 * ai-description - bullet-point-type Short 코드 매핑.
 */
export const ACLOSET_AI_DESCRIPTION_BULLET_POINT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetAiDescriptionBulletPointTypeShortCode, AclosetAiDescriptionBulletPointTypeCode>> = {
  'basic'  : 'AI-DESCRIPTION_BULLET-POINT-TYPE_BASIC',
  'checked': 'AI-DESCRIPTION_BULLET-POINT-TYPE_CHECKED',
  'custom' : 'AI-DESCRIPTION_BULLET-POINT-TYPE_CUSTOM',
  'square' : 'AI-DESCRIPTION_BULLET-POINT-TYPE_SQUARE',
};

/**
 * ai-description - bullet-point-type Short 코드 역매핑.
 */
export const ACLOSET_AI_DESCRIPTION_BULLET_POINT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAiDescriptionBulletPointTypeCode, AclosetAiDescriptionBulletPointTypeShortCode>> = {
  'AI-DESCRIPTION_BULLET-POINT-TYPE_BASIC'  : 'basic',
  'AI-DESCRIPTION_BULLET-POINT-TYPE_CHECKED': 'checked',
  'AI-DESCRIPTION_BULLET-POINT-TYPE_CUSTOM' : 'custom',
  'AI-DESCRIPTION_BULLET-POINT-TYPE_SQUARE' : 'square',
};

// ************************************************************************************************

/**
 * app - notice-status 리스트.
 */
export const ACLOSET_APP_NOTICE_STATUS_CODE_LIST = [
  'APP_NOTICE-STATUS_CLOSE',  // 공지사항 게시 해제됨
  'APP_NOTICE-STATUS_OPEN',   // 공지사항 게시중
] as const;

/**
 * app - notice-status 타입.
 */
export type AclosetAppNoticeStatusCode = (typeof ACLOSET_APP_NOTICE_STATUS_CODE_LIST)[number];

/**
 * app - notice-status Short 코드 리스트.
 */
export const ACLOSET_APP_NOTICE_STATUS_SHORT_CODE_LIST = [
  'close',  // 공지사항 게시 해제됨
  'open',   // 공지사항 게시중
] as const;

/**
 * app - notice-status Short 코드 타입.
 */
export type AclosetAppNoticeStatusShortCode = (typeof ACLOSET_APP_NOTICE_STATUS_SHORT_CODE_LIST)[number];

/**
 * app - notice-status Short 코드 매핑.
 */
export const ACLOSET_APP_NOTICE_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetAppNoticeStatusShortCode, AclosetAppNoticeStatusCode>> = {
  'close': 'APP_NOTICE-STATUS_CLOSE',
  'open' : 'APP_NOTICE-STATUS_OPEN',
};

/**
 * app - notice-status Short 코드 역매핑.
 */
export const ACLOSET_APP_NOTICE_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetAppNoticeStatusCode, AclosetAppNoticeStatusShortCode>> = {
  'APP_NOTICE-STATUS_CLOSE': 'close',
  'APP_NOTICE-STATUS_OPEN' : 'open',
};

// ************************************************************************************************

/**
 * bunjang - status 리스트.
 */
export const ACLOSET_BUNJANG_STATUS_CODE_LIST = [
  'BUNJANG_STATUS_BEFORE-SIGNUP',      // 계정 생성 전
  'BUNJANG_STATUS_INVITE-SUCCESS',     // 입점 완료
  'BUNJANG_STATUS_LOAD-ITEM-SUCCESS',  // 상품 불러오기 완료
  'BUNJANG_STATUS_ORDER-SUCCESS',      // 주문 발생
  'BUNJANG_STATUS_SETTING-SUCCESS',    // 계정 설정 완료
  'BUNJANG_STATUS_SIGNUP-SUCCESS',     // 계정 생성 완료
] as const;

/**
 * bunjang - status 타입.
 */
export type AclosetBunjangStatusCode = (typeof ACLOSET_BUNJANG_STATUS_CODE_LIST)[number];

/**
 * bunjang - status Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_STATUS_SHORT_CODE_LIST = [
  'before-signup',      // 계정 생성 전
  'invite-success',     // 입점 완료
  'load-item-success',  // 상품 불러오기 완료
  'order-success',      // 주문 발생
  'setting-success',    // 계정 설정 완료
  'signup-success',     // 계정 생성 완료
] as const;

/**
 * bunjang - status Short 코드 타입.
 */
export type AclosetBunjangStatusShortCode = (typeof ACLOSET_BUNJANG_STATUS_SHORT_CODE_LIST)[number];

/**
 * bunjang - status Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangStatusShortCode, AclosetBunjangStatusCode>> = {
  'before-signup'    : 'BUNJANG_STATUS_BEFORE-SIGNUP',
  'invite-success'   : 'BUNJANG_STATUS_INVITE-SUCCESS',
  'load-item-success': 'BUNJANG_STATUS_LOAD-ITEM-SUCCESS',
  'order-success'    : 'BUNJANG_STATUS_ORDER-SUCCESS',
  'setting-success'  : 'BUNJANG_STATUS_SETTING-SUCCESS',
  'signup-success'   : 'BUNJANG_STATUS_SIGNUP-SUCCESS',
};

/**
 * bunjang - status Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangStatusCode, AclosetBunjangStatusShortCode>> = {
  'BUNJANG_STATUS_BEFORE-SIGNUP'    : 'before-signup',
  'BUNJANG_STATUS_INVITE-SUCCESS'   : 'invite-success',
  'BUNJANG_STATUS_LOAD-ITEM-SUCCESS': 'load-item-success',
  'BUNJANG_STATUS_ORDER-SUCCESS'    : 'order-success',
  'BUNJANG_STATUS_SETTING-SUCCESS'  : 'setting-success',
  'BUNJANG_STATUS_SIGNUP-SUCCESS'   : 'signup-success',
};

// ************************************************************************************************

/**
 * bunjang - shop-load-status 리스트.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_STATUS_CODE_LIST = [
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-EXCLUDED',  // 불러오기 제외
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-FAILED',    // 불러오기 실패
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-PAUSED',    // 불러오기 일시 중지
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-SUCCESS',   // 불러오기 완료
  'BUNJANG_SHOP-LOAD-STATUS_LOADING',        // 불러오기 진행 중
] as const;

/**
 * bunjang - shop-load-status 타입.
 */
export type AclosetBunjangShopLoadStatusCode = (typeof ACLOSET_BUNJANG_SHOP_LOAD_STATUS_CODE_LIST)[number];

/**
 * bunjang - shop-load-status Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_STATUS_SHORT_CODE_LIST = [
  'load-excluded',  // 불러오기 제외
  'load-failed',    // 불러오기 실패
  'load-paused',    // 불러오기 일시 중지
  'load-success',   // 불러오기 완료
  'loading',        // 불러오기 진행 중
] as const;

/**
 * bunjang - shop-load-status Short 코드 타입.
 */
export type AclosetBunjangShopLoadStatusShortCode = (typeof ACLOSET_BUNJANG_SHOP_LOAD_STATUS_SHORT_CODE_LIST)[number];

/**
 * bunjang - shop-load-status Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangShopLoadStatusShortCode, AclosetBunjangShopLoadStatusCode>> = {
  'load-excluded': 'BUNJANG_SHOP-LOAD-STATUS_LOAD-EXCLUDED',
  'load-failed'  : 'BUNJANG_SHOP-LOAD-STATUS_LOAD-FAILED',
  'load-paused'  : 'BUNJANG_SHOP-LOAD-STATUS_LOAD-PAUSED',
  'load-success' : 'BUNJANG_SHOP-LOAD-STATUS_LOAD-SUCCESS',
  'loading'      : 'BUNJANG_SHOP-LOAD-STATUS_LOADING',
};

/**
 * bunjang - shop-load-status Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangShopLoadStatusCode, AclosetBunjangShopLoadStatusShortCode>> = {
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-EXCLUDED': 'load-excluded',
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-FAILED'  : 'load-failed',
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-PAUSED'  : 'load-paused',
  'BUNJANG_SHOP-LOAD-STATUS_LOAD-SUCCESS' : 'load-success',
  'BUNJANG_SHOP-LOAD-STATUS_LOADING'      : 'loading',
};

// ************************************************************************************************

/**
 * bunjang - shop-load-search-type 리스트.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_SEARCH_TYPE_CODE_LIST = [
  'BUNJANG_SHOP-LOAD-SEARCH-TYPE_CONTAIN',  // 포함
  'BUNJANG_SHOP-LOAD-SEARCH-TYPE_EXACT',    // 정확히 일치
] as const;

/**
 * bunjang - shop-load-search-type 타입.
 */
export type AclosetBunjangShopLoadSearchTypeCode = (typeof ACLOSET_BUNJANG_SHOP_LOAD_SEARCH_TYPE_CODE_LIST)[number];

/**
 * bunjang - shop-load-search-type Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_SEARCH_TYPE_SHORT_CODE_LIST = [
  'contain',  // 포함
  'exact',    // 정확히 일치
] as const;

/**
 * bunjang - shop-load-search-type Short 코드 타입.
 */
export type AclosetBunjangShopLoadSearchTypeShortCode = (typeof ACLOSET_BUNJANG_SHOP_LOAD_SEARCH_TYPE_SHORT_CODE_LIST)[number];

/**
 * bunjang - shop-load-search-type Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_SEARCH_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangShopLoadSearchTypeShortCode, AclosetBunjangShopLoadSearchTypeCode>> = {
  'contain': 'BUNJANG_SHOP-LOAD-SEARCH-TYPE_CONTAIN',
  'exact'  : 'BUNJANG_SHOP-LOAD-SEARCH-TYPE_EXACT',
};

/**
 * bunjang - shop-load-search-type Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_SHOP_LOAD_SEARCH_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangShopLoadSearchTypeCode, AclosetBunjangShopLoadSearchTypeShortCode>> = {
  'BUNJANG_SHOP-LOAD-SEARCH-TYPE_CONTAIN': 'contain',
  'BUNJANG_SHOP-LOAD-SEARCH-TYPE_EXACT'  : 'exact',
};

// ************************************************************************************************

/**
 * bunjang - load-status 리스트.
 */
export const ACLOSET_BUNJANG_LOAD_STATUS_CODE_LIST = [
  'BUNJANG_LOAD-STATUS_FAIL',         // 상품 불러오기 실패
  'BUNJANG_LOAD-STATUS_IDLE',         // 상품 불러오기 대기
  'BUNJANG_LOAD-STATUS_IN-PROGRESS',  // 상품 불러오기 진행중
] as const;

/**
 * bunjang - load-status 타입.
 */
export type AclosetBunjangLoadStatusCode = (typeof ACLOSET_BUNJANG_LOAD_STATUS_CODE_LIST)[number];

/**
 * bunjang - load-status Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_LOAD_STATUS_SHORT_CODE_LIST = [
  'fail',         // 상품 불러오기 실패
  'idle',         // 상품 불러오기 대기
  'in-progress',  // 상품 불러오기 진행중
] as const;

/**
 * bunjang - load-status Short 코드 타입.
 */
export type AclosetBunjangLoadStatusShortCode = (typeof ACLOSET_BUNJANG_LOAD_STATUS_SHORT_CODE_LIST)[number];

/**
 * bunjang - load-status Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_LOAD_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangLoadStatusShortCode, AclosetBunjangLoadStatusCode>> = {
  'fail'       : 'BUNJANG_LOAD-STATUS_FAIL',
  'idle'       : 'BUNJANG_LOAD-STATUS_IDLE',
  'in-progress': 'BUNJANG_LOAD-STATUS_IN-PROGRESS',
};

/**
 * bunjang - load-status Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_LOAD_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangLoadStatusCode, AclosetBunjangLoadStatusShortCode>> = {
  'BUNJANG_LOAD-STATUS_FAIL'       : 'fail',
  'BUNJANG_LOAD-STATUS_IDLE'       : 'idle',
  'BUNJANG_LOAD-STATUS_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * bunjang - load-duration 리스트.
 */
export const ACLOSET_BUNJANG_LOAD_DURATION_CODE_LIST = [
  'BUNJANG_LOAD-DURATION_ONE-MONTH',   // 1개월
  'BUNJANG_LOAD-DURATION_ONE-WEEK',    // 1주일
  'BUNJANG_LOAD-DURATION_ONE-YEAR',    // 1년
  'BUNJANG_LOAD-DURATION_SIX-MONTH',   // 6개월
  'BUNJANG_LOAD-DURATION_THREE-WEEK',  // 3주일
  'BUNJANG_LOAD-DURATION_TWO-MONTH',   // 2개월
  'BUNJANG_LOAD-DURATION_TWO-WEEK',    // 2주일
  'BUNJANG_LOAD-DURATION_TWO-YEAR',    // 2년
] as const;

/**
 * bunjang - load-duration 타입.
 */
export type AclosetBunjangLoadDurationCode = (typeof ACLOSET_BUNJANG_LOAD_DURATION_CODE_LIST)[number];

/**
 * bunjang - load-duration Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_LOAD_DURATION_SHORT_CODE_LIST = [
  'one-month',   // 1개월
  'one-week',    // 1주일
  'one-year',    // 1년
  'six-month',   // 6개월
  'three-week',  // 3주일
  'two-month',   // 2개월
  'two-week',    // 2주일
  'two-year',    // 2년
] as const;

/**
 * bunjang - load-duration Short 코드 타입.
 */
export type AclosetBunjangLoadDurationShortCode = (typeof ACLOSET_BUNJANG_LOAD_DURATION_SHORT_CODE_LIST)[number];

/**
 * bunjang - load-duration Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_LOAD_DURATION_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangLoadDurationShortCode, AclosetBunjangLoadDurationCode>> = {
  'one-month' : 'BUNJANG_LOAD-DURATION_ONE-MONTH',
  'one-week'  : 'BUNJANG_LOAD-DURATION_ONE-WEEK',
  'one-year'  : 'BUNJANG_LOAD-DURATION_ONE-YEAR',
  'six-month' : 'BUNJANG_LOAD-DURATION_SIX-MONTH',
  'three-week': 'BUNJANG_LOAD-DURATION_THREE-WEEK',
  'two-month' : 'BUNJANG_LOAD-DURATION_TWO-MONTH',
  'two-week'  : 'BUNJANG_LOAD-DURATION_TWO-WEEK',
  'two-year'  : 'BUNJANG_LOAD-DURATION_TWO-YEAR',
};

/**
 * bunjang - load-duration Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_LOAD_DURATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangLoadDurationCode, AclosetBunjangLoadDurationShortCode>> = {
  'BUNJANG_LOAD-DURATION_ONE-MONTH' : 'one-month',
  'BUNJANG_LOAD-DURATION_ONE-WEEK'  : 'one-week',
  'BUNJANG_LOAD-DURATION_ONE-YEAR'  : 'one-year',
  'BUNJANG_LOAD-DURATION_SIX-MONTH' : 'six-month',
  'BUNJANG_LOAD-DURATION_THREE-WEEK': 'three-week',
  'BUNJANG_LOAD-DURATION_TWO-MONTH' : 'two-month',
  'BUNJANG_LOAD-DURATION_TWO-WEEK'  : 'two-week',
  'BUNJANG_LOAD-DURATION_TWO-YEAR'  : 'two-year',
};

// ************************************************************************************************

/**
 * bunjang - kakaotalk-status 리스트.
 */
export const ACLOSET_BUNJANG_KAKAOTALK_STATUS_CODE_LIST = [
  'BUNJANG_KAKAOTALK-STATUS_AFTER-SEND',   // 발송 완료
  'BUNJANG_KAKAOTALK-STATUS_BEFORE-SEND',  // 발송 전
] as const;

/**
 * bunjang - kakaotalk-status 타입.
 */
export type AclosetBunjangKakaotalkStatusCode = (typeof ACLOSET_BUNJANG_KAKAOTALK_STATUS_CODE_LIST)[number];

/**
 * bunjang - kakaotalk-status Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_KAKAOTALK_STATUS_SHORT_CODE_LIST = [
  'after-send',   // 발송 완료
  'before-send',  // 발송 전
] as const;

/**
 * bunjang - kakaotalk-status Short 코드 타입.
 */
export type AclosetBunjangKakaotalkStatusShortCode = (typeof ACLOSET_BUNJANG_KAKAOTALK_STATUS_SHORT_CODE_LIST)[number];

/**
 * bunjang - kakaotalk-status Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_KAKAOTALK_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangKakaotalkStatusShortCode, AclosetBunjangKakaotalkStatusCode>> = {
  'after-send' : 'BUNJANG_KAKAOTALK-STATUS_AFTER-SEND',
  'before-send': 'BUNJANG_KAKAOTALK-STATUS_BEFORE-SEND',
};

/**
 * bunjang - kakaotalk-status Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_KAKAOTALK_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangKakaotalkStatusCode, AclosetBunjangKakaotalkStatusShortCode>> = {
  'BUNJANG_KAKAOTALK-STATUS_AFTER-SEND' : 'after-send',
  'BUNJANG_KAKAOTALK-STATUS_BEFORE-SEND': 'before-send',
};

// ************************************************************************************************

/**
 * bunjang - customer-history-summary 리스트.
 */
export const ACLOSET_BUNJANG_CUSTOMER_HISTORY_SUMMARY_CODE_LIST = [
  'BUNJANG_CUSTOMER-HISTORY-SUMMARY_ENTRY-COMPLETE',  // 약관동의(입점완료)
  'BUNJANG_CUSTOMER-HISTORY-SUMMARY_SEND-KAKAOTALK',  // 알림톡 발송
] as const;

/**
 * bunjang - customer-history-summary 타입.
 */
export type AclosetBunjangCustomerHistorySummaryCode = (typeof ACLOSET_BUNJANG_CUSTOMER_HISTORY_SUMMARY_CODE_LIST)[number];

/**
 * bunjang - customer-history-summary Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_CUSTOMER_HISTORY_SUMMARY_SHORT_CODE_LIST = [
  'entry-complete',  // 약관동의(입점완료)
  'send-kakaotalk',  // 알림톡 발송
] as const;

/**
 * bunjang - customer-history-summary Short 코드 타입.
 */
export type AclosetBunjangCustomerHistorySummaryShortCode = (typeof ACLOSET_BUNJANG_CUSTOMER_HISTORY_SUMMARY_SHORT_CODE_LIST)[number];

/**
 * bunjang - customer-history-summary Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_CUSTOMER_HISTORY_SUMMARY_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangCustomerHistorySummaryShortCode, AclosetBunjangCustomerHistorySummaryCode>> = {
  'entry-complete': 'BUNJANG_CUSTOMER-HISTORY-SUMMARY_ENTRY-COMPLETE',
  'send-kakaotalk': 'BUNJANG_CUSTOMER-HISTORY-SUMMARY_SEND-KAKAOTALK',
};

/**
 * bunjang - customer-history-summary Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_CUSTOMER_HISTORY_SUMMARY_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangCustomerHistorySummaryCode, AclosetBunjangCustomerHistorySummaryShortCode>> = {
  'BUNJANG_CUSTOMER-HISTORY-SUMMARY_ENTRY-COMPLETE': 'entry-complete',
  'BUNJANG_CUSTOMER-HISTORY-SUMMARY_SEND-KAKAOTALK': 'send-kakaotalk',
};

// ************************************************************************************************

/**
 * bunjang - business-status 리스트.
 */
export const ACLOSET_BUNJANG_BUSINESS_STATUS_CODE_LIST = [
  'BUNJANG_BUSINESS-STATUS_EXCLUDED',       // 영업 제외
  'BUNJANG_BUSINESS-STATUS_NOT_CONFIRMED',  // 미확인
  'BUNJANG_BUSINESS-STATUS_PENDING',        // 보류
  'BUNJANG_BUSINESS-STATUS_STARTED',        // 영업 시작
] as const;

/**
 * bunjang - business-status 타입.
 */
export type AclosetBunjangBusinessStatusCode = (typeof ACLOSET_BUNJANG_BUSINESS_STATUS_CODE_LIST)[number];

/**
 * bunjang - business-status Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_BUSINESS_STATUS_SHORT_CODE_LIST = [
  'excluded',       // 영업 제외
  'not_confirmed',  // 미확인
  'pending',        // 보류
  'started',        // 영업 시작
] as const;

/**
 * bunjang - business-status Short 코드 타입.
 */
export type AclosetBunjangBusinessStatusShortCode = (typeof ACLOSET_BUNJANG_BUSINESS_STATUS_SHORT_CODE_LIST)[number];

/**
 * bunjang - business-status Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_BUSINESS_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangBusinessStatusShortCode, AclosetBunjangBusinessStatusCode>> = {
  'excluded'     : 'BUNJANG_BUSINESS-STATUS_EXCLUDED',
  'not_confirmed': 'BUNJANG_BUSINESS-STATUS_NOT_CONFIRMED',
  'pending'      : 'BUNJANG_BUSINESS-STATUS_PENDING',
  'started'      : 'BUNJANG_BUSINESS-STATUS_STARTED',
};

/**
 * bunjang - business-status Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_BUSINESS_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangBusinessStatusCode, AclosetBunjangBusinessStatusShortCode>> = {
  'BUNJANG_BUSINESS-STATUS_EXCLUDED'     : 'excluded',
  'BUNJANG_BUSINESS-STATUS_NOT_CONFIRMED': 'not_confirmed',
  'BUNJANG_BUSINESS-STATUS_PENDING'      : 'pending',
  'BUNJANG_BUSINESS-STATUS_STARTED'      : 'started',
};

// ************************************************************************************************

/**
 * bunjang - account-setting-type 리스트.
 */
export const ACLOSET_BUNJANG_ACCOUNT_SETTING_TYPE_CODE_LIST = [
  'BUNJANG_ACCOUNT-SETTING-TYPE_BUSINESS',   // 사업자 정보 입력
  'BUNJANG_ACCOUNT-SETTING-TYPE_SETTLMENT',  // 정산 정보 입력
  'BUNJANG_ACCOUNT-SETTING-TYPE_SHIPPING',   // 배송 ∙ 반품 정보 입력
  'BUNJANG_ACCOUNT-SETTING-TYPE_SHOP',       // 샵정보/프로필 설정
] as const;

/**
 * bunjang - account-setting-type 타입.
 */
export type AclosetBunjangAccountSettingTypeCode = (typeof ACLOSET_BUNJANG_ACCOUNT_SETTING_TYPE_CODE_LIST)[number];

/**
 * bunjang - account-setting-type Short 코드 리스트.
 */
export const ACLOSET_BUNJANG_ACCOUNT_SETTING_TYPE_SHORT_CODE_LIST = [
  'business',   // 사업자 정보 입력
  'settlment',  // 정산 정보 입력
  'shipping',   // 배송 ∙ 반품 정보 입력
  'shop',       // 샵정보/프로필 설정
] as const;

/**
 * bunjang - account-setting-type Short 코드 타입.
 */
export type AclosetBunjangAccountSettingTypeShortCode = (typeof ACLOSET_BUNJANG_ACCOUNT_SETTING_TYPE_SHORT_CODE_LIST)[number];

/**
 * bunjang - account-setting-type Short 코드 매핑.
 */
export const ACLOSET_BUNJANG_ACCOUNT_SETTING_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetBunjangAccountSettingTypeShortCode, AclosetBunjangAccountSettingTypeCode>> = {
  'business' : 'BUNJANG_ACCOUNT-SETTING-TYPE_BUSINESS',
  'settlment': 'BUNJANG_ACCOUNT-SETTING-TYPE_SETTLMENT',
  'shipping' : 'BUNJANG_ACCOUNT-SETTING-TYPE_SHIPPING',
  'shop'     : 'BUNJANG_ACCOUNT-SETTING-TYPE_SHOP',
};

/**
 * bunjang - account-setting-type Short 코드 역매핑.
 */
export const ACLOSET_BUNJANG_ACCOUNT_SETTING_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetBunjangAccountSettingTypeCode, AclosetBunjangAccountSettingTypeShortCode>> = {
  'BUNJANG_ACCOUNT-SETTING-TYPE_BUSINESS' : 'business',
  'BUNJANG_ACCOUNT-SETTING-TYPE_SETTLMENT': 'settlment',
  'BUNJANG_ACCOUNT-SETTING-TYPE_SHIPPING' : 'shipping',
  'BUNJANG_ACCOUNT-SETTING-TYPE_SHOP'     : 'shop',
};

// ************************************************************************************************

/**
 * cafe24 - load-status 리스트.
 */
export const ACLOSET_CAFE_24_LOAD_STATUS_CODE_LIST = [
  'CAFE24_LOAD-STATUS_FAIL',         // 실패
  'CAFE24_LOAD-STATUS_IDLE',         // 대기
  'CAFE24_LOAD-STATUS_IN-PROGRESS',  // 진행중
] as const;

/**
 * cafe24 - load-status 타입.
 */
export type AclosetCafe24LoadStatusCode = (typeof ACLOSET_CAFE_24_LOAD_STATUS_CODE_LIST)[number];

/**
 * cafe24 - load-status Short 코드 리스트.
 */
export const ACLOSET_CAFE_24_LOAD_STATUS_SHORT_CODE_LIST = [
  'fail',         // 실패
  'idle',         // 대기
  'in-progress',  // 진행중
] as const;

/**
 * cafe24 - load-status Short 코드 타입.
 */
export type AclosetCafe24LoadStatusShortCode = (typeof ACLOSET_CAFE_24_LOAD_STATUS_SHORT_CODE_LIST)[number];

/**
 * cafe24 - load-status Short 코드 매핑.
 */
export const ACLOSET_CAFE_24_LOAD_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetCafe24LoadStatusShortCode, AclosetCafe24LoadStatusCode>> = {
  'fail'       : 'CAFE24_LOAD-STATUS_FAIL',
  'idle'       : 'CAFE24_LOAD-STATUS_IDLE',
  'in-progress': 'CAFE24_LOAD-STATUS_IN-PROGRESS',
};

/**
 * cafe24 - load-status Short 코드 역매핑.
 */
export const ACLOSET_CAFE_24_LOAD_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetCafe24LoadStatusCode, AclosetCafe24LoadStatusShortCode>> = {
  'CAFE24_LOAD-STATUS_FAIL'       : 'fail',
  'CAFE24_LOAD-STATUS_IDLE'       : 'idle',
  'CAFE24_LOAD-STATUS_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * cafe24 - load-duration 리스트.
 */
export const ACLOSET_CAFE_24_LOAD_DURATION_CODE_LIST = [
  'CAFE24_LOAD-DURATION_ONE-MONTH',   // 1개월
  'CAFE24_LOAD-DURATION_ONE-WEEK',    // 1주일
  'CAFE24_LOAD-DURATION_ONE-YEAR',    // 1년
  'CAFE24_LOAD-DURATION_SIX-MONTH',   // 6개월
  'CAFE24_LOAD-DURATION_THREE-WEEK',  // 3주일
  'CAFE24_LOAD-DURATION_THREE-YEAR',  // 3년
  'CAFE24_LOAD-DURATION_TWO-MONTH',   // 2개월
  'CAFE24_LOAD-DURATION_TWO-WEEK',    // 2주일
  'CAFE24_LOAD-DURATION_TWO-YEAR',    // 2년
] as const;

/**
 * cafe24 - load-duration 타입.
 */
export type AclosetCafe24LoadDurationCode = (typeof ACLOSET_CAFE_24_LOAD_DURATION_CODE_LIST)[number];

/**
 * cafe24 - load-duration Short 코드 리스트.
 */
export const ACLOSET_CAFE_24_LOAD_DURATION_SHORT_CODE_LIST = [
  'one-month',   // 1개월
  'one-week',    // 1주일
  'one-year',    // 1년
  'six-month',   // 6개월
  'three-week',  // 3주일
  'three-year',  // 3년
  'two-month',   // 2개월
  'two-week',    // 2주일
  'two-year',    // 2년
] as const;

/**
 * cafe24 - load-duration Short 코드 타입.
 */
export type AclosetCafe24LoadDurationShortCode = (typeof ACLOSET_CAFE_24_LOAD_DURATION_SHORT_CODE_LIST)[number];

/**
 * cafe24 - load-duration Short 코드 매핑.
 */
export const ACLOSET_CAFE_24_LOAD_DURATION_SHORT_CODE_MAP: Readonly<Record<AclosetCafe24LoadDurationShortCode, AclosetCafe24LoadDurationCode>> = {
  'one-month' : 'CAFE24_LOAD-DURATION_ONE-MONTH',
  'one-week'  : 'CAFE24_LOAD-DURATION_ONE-WEEK',
  'one-year'  : 'CAFE24_LOAD-DURATION_ONE-YEAR',
  'six-month' : 'CAFE24_LOAD-DURATION_SIX-MONTH',
  'three-week': 'CAFE24_LOAD-DURATION_THREE-WEEK',
  'three-year': 'CAFE24_LOAD-DURATION_THREE-YEAR',
  'two-month' : 'CAFE24_LOAD-DURATION_TWO-MONTH',
  'two-week'  : 'CAFE24_LOAD-DURATION_TWO-WEEK',
  'two-year'  : 'CAFE24_LOAD-DURATION_TWO-YEAR',
};

/**
 * cafe24 - load-duration Short 코드 역매핑.
 */
export const ACLOSET_CAFE_24_LOAD_DURATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetCafe24LoadDurationCode, AclosetCafe24LoadDurationShortCode>> = {
  'CAFE24_LOAD-DURATION_ONE-MONTH' : 'one-month',
  'CAFE24_LOAD-DURATION_ONE-WEEK'  : 'one-week',
  'CAFE24_LOAD-DURATION_ONE-YEAR'  : 'one-year',
  'CAFE24_LOAD-DURATION_SIX-MONTH' : 'six-month',
  'CAFE24_LOAD-DURATION_THREE-WEEK': 'three-week',
  'CAFE24_LOAD-DURATION_THREE-YEAR': 'three-year',
  'CAFE24_LOAD-DURATION_TWO-MONTH' : 'two-month',
  'CAFE24_LOAD-DURATION_TWO-WEEK'  : 'two-week',
  'CAFE24_LOAD-DURATION_TWO-YEAR'  : 'two-year',
};

// ************************************************************************************************

/**
 * cafe24 - image-source 리스트.
 */
export const ACLOSET_CAFE_24_IMAGE_SOURCE_CODE_LIST = [
  'CAFE24_IMAGE-SOURCE_ADDITIONAL',   // 추가 이미지
  'CAFE24_IMAGE-SOURCE_DESCRIPTION',  // 상세 페이지
  'CAFE24_IMAGE-SOURCE_MAIN',         // 대표 이미지
] as const;

/**
 * cafe24 - image-source 타입.
 */
export type AclosetCafe24ImageSourceCode = (typeof ACLOSET_CAFE_24_IMAGE_SOURCE_CODE_LIST)[number];

/**
 * cafe24 - image-source Short 코드 리스트.
 */
export const ACLOSET_CAFE_24_IMAGE_SOURCE_SHORT_CODE_LIST = [
  'additional',   // 추가 이미지
  'description',  // 상세 페이지
  'main',         // 대표 이미지
] as const;

/**
 * cafe24 - image-source Short 코드 타입.
 */
export type AclosetCafe24ImageSourceShortCode = (typeof ACLOSET_CAFE_24_IMAGE_SOURCE_SHORT_CODE_LIST)[number];

/**
 * cafe24 - image-source Short 코드 매핑.
 */
export const ACLOSET_CAFE_24_IMAGE_SOURCE_SHORT_CODE_MAP: Readonly<Record<AclosetCafe24ImageSourceShortCode, AclosetCafe24ImageSourceCode>> = {
  'additional' : 'CAFE24_IMAGE-SOURCE_ADDITIONAL',
  'description': 'CAFE24_IMAGE-SOURCE_DESCRIPTION',
  'main'       : 'CAFE24_IMAGE-SOURCE_MAIN',
};

/**
 * cafe24 - image-source Short 코드 역매핑.
 */
export const ACLOSET_CAFE_24_IMAGE_SOURCE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetCafe24ImageSourceCode, AclosetCafe24ImageSourceShortCode>> = {
  'CAFE24_IMAGE-SOURCE_ADDITIONAL' : 'additional',
  'CAFE24_IMAGE-SOURCE_DESCRIPTION': 'description',
  'CAFE24_IMAGE-SOURCE_MAIN'       : 'main',
};

// ************************************************************************************************

/**
 * cafe24 - description-source 리스트.
 */
export const ACLOSET_CAFE_24_DESCRIPTION_SOURCE_CODE_LIST = [
  'CAFE24_DESCRIPTION-SOURCE_EXCHANGE-INFO',  // 교환/반품안내
  'CAFE24_DESCRIPTION-SOURCE_MATERIAL',       // 상품소재
  'CAFE24_DESCRIPTION-SOURCE_NORMAL',         // 상세설명
  'CAFE24_DESCRIPTION-SOURCE_PAYMENT-INFO',   // 상품결제안내
  'CAFE24_DESCRIPTION-SOURCE_SERVICE-INFO',   // 서비스문의/안내
  'CAFE24_DESCRIPTION-SOURCE_SHIPPING-INFO',  // 상품배송안내
  'CAFE24_DESCRIPTION-SOURCE_SIMPLE',         // 간략설명
  'CAFE24_DESCRIPTION-SOURCE_SUMMARY',        // 요약설명
] as const;

/**
 * cafe24 - description-source 타입.
 */
export type AclosetCafe24DescriptionSourceCode = (typeof ACLOSET_CAFE_24_DESCRIPTION_SOURCE_CODE_LIST)[number];

/**
 * cafe24 - description-source Short 코드 리스트.
 */
export const ACLOSET_CAFE_24_DESCRIPTION_SOURCE_SHORT_CODE_LIST = [
  'exchange-info',  // 교환/반품안내
  'material',       // 상품소재
  'normal',         // 상세설명
  'payment-info',   // 상품결제안내
  'service-info',   // 서비스문의/안내
  'shipping-info',  // 상품배송안내
  'simple',         // 간략설명
  'summary',        // 요약설명
] as const;

/**
 * cafe24 - description-source Short 코드 타입.
 */
export type AclosetCafe24DescriptionSourceShortCode = (typeof ACLOSET_CAFE_24_DESCRIPTION_SOURCE_SHORT_CODE_LIST)[number];

/**
 * cafe24 - description-source Short 코드 매핑.
 */
export const ACLOSET_CAFE_24_DESCRIPTION_SOURCE_SHORT_CODE_MAP: Readonly<Record<AclosetCafe24DescriptionSourceShortCode, AclosetCafe24DescriptionSourceCode>> = {
  'exchange-info': 'CAFE24_DESCRIPTION-SOURCE_EXCHANGE-INFO',
  'material'     : 'CAFE24_DESCRIPTION-SOURCE_MATERIAL',
  'normal'       : 'CAFE24_DESCRIPTION-SOURCE_NORMAL',
  'payment-info' : 'CAFE24_DESCRIPTION-SOURCE_PAYMENT-INFO',
  'service-info' : 'CAFE24_DESCRIPTION-SOURCE_SERVICE-INFO',
  'shipping-info': 'CAFE24_DESCRIPTION-SOURCE_SHIPPING-INFO',
  'simple'       : 'CAFE24_DESCRIPTION-SOURCE_SIMPLE',
  'summary'      : 'CAFE24_DESCRIPTION-SOURCE_SUMMARY',
};

/**
 * cafe24 - description-source Short 코드 역매핑.
 */
export const ACLOSET_CAFE_24_DESCRIPTION_SOURCE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetCafe24DescriptionSourceCode, AclosetCafe24DescriptionSourceShortCode>> = {
  'CAFE24_DESCRIPTION-SOURCE_EXCHANGE-INFO': 'exchange-info',
  'CAFE24_DESCRIPTION-SOURCE_MATERIAL'     : 'material',
  'CAFE24_DESCRIPTION-SOURCE_NORMAL'       : 'normal',
  'CAFE24_DESCRIPTION-SOURCE_PAYMENT-INFO' : 'payment-info',
  'CAFE24_DESCRIPTION-SOURCE_SERVICE-INFO' : 'service-info',
  'CAFE24_DESCRIPTION-SOURCE_SHIPPING-INFO': 'shipping-info',
  'CAFE24_DESCRIPTION-SOURCE_SIMPLE'       : 'simple',
  'CAFE24_DESCRIPTION-SOURCE_SUMMARY'      : 'summary',
};

// ************************************************************************************************

/**
 * claim - type 리스트.
 */
export const ACLOSET_CLAIM_TYPE_CODE_LIST = [
  'CLAIM_TYPE_EXCHANGE',  // 교환
  'CLAIM_TYPE_RETURN',    // 반품
] as const;

/**
 * claim - type 타입.
 */
export type AclosetClaimTypeCode = (typeof ACLOSET_CLAIM_TYPE_CODE_LIST)[number];

/**
 * claim - type Short 코드 리스트.
 */
export const ACLOSET_CLAIM_TYPE_SHORT_CODE_LIST = [
  'exchange',  // 교환
  'return',    // 반품
] as const;

/**
 * claim - type Short 코드 타입.
 */
export type AclosetClaimTypeShortCode = (typeof ACLOSET_CLAIM_TYPE_SHORT_CODE_LIST)[number];

/**
 * claim - type Short 코드 매핑.
 */
export const ACLOSET_CLAIM_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetClaimTypeShortCode, AclosetClaimTypeCode>> = {
  'exchange': 'CLAIM_TYPE_EXCHANGE',
  'return'  : 'CLAIM_TYPE_RETURN',
};

/**
 * claim - type Short 코드 역매핑.
 */
export const ACLOSET_CLAIM_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetClaimTypeCode, AclosetClaimTypeShortCode>> = {
  'CLAIM_TYPE_EXCHANGE': 'exchange',
  'CLAIM_TYPE_RETURN'  : 'return',
};

// ************************************************************************************************

/**
 * claim - transaction-type 리스트.
 */
export const ACLOSET_CLAIM_TRANSACTION_TYPE_CODE_LIST = [
  'CLAIM_TRANSACTION-TYPE_BUYER',   // 구매자
  'CLAIM_TRANSACTION-TYPE_SELLER',  // 판매자
] as const;

/**
 * claim - transaction-type 타입.
 */
export type AclosetClaimTransactionTypeCode = (typeof ACLOSET_CLAIM_TRANSACTION_TYPE_CODE_LIST)[number];

/**
 * claim - transaction-type Short 코드 리스트.
 */
export const ACLOSET_CLAIM_TRANSACTION_TYPE_SHORT_CODE_LIST = [
  'buyer',   // 구매자
  'seller',  // 판매자
] as const;

/**
 * claim - transaction-type Short 코드 타입.
 */
export type AclosetClaimTransactionTypeShortCode = (typeof ACLOSET_CLAIM_TRANSACTION_TYPE_SHORT_CODE_LIST)[number];

/**
 * claim - transaction-type Short 코드 매핑.
 */
export const ACLOSET_CLAIM_TRANSACTION_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetClaimTransactionTypeShortCode, AclosetClaimTransactionTypeCode>> = {
  'buyer' : 'CLAIM_TRANSACTION-TYPE_BUYER',
  'seller': 'CLAIM_TRANSACTION-TYPE_SELLER',
};

/**
 * claim - transaction-type Short 코드 역매핑.
 */
export const ACLOSET_CLAIM_TRANSACTION_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetClaimTransactionTypeCode, AclosetClaimTransactionTypeShortCode>> = {
  'CLAIM_TRANSACTION-TYPE_BUYER' : 'buyer',
  'CLAIM_TRANSACTION-TYPE_SELLER': 'seller',
};

// ************************************************************************************************

/**
 * claim - return-status 리스트.
 */
export const ACLOSET_CLAIM_RETURN_STATUS_CODE_LIST = [
  'CLAIM_RETURN-STATUS_BEFORE-PICKUP',       // 수거 전
  'CLAIM_RETURN-STATUS_DONE',                // 반품 완료
  'CLAIM_RETURN-STATUS_PENDING',             // 반품 보류
  'CLAIM_RETURN-STATUS_PICKUP-DONE',         // 수거 완료
  'CLAIM_RETURN-STATUS_PICKUP-IN-PROGRESS',  // 수거 중
  'CLAIM_RETURN-STATUS_REJECT',              // 반품 철회
  'CLAIM_RETURN-STATUS_REQUEST',             // 반품 요청
] as const;

/**
 * claim - return-status 타입.
 */
export type AclosetClaimReturnStatusCode = (typeof ACLOSET_CLAIM_RETURN_STATUS_CODE_LIST)[number];

/**
 * claim - return-status Short 코드 리스트.
 */
export const ACLOSET_CLAIM_RETURN_STATUS_SHORT_CODE_LIST = [
  'before-pickup',       // 수거 전
  'done',                // 반품 완료
  'pending',             // 반품 보류
  'pickup-done',         // 수거 완료
  'pickup-in-progress',  // 수거 중
  'reject',              // 반품 철회
  'request',             // 반품 요청
] as const;

/**
 * claim - return-status Short 코드 타입.
 */
export type AclosetClaimReturnStatusShortCode = (typeof ACLOSET_CLAIM_RETURN_STATUS_SHORT_CODE_LIST)[number];

/**
 * claim - return-status Short 코드 매핑.
 */
export const ACLOSET_CLAIM_RETURN_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetClaimReturnStatusShortCode, AclosetClaimReturnStatusCode>> = {
  'before-pickup'     : 'CLAIM_RETURN-STATUS_BEFORE-PICKUP',
  'done'              : 'CLAIM_RETURN-STATUS_DONE',
  'pending'           : 'CLAIM_RETURN-STATUS_PENDING',
  'pickup-done'       : 'CLAIM_RETURN-STATUS_PICKUP-DONE',
  'pickup-in-progress': 'CLAIM_RETURN-STATUS_PICKUP-IN-PROGRESS',
  'reject'            : 'CLAIM_RETURN-STATUS_REJECT',
  'request'           : 'CLAIM_RETURN-STATUS_REQUEST',
};

/**
 * claim - return-status Short 코드 역매핑.
 */
export const ACLOSET_CLAIM_RETURN_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetClaimReturnStatusCode, AclosetClaimReturnStatusShortCode>> = {
  'CLAIM_RETURN-STATUS_BEFORE-PICKUP'     : 'before-pickup',
  'CLAIM_RETURN-STATUS_DONE'              : 'done',
  'CLAIM_RETURN-STATUS_PENDING'           : 'pending',
  'CLAIM_RETURN-STATUS_PICKUP-DONE'       : 'pickup-done',
  'CLAIM_RETURN-STATUS_PICKUP-IN-PROGRESS': 'pickup-in-progress',
  'CLAIM_RETURN-STATUS_REJECT'            : 'reject',
  'CLAIM_RETURN-STATUS_REQUEST'           : 'request',
};

// ************************************************************************************************

/**
 * claim - operation 리스트.
 */
export const ACLOSET_CLAIM_OPERATION_CODE_LIST = [
  'CLAIM_OPERATION_FAILED',       // 처리 실패
  'CLAIM_OPERATION_IDLE',         // 처리 대기
  'CLAIM_OPERATION_IN-PROGRESS',  // 처리 중
] as const;

/**
 * claim - operation 타입.
 */
export type AclosetClaimOperationCode = (typeof ACLOSET_CLAIM_OPERATION_CODE_LIST)[number];

/**
 * claim - operation Short 코드 리스트.
 */
export const ACLOSET_CLAIM_OPERATION_SHORT_CODE_LIST = [
  'failed',       // 처리 실패
  'idle',         // 처리 대기
  'in-progress',  // 처리 중
] as const;

/**
 * claim - operation Short 코드 타입.
 */
export type AclosetClaimOperationShortCode = (typeof ACLOSET_CLAIM_OPERATION_SHORT_CODE_LIST)[number];

/**
 * claim - operation Short 코드 매핑.
 */
export const ACLOSET_CLAIM_OPERATION_SHORT_CODE_MAP: Readonly<Record<AclosetClaimOperationShortCode, AclosetClaimOperationCode>> = {
  'failed'     : 'CLAIM_OPERATION_FAILED',
  'idle'       : 'CLAIM_OPERATION_IDLE',
  'in-progress': 'CLAIM_OPERATION_IN-PROGRESS',
};

/**
 * claim - operation Short 코드 역매핑.
 */
export const ACLOSET_CLAIM_OPERATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetClaimOperationCode, AclosetClaimOperationShortCode>> = {
  'CLAIM_OPERATION_FAILED'     : 'failed',
  'CLAIM_OPERATION_IDLE'       : 'idle',
  'CLAIM_OPERATION_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * coupon - type 리스트.
 */
export const ACLOSET_COUPON_TYPE_CODE_LIST = [
  'COUPON_TYPE_FREE-TRIAL',  // 무료체험 쿠폰
] as const;

/**
 * coupon - type 타입.
 */
export type AclosetCouponTypeCode = (typeof ACLOSET_COUPON_TYPE_CODE_LIST)[number];

/**
 * coupon - type Short 코드 리스트.
 */
export const ACLOSET_COUPON_TYPE_SHORT_CODE_LIST = [
  'free-trial',  // 무료체험 쿠폰
] as const;

/**
 * coupon - type Short 코드 타입.
 */
export type AclosetCouponTypeShortCode = (typeof ACLOSET_COUPON_TYPE_SHORT_CODE_LIST)[number];

/**
 * coupon - type Short 코드 매핑.
 */
export const ACLOSET_COUPON_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetCouponTypeShortCode, AclosetCouponTypeCode>> = {
  'free-trial': 'COUPON_TYPE_FREE-TRIAL',
};

/**
 * coupon - type Short 코드 역매핑.
 */
export const ACLOSET_COUPON_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetCouponTypeCode, AclosetCouponTypeShortCode>> = {
  'COUPON_TYPE_FREE-TRIAL': 'free-trial',
};

// ************************************************************************************************

/**
 * coupon - status 리스트.
 */
export const ACLOSET_COUPON_STATUS_CODE_LIST = [
  'COUPON_STATUS_EXPIRED',         // 미사용 만료
  'COUPON_STATUS_NOT-REGISTERED',  // 미등록
  'COUPON_STATUS_REGISTERED',      // 등록
  'COUPON_STATUS_USED',            // 사용 완료
  'COUPON_STATUS_USING',           // 적용
] as const;

/**
 * coupon - status 타입.
 */
export type AclosetCouponStatusCode = (typeof ACLOSET_COUPON_STATUS_CODE_LIST)[number];

/**
 * coupon - status Short 코드 리스트.
 */
export const ACLOSET_COUPON_STATUS_SHORT_CODE_LIST = [
  'expired',         // 미사용 만료
  'not-registered',  // 미등록
  'registered',      // 등록
  'used',            // 사용 완료
  'using',           // 적용
] as const;

/**
 * coupon - status Short 코드 타입.
 */
export type AclosetCouponStatusShortCode = (typeof ACLOSET_COUPON_STATUS_SHORT_CODE_LIST)[number];

/**
 * coupon - status Short 코드 매핑.
 */
export const ACLOSET_COUPON_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetCouponStatusShortCode, AclosetCouponStatusCode>> = {
  'expired'       : 'COUPON_STATUS_EXPIRED',
  'not-registered': 'COUPON_STATUS_NOT-REGISTERED',
  'registered'    : 'COUPON_STATUS_REGISTERED',
  'used'          : 'COUPON_STATUS_USED',
  'using'         : 'COUPON_STATUS_USING',
};

/**
 * coupon - status Short 코드 역매핑.
 */
export const ACLOSET_COUPON_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetCouponStatusCode, AclosetCouponStatusShortCode>> = {
  'COUPON_STATUS_EXPIRED'       : 'expired',
  'COUPON_STATUS_NOT-REGISTERED': 'not-registered',
  'COUPON_STATUS_REGISTERED'    : 'registered',
  'COUPON_STATUS_USED'          : 'used',
  'COUPON_STATUS_USING'         : 'using',
};

// ************************************************************************************************

/**
 * global-state - key 리스트.
 */
export const ACLOSET_GLOBAL_STATE_KEY_CODE_LIST = [
  'GLOBAL-STATE_KEY_AI-DESCRIPTION-PRICING-ENABLE',  // AI 상품설명 비용 활성화 여부
  'GLOBAL-STATE_KEY_INSTAGRAM-SLEEP-TIME',           // 인스타그램 게시 대기 시간
  'GLOBAL-STATE_KEY_MONTHLY-PRICE',                  // 월별 구독 가격
  'GLOBAL-STATE_KEY_NEW-PRICING-ENABLE',             // 신규 비용 기준 활성화 여부
] as const;

/**
 * global-state - key 타입.
 */
export type AclosetGlobalStateKeyCode = (typeof ACLOSET_GLOBAL_STATE_KEY_CODE_LIST)[number];

/**
 * global-state - key Short 코드 리스트.
 */
export const ACLOSET_GLOBAL_STATE_KEY_SHORT_CODE_LIST = [
  'ai-description-pricing-enable',  // AI 상품설명 비용 활성화 여부
  'instagram-sleep-time',           // 인스타그램 게시 대기 시간
  'monthly-price',                  // 월별 구독 가격
  'new-pricing-enable',             // 신규 비용 기준 활성화 여부
] as const;

/**
 * global-state - key Short 코드 타입.
 */
export type AclosetGlobalStateKeyShortCode = (typeof ACLOSET_GLOBAL_STATE_KEY_SHORT_CODE_LIST)[number];

/**
 * global-state - key Short 코드 매핑.
 */
export const ACLOSET_GLOBAL_STATE_KEY_SHORT_CODE_MAP: Readonly<Record<AclosetGlobalStateKeyShortCode, AclosetGlobalStateKeyCode>> = {
  'ai-description-pricing-enable': 'GLOBAL-STATE_KEY_AI-DESCRIPTION-PRICING-ENABLE',
  'instagram-sleep-time'         : 'GLOBAL-STATE_KEY_INSTAGRAM-SLEEP-TIME',
  'monthly-price'                : 'GLOBAL-STATE_KEY_MONTHLY-PRICE',
  'new-pricing-enable'           : 'GLOBAL-STATE_KEY_NEW-PRICING-ENABLE',
};

/**
 * global-state - key Short 코드 역매핑.
 */
export const ACLOSET_GLOBAL_STATE_KEY_SHORT_CODE_INV_MAP: Readonly<Record<AclosetGlobalStateKeyCode, AclosetGlobalStateKeyShortCode>> = {
  'GLOBAL-STATE_KEY_AI-DESCRIPTION-PRICING-ENABLE': 'ai-description-pricing-enable',
  'GLOBAL-STATE_KEY_INSTAGRAM-SLEEP-TIME'         : 'instagram-sleep-time',
  'GLOBAL-STATE_KEY_MONTHLY-PRICE'                : 'monthly-price',
  'GLOBAL-STATE_KEY_NEW-PRICING-ENABLE'           : 'new-pricing-enable',
};

// ************************************************************************************************

/**
 * item-consistency-report - status 리스트.
 */
export const ACLOSET_ITEM_CONSISTENCY_REPORT_STATUS_CODE_LIST = [
  'ITEM-CONSISTENCY-REPORT_STATUS_CHECKED',    // 확인됨
  'ITEM-CONSISTENCY-REPORT_STATUS_UNCHECKED',  // 미확인
] as const;

/**
 * item-consistency-report - status 타입.
 */
export type AclosetItemConsistencyReportStatusCode = (typeof ACLOSET_ITEM_CONSISTENCY_REPORT_STATUS_CODE_LIST)[number];

/**
 * item-consistency-report - status Short 코드 리스트.
 */
export const ACLOSET_ITEM_CONSISTENCY_REPORT_STATUS_SHORT_CODE_LIST = [
  'checked',    // 확인됨
  'unchecked',  // 미확인
] as const;

/**
 * item-consistency-report - status Short 코드 타입.
 */
export type AclosetItemConsistencyReportStatusShortCode = (typeof ACLOSET_ITEM_CONSISTENCY_REPORT_STATUS_SHORT_CODE_LIST)[number];

/**
 * item-consistency-report - status Short 코드 매핑.
 */
export const ACLOSET_ITEM_CONSISTENCY_REPORT_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetItemConsistencyReportStatusShortCode, AclosetItemConsistencyReportStatusCode>> = {
  'checked'  : 'ITEM-CONSISTENCY-REPORT_STATUS_CHECKED',
  'unchecked': 'ITEM-CONSISTENCY-REPORT_STATUS_UNCHECKED',
};

/**
 * item-consistency-report - status Short 코드 역매핑.
 */
export const ACLOSET_ITEM_CONSISTENCY_REPORT_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetItemConsistencyReportStatusCode, AclosetItemConsistencyReportStatusShortCode>> = {
  'ITEM-CONSISTENCY-REPORT_STATUS_CHECKED'  : 'checked',
  'ITEM-CONSISTENCY-REPORT_STATUS_UNCHECKED': 'unchecked',
};

// ************************************************************************************************

/**
 * kakaotalk - template-type 리스트.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_TYPE_CODE_LIST = [
  'KAKAOTALK_TEMPLATE-TYPE_BUSINESS',  // 영업용
] as const;

/**
 * kakaotalk - template-type 타입.
 */
export type AclosetKakaotalkTemplateTypeCode = (typeof ACLOSET_KAKAOTALK_TEMPLATE_TYPE_CODE_LIST)[number];

/**
 * kakaotalk - template-type Short 코드 리스트.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_TYPE_SHORT_CODE_LIST = [
  'business',  // 영업용
] as const;

/**
 * kakaotalk - template-type Short 코드 타입.
 */
export type AclosetKakaotalkTemplateTypeShortCode = (typeof ACLOSET_KAKAOTALK_TEMPLATE_TYPE_SHORT_CODE_LIST)[number];

/**
 * kakaotalk - template-type Short 코드 매핑.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetKakaotalkTemplateTypeShortCode, AclosetKakaotalkTemplateTypeCode>> = {
  'business': 'KAKAOTALK_TEMPLATE-TYPE_BUSINESS',
};

/**
 * kakaotalk - template-type Short 코드 역매핑.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetKakaotalkTemplateTypeCode, AclosetKakaotalkTemplateTypeShortCode>> = {
  'KAKAOTALK_TEMPLATE-TYPE_BUSINESS': 'business',
};

// ************************************************************************************************

/**
 * kakaotalk - template-destination 리스트.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_DESTINATION_CODE_LIST = [
  'KAKAOTALK_TEMPLATE-DESTINATION_CREDENTIAL',  // 아이디/비밀번호 변경 페이지
  'KAKAOTALK_TEMPLATE-DESTINATION_INVITE',      // 입점안내 페이지
] as const;

/**
 * kakaotalk - template-destination 타입.
 */
export type AclosetKakaotalkTemplateDestinationCode = (typeof ACLOSET_KAKAOTALK_TEMPLATE_DESTINATION_CODE_LIST)[number];

/**
 * kakaotalk - template-destination Short 코드 리스트.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_DESTINATION_SHORT_CODE_LIST = [
  'credential',  // 아이디/비밀번호 변경 페이지
  'invite',      // 입점안내 페이지
] as const;

/**
 * kakaotalk - template-destination Short 코드 타입.
 */
export type AclosetKakaotalkTemplateDestinationShortCode = (typeof ACLOSET_KAKAOTALK_TEMPLATE_DESTINATION_SHORT_CODE_LIST)[number];

/**
 * kakaotalk - template-destination Short 코드 매핑.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_DESTINATION_SHORT_CODE_MAP: Readonly<Record<AclosetKakaotalkTemplateDestinationShortCode, AclosetKakaotalkTemplateDestinationCode>> = {
  'credential': 'KAKAOTALK_TEMPLATE-DESTINATION_CREDENTIAL',
  'invite'    : 'KAKAOTALK_TEMPLATE-DESTINATION_INVITE',
};

/**
 * kakaotalk - template-destination Short 코드 역매핑.
 */
export const ACLOSET_KAKAOTALK_TEMPLATE_DESTINATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetKakaotalkTemplateDestinationCode, AclosetKakaotalkTemplateDestinationShortCode>> = {
  'KAKAOTALK_TEMPLATE-DESTINATION_CREDENTIAL': 'credential',
  'KAKAOTALK_TEMPLATE-DESTINATION_INVITE'    : 'invite',
};

// ************************************************************************************************

/**
 * labeling - type 리스트.
 */
export const ACLOSET_LABELING_TYPE_CODE_LIST = [
  'LABELING_TYPE_BRAND',     // 브랜드
  'LABELING_TYPE_CATEGORY',  // 카테고리
  'LABELING_TYPE_COLOR',     // 색상
  'LABELING_TYPE_GENDER',    // 성별
] as const;

/**
 * labeling - type 타입.
 */
export type AclosetLabelingTypeCode = (typeof ACLOSET_LABELING_TYPE_CODE_LIST)[number];

/**
 * labeling - type Short 코드 리스트.
 */
export const ACLOSET_LABELING_TYPE_SHORT_CODE_LIST = [
  'brand',     // 브랜드
  'category',  // 카테고리
  'color',     // 색상
  'gender',    // 성별
] as const;

/**
 * labeling - type Short 코드 타입.
 */
export type AclosetLabelingTypeShortCode = (typeof ACLOSET_LABELING_TYPE_SHORT_CODE_LIST)[number];

/**
 * labeling - type Short 코드 매핑.
 */
export const ACLOSET_LABELING_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetLabelingTypeShortCode, AclosetLabelingTypeCode>> = {
  'brand'   : 'LABELING_TYPE_BRAND',
  'category': 'LABELING_TYPE_CATEGORY',
  'color'   : 'LABELING_TYPE_COLOR',
  'gender'  : 'LABELING_TYPE_GENDER',
};

/**
 * labeling - type Short 코드 역매핑.
 */
export const ACLOSET_LABELING_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetLabelingTypeCode, AclosetLabelingTypeShortCode>> = {
  'LABELING_TYPE_BRAND'   : 'brand',
  'LABELING_TYPE_CATEGORY': 'category',
  'LABELING_TYPE_COLOR'   : 'color',
  'LABELING_TYPE_GENDER'  : 'gender',
};

// ************************************************************************************************

/**
 * labeling - status 리스트.
 */
export const ACLOSET_LABELING_STATUS_CODE_LIST = [
  'LABELING_STATUS_CONFIRMED',                  // 확인완료
  'LABELING_STATUS_IDLE',                       // 미완료
  'LABELING_STATUS_IDLE-AND-HIGH-PROBABILITY',  // 미완료(정답 확률 높음)
  'LABELING_STATUS_MODIFIED',                   // 수정완료
] as const;

/**
 * labeling - status 타입.
 */
export type AclosetLabelingStatusCode = (typeof ACLOSET_LABELING_STATUS_CODE_LIST)[number];

/**
 * labeling - status Short 코드 리스트.
 */
export const ACLOSET_LABELING_STATUS_SHORT_CODE_LIST = [
  'confirmed',                  // 확인완료
  'idle',                       // 미완료
  'idle-and-high-probability',  // 미완료(정답 확률 높음)
  'modified',                   // 수정완료
] as const;

/**
 * labeling - status Short 코드 타입.
 */
export type AclosetLabelingStatusShortCode = (typeof ACLOSET_LABELING_STATUS_SHORT_CODE_LIST)[number];

/**
 * labeling - status Short 코드 매핑.
 */
export const ACLOSET_LABELING_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetLabelingStatusShortCode, AclosetLabelingStatusCode>> = {
  'confirmed'                : 'LABELING_STATUS_CONFIRMED',
  'idle'                     : 'LABELING_STATUS_IDLE',
  'idle-and-high-probability': 'LABELING_STATUS_IDLE-AND-HIGH-PROBABILITY',
  'modified'                 : 'LABELING_STATUS_MODIFIED',
};

/**
 * labeling - status Short 코드 역매핑.
 */
export const ACLOSET_LABELING_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetLabelingStatusCode, AclosetLabelingStatusShortCode>> = {
  'LABELING_STATUS_CONFIRMED'                : 'confirmed',
  'LABELING_STATUS_IDLE'                     : 'idle',
  'LABELING_STATUS_IDLE-AND-HIGH-PROBABILITY': 'idle-and-high-probability',
  'LABELING_STATUS_MODIFIED'                 : 'modified',
};

// ************************************************************************************************

/**
 * mapping-group - type 리스트.
 */
export const ACLOSET_MAPPING_GROUP_TYPE_CODE_LIST = [
  'MAPPING-GROUP_TYPE_KIDS-MEN',     // 키즈 남
  'MAPPING-GROUP_TYPE_KIDS-UNISEX',  // 키즈
  'MAPPING-GROUP_TYPE_KIDS-WOMEN',   // 키즈 여
  'MAPPING-GROUP_TYPE_MEN',          // 남성
  'MAPPING-GROUP_TYPE_UNISEX',       // 유니섹스
  'MAPPING-GROUP_TYPE_WOMEN',        // 여성
] as const;

/**
 * mapping-group - type 타입.
 */
export type AclosetMappingGroupTypeCode = (typeof ACLOSET_MAPPING_GROUP_TYPE_CODE_LIST)[number];

/**
 * mapping-group - type Short 코드 리스트.
 */
export const ACLOSET_MAPPING_GROUP_TYPE_SHORT_CODE_LIST = [
  'kids-men',     // 키즈 남
  'kids-unisex',  // 키즈
  'kids-women',   // 키즈 여
  'men',          // 남성
  'unisex',       // 유니섹스
  'women',        // 여성
] as const;

/**
 * mapping-group - type Short 코드 타입.
 */
export type AclosetMappingGroupTypeShortCode = (typeof ACLOSET_MAPPING_GROUP_TYPE_SHORT_CODE_LIST)[number];

/**
 * mapping-group - type Short 코드 매핑.
 */
export const ACLOSET_MAPPING_GROUP_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetMappingGroupTypeShortCode, AclosetMappingGroupTypeCode>> = {
  'kids-men'   : 'MAPPING-GROUP_TYPE_KIDS-MEN',
  'kids-unisex': 'MAPPING-GROUP_TYPE_KIDS-UNISEX',
  'kids-women' : 'MAPPING-GROUP_TYPE_KIDS-WOMEN',
  'men'        : 'MAPPING-GROUP_TYPE_MEN',
  'unisex'     : 'MAPPING-GROUP_TYPE_UNISEX',
  'women'      : 'MAPPING-GROUP_TYPE_WOMEN',
};

/**
 * mapping-group - type Short 코드 역매핑.
 */
export const ACLOSET_MAPPING_GROUP_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetMappingGroupTypeCode, AclosetMappingGroupTypeShortCode>> = {
  'MAPPING-GROUP_TYPE_KIDS-MEN'   : 'kids-men',
  'MAPPING-GROUP_TYPE_KIDS-UNISEX': 'kids-unisex',
  'MAPPING-GROUP_TYPE_KIDS-WOMEN' : 'kids-women',
  'MAPPING-GROUP_TYPE_MEN'        : 'men',
  'MAPPING-GROUP_TYPE_UNISEX'     : 'unisex',
  'MAPPING-GROUP_TYPE_WOMEN'      : 'women',
};

// ************************************************************************************************

/**
 * mapping-group - size-mapping-type 리스트.
 */
export const ACLOSET_MAPPING_GROUP_SIZE_MAPPING_TYPE_CODE_LIST = [
  'MAPPING-GROUP_SIZE-MAPPING-TYPE_BOTTOM',        // 카테고리가 하의인 경우
  'MAPPING-GROUP_SIZE-MAPPING-TYPE_OUTER',         // 카테고리가 아우터인 경우
  'MAPPING-GROUP_SIZE-MAPPING-TYPE_TOP-ONEPIECE',  // 카테고리가 상의, 원피스 (점프수트 포함)인 경우
] as const;

/**
 * mapping-group - size-mapping-type 타입.
 */
export type AclosetMappingGroupSizeMappingTypeCode = (typeof ACLOSET_MAPPING_GROUP_SIZE_MAPPING_TYPE_CODE_LIST)[number];

/**
 * mapping-group - size-mapping-type Short 코드 리스트.
 */
export const ACLOSET_MAPPING_GROUP_SIZE_MAPPING_TYPE_SHORT_CODE_LIST = [
  'bottom',        // 카테고리가 하의인 경우
  'outer',         // 카테고리가 아우터인 경우
  'top-onepiece',  // 카테고리가 상의, 원피스 (점프수트 포함)인 경우
] as const;

/**
 * mapping-group - size-mapping-type Short 코드 타입.
 */
export type AclosetMappingGroupSizeMappingTypeShortCode = (typeof ACLOSET_MAPPING_GROUP_SIZE_MAPPING_TYPE_SHORT_CODE_LIST)[number];

/**
 * mapping-group - size-mapping-type Short 코드 매핑.
 */
export const ACLOSET_MAPPING_GROUP_SIZE_MAPPING_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetMappingGroupSizeMappingTypeShortCode, AclosetMappingGroupSizeMappingTypeCode>> = {
  'bottom'      : 'MAPPING-GROUP_SIZE-MAPPING-TYPE_BOTTOM',
  'outer'       : 'MAPPING-GROUP_SIZE-MAPPING-TYPE_OUTER',
  'top-onepiece': 'MAPPING-GROUP_SIZE-MAPPING-TYPE_TOP-ONEPIECE',
};

/**
 * mapping-group - size-mapping-type Short 코드 역매핑.
 */
export const ACLOSET_MAPPING_GROUP_SIZE_MAPPING_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetMappingGroupSizeMappingTypeCode, AclosetMappingGroupSizeMappingTypeShortCode>> = {
  'MAPPING-GROUP_SIZE-MAPPING-TYPE_BOTTOM'      : 'bottom',
  'MAPPING-GROUP_SIZE-MAPPING-TYPE_OUTER'       : 'outer',
  'MAPPING-GROUP_SIZE-MAPPING-TYPE_TOP-ONEPIECE': 'top-onepiece',
};

// ************************************************************************************************

/**
 * mapping-group - mapping-type 리스트.
 */
export const ACLOSET_MAPPING_GROUP_MAPPING_TYPE_CODE_LIST = [
  'MAPPING-GROUP_MAPPING-TYPE_BASIC',   // 기본 매핑
  'MAPPING-GROUP_MAPPING-TYPE_CUSTOM',  // 사용자 지정 매핑
] as const;

/**
 * mapping-group - mapping-type 타입.
 */
export type AclosetMappingGroupMappingTypeCode = (typeof ACLOSET_MAPPING_GROUP_MAPPING_TYPE_CODE_LIST)[number];

/**
 * mapping-group - mapping-type Short 코드 리스트.
 */
export const ACLOSET_MAPPING_GROUP_MAPPING_TYPE_SHORT_CODE_LIST = [
  'basic',   // 기본 매핑
  'custom',  // 사용자 지정 매핑
] as const;

/**
 * mapping-group - mapping-type Short 코드 타입.
 */
export type AclosetMappingGroupMappingTypeShortCode = (typeof ACLOSET_MAPPING_GROUP_MAPPING_TYPE_SHORT_CODE_LIST)[number];

/**
 * mapping-group - mapping-type Short 코드 매핑.
 */
export const ACLOSET_MAPPING_GROUP_MAPPING_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetMappingGroupMappingTypeShortCode, AclosetMappingGroupMappingTypeCode>> = {
  'basic' : 'MAPPING-GROUP_MAPPING-TYPE_BASIC',
  'custom': 'MAPPING-GROUP_MAPPING-TYPE_CUSTOM',
};

/**
 * mapping-group - mapping-type Short 코드 역매핑.
 */
export const ACLOSET_MAPPING_GROUP_MAPPING_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetMappingGroupMappingTypeCode, AclosetMappingGroupMappingTypeShortCode>> = {
  'MAPPING-GROUP_MAPPING-TYPE_BASIC' : 'basic',
  'MAPPING-GROUP_MAPPING-TYPE_CUSTOM': 'custom',
};

// ************************************************************************************************

/**
 * market-item - genderwear 리스트.
 */
export const ACLOSET_MARKET_ITEM_GENDERWEAR_CODE_LIST = [
  'MARKET-ITEM_GENDERWEAR_BOY',         // 키즈남
  'MARKET-ITEM_GENDERWEAR_GIRL',        // 키즈여
  'MARKET-ITEM_GENDERWEAR_KID_UNISEX',  // 키즈
  'MARKET-ITEM_GENDERWEAR_MEN',         // 남성
  'MARKET-ITEM_GENDERWEAR_UNISEX',      // 유니섹스
  'MARKET-ITEM_GENDERWEAR_WOMEN',       // 여성
] as const;

/**
 * market-item - genderwear 타입.
 */
export type AclosetMarketItemGenderwearCode = (typeof ACLOSET_MARKET_ITEM_GENDERWEAR_CODE_LIST)[number];

/**
 * market-item - genderwear Short 코드 리스트.
 */
export const ACLOSET_MARKET_ITEM_GENDERWEAR_SHORT_CODE_LIST = [
  'boy',         // 키즈남
  'girl',        // 키즈여
  'kid_unisex',  // 키즈
  'men',         // 남성
  'unisex',      // 유니섹스
  'women',       // 여성
] as const;

/**
 * market-item - genderwear Short 코드 타입.
 */
export type AclosetMarketItemGenderwearShortCode = (typeof ACLOSET_MARKET_ITEM_GENDERWEAR_SHORT_CODE_LIST)[number];

/**
 * market-item - genderwear Short 코드 매핑.
 */
export const ACLOSET_MARKET_ITEM_GENDERWEAR_SHORT_CODE_MAP: Readonly<Record<AclosetMarketItemGenderwearShortCode, AclosetMarketItemGenderwearCode>> = {
  'boy'       : 'MARKET-ITEM_GENDERWEAR_BOY',
  'girl'      : 'MARKET-ITEM_GENDERWEAR_GIRL',
  'kid_unisex': 'MARKET-ITEM_GENDERWEAR_KID_UNISEX',
  'men'       : 'MARKET-ITEM_GENDERWEAR_MEN',
  'unisex'    : 'MARKET-ITEM_GENDERWEAR_UNISEX',
  'women'     : 'MARKET-ITEM_GENDERWEAR_WOMEN',
};

/**
 * market-item - genderwear Short 코드 역매핑.
 */
export const ACLOSET_MARKET_ITEM_GENDERWEAR_SHORT_CODE_INV_MAP: Readonly<Record<AclosetMarketItemGenderwearCode, AclosetMarketItemGenderwearShortCode>> = {
  'MARKET-ITEM_GENDERWEAR_BOY'       : 'boy',
  'MARKET-ITEM_GENDERWEAR_GIRL'      : 'girl',
  'MARKET-ITEM_GENDERWEAR_KID_UNISEX': 'kid_unisex',
  'MARKET-ITEM_GENDERWEAR_MEN'       : 'men',
  'MARKET-ITEM_GENDERWEAR_UNISEX'    : 'unisex',
  'MARKET-ITEM_GENDERWEAR_WOMEN'     : 'women',
};

// ************************************************************************************************

/**
 * metadata-alias - fabric-notation 리스트.
 */
export const ACLOSET_METADATA_ALIAS_FABRIC_NOTATION_CODE_LIST = [
  'METADATA-ALIAS_FABRIC-NOTATION_ALL',              // 모든 소재 표기
  'METADATA-ALIAS_FABRIC-NOTATION_FIRST',            // 첫번째 소재만 표기
  'METADATA-ALIAS_FABRIC-NOTATION_FIRST-AND-MIXED',  // 첫번째 소재와 혼방 표기
  'METADATA-ALIAS_FABRIC-NOTATION_SECOND',           // 두번째 소재까지 표기
] as const;

/**
 * metadata-alias - fabric-notation 타입.
 */
export type AclosetMetadataAliasFabricNotationCode = (typeof ACLOSET_METADATA_ALIAS_FABRIC_NOTATION_CODE_LIST)[number];

/**
 * metadata-alias - fabric-notation Short 코드 리스트.
 */
export const ACLOSET_METADATA_ALIAS_FABRIC_NOTATION_SHORT_CODE_LIST = [
  'all',              // 모든 소재 표기
  'first',            // 첫번째 소재만 표기
  'first-and-mixed',  // 첫번째 소재와 혼방 표기
  'second',           // 두번째 소재까지 표기
] as const;

/**
 * metadata-alias - fabric-notation Short 코드 타입.
 */
export type AclosetMetadataAliasFabricNotationShortCode = (typeof ACLOSET_METADATA_ALIAS_FABRIC_NOTATION_SHORT_CODE_LIST)[number];

/**
 * metadata-alias - fabric-notation Short 코드 매핑.
 */
export const ACLOSET_METADATA_ALIAS_FABRIC_NOTATION_SHORT_CODE_MAP: Readonly<Record<AclosetMetadataAliasFabricNotationShortCode, AclosetMetadataAliasFabricNotationCode>> = {
  'all'            : 'METADATA-ALIAS_FABRIC-NOTATION_ALL',
  'first'          : 'METADATA-ALIAS_FABRIC-NOTATION_FIRST',
  'first-and-mixed': 'METADATA-ALIAS_FABRIC-NOTATION_FIRST-AND-MIXED',
  'second'         : 'METADATA-ALIAS_FABRIC-NOTATION_SECOND',
};

/**
 * metadata-alias - fabric-notation Short 코드 역매핑.
 */
export const ACLOSET_METADATA_ALIAS_FABRIC_NOTATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetMetadataAliasFabricNotationCode, AclosetMetadataAliasFabricNotationShortCode>> = {
  'METADATA-ALIAS_FABRIC-NOTATION_ALL'            : 'all',
  'METADATA-ALIAS_FABRIC-NOTATION_FIRST'          : 'first',
  'METADATA-ALIAS_FABRIC-NOTATION_FIRST-AND-MIXED': 'first-and-mixed',
  'METADATA-ALIAS_FABRIC-NOTATION_SECOND'         : 'second',
};

// ************************************************************************************************

/**
 * naver - load-status 리스트.
 */
export const ACLOSET_NAVER_LOAD_STATUS_CODE_LIST = [
  'NAVER_LOAD-STATUS_FAIL',         // 실패
  'NAVER_LOAD-STATUS_IDLE',         // 대기
  'NAVER_LOAD-STATUS_IN-PROGRESS',  // 진행중
] as const;

/**
 * naver - load-status 타입.
 */
export type AclosetNaverLoadStatusCode = (typeof ACLOSET_NAVER_LOAD_STATUS_CODE_LIST)[number];

/**
 * naver - load-status Short 코드 리스트.
 */
export const ACLOSET_NAVER_LOAD_STATUS_SHORT_CODE_LIST = [
  'fail',         // 실패
  'idle',         // 대기
  'in-progress',  // 진행중
] as const;

/**
 * naver - load-status Short 코드 타입.
 */
export type AclosetNaverLoadStatusShortCode = (typeof ACLOSET_NAVER_LOAD_STATUS_SHORT_CODE_LIST)[number];

/**
 * naver - load-status Short 코드 매핑.
 */
export const ACLOSET_NAVER_LOAD_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetNaverLoadStatusShortCode, AclosetNaverLoadStatusCode>> = {
  'fail'       : 'NAVER_LOAD-STATUS_FAIL',
  'idle'       : 'NAVER_LOAD-STATUS_IDLE',
  'in-progress': 'NAVER_LOAD-STATUS_IN-PROGRESS',
};

/**
 * naver - load-status Short 코드 역매핑.
 */
export const ACLOSET_NAVER_LOAD_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNaverLoadStatusCode, AclosetNaverLoadStatusShortCode>> = {
  'NAVER_LOAD-STATUS_FAIL'       : 'fail',
  'NAVER_LOAD-STATUS_IDLE'       : 'idle',
  'NAVER_LOAD-STATUS_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * naver - load-duration 리스트.
 */
export const ACLOSET_NAVER_LOAD_DURATION_CODE_LIST = [
  'NAVER_LOAD-DURATION_ONE-MONTH',   // 1개월
  'NAVER_LOAD-DURATION_ONE-WEEK',    // 1주일
  'NAVER_LOAD-DURATION_ONE-YEAR',    // 1년
  'NAVER_LOAD-DURATION_SIX-MONTH',   // 6개월
  'NAVER_LOAD-DURATION_THREE-WEEK',  // 3주일
  'NAVER_LOAD-DURATION_THREE-YEAR',  // 3년
  'NAVER_LOAD-DURATION_TWO-MONTH',   // 2개월
  'NAVER_LOAD-DURATION_TWO-WEEK',    // 2주일
  'NAVER_LOAD-DURATION_TWO-YEAR',    // 2년
] as const;

/**
 * naver - load-duration 타입.
 */
export type AclosetNaverLoadDurationCode = (typeof ACLOSET_NAVER_LOAD_DURATION_CODE_LIST)[number];

/**
 * naver - load-duration Short 코드 리스트.
 */
export const ACLOSET_NAVER_LOAD_DURATION_SHORT_CODE_LIST = [
  'one-month',   // 1개월
  'one-week',    // 1주일
  'one-year',    // 1년
  'six-month',   // 6개월
  'three-week',  // 3주일
  'three-year',  // 3년
  'two-month',   // 2개월
  'two-week',    // 2주일
  'two-year',    // 2년
] as const;

/**
 * naver - load-duration Short 코드 타입.
 */
export type AclosetNaverLoadDurationShortCode = (typeof ACLOSET_NAVER_LOAD_DURATION_SHORT_CODE_LIST)[number];

/**
 * naver - load-duration Short 코드 매핑.
 */
export const ACLOSET_NAVER_LOAD_DURATION_SHORT_CODE_MAP: Readonly<Record<AclosetNaverLoadDurationShortCode, AclosetNaverLoadDurationCode>> = {
  'one-month' : 'NAVER_LOAD-DURATION_ONE-MONTH',
  'one-week'  : 'NAVER_LOAD-DURATION_ONE-WEEK',
  'one-year'  : 'NAVER_LOAD-DURATION_ONE-YEAR',
  'six-month' : 'NAVER_LOAD-DURATION_SIX-MONTH',
  'three-week': 'NAVER_LOAD-DURATION_THREE-WEEK',
  'three-year': 'NAVER_LOAD-DURATION_THREE-YEAR',
  'two-month' : 'NAVER_LOAD-DURATION_TWO-MONTH',
  'two-week'  : 'NAVER_LOAD-DURATION_TWO-WEEK',
  'two-year'  : 'NAVER_LOAD-DURATION_TWO-YEAR',
};

/**
 * naver - load-duration Short 코드 역매핑.
 */
export const ACLOSET_NAVER_LOAD_DURATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNaverLoadDurationCode, AclosetNaverLoadDurationShortCode>> = {
  'NAVER_LOAD-DURATION_ONE-MONTH' : 'one-month',
  'NAVER_LOAD-DURATION_ONE-WEEK'  : 'one-week',
  'NAVER_LOAD-DURATION_ONE-YEAR'  : 'one-year',
  'NAVER_LOAD-DURATION_SIX-MONTH' : 'six-month',
  'NAVER_LOAD-DURATION_THREE-WEEK': 'three-week',
  'NAVER_LOAD-DURATION_THREE-YEAR': 'three-year',
  'NAVER_LOAD-DURATION_TWO-MONTH' : 'two-month',
  'NAVER_LOAD-DURATION_TWO-WEEK'  : 'two-week',
  'NAVER_LOAD-DURATION_TWO-YEAR'  : 'two-year',
};

// ************************************************************************************************

/**
 * naver - image-source 리스트.
 */
export const ACLOSET_NAVER_IMAGE_SOURCE_CODE_LIST = [
  'NAVER_IMAGE-SOURCE_ADDITIONAL',   // 추가 이미지
  'NAVER_IMAGE-SOURCE_DESCRIPTION',  // 상세 페이지
  'NAVER_IMAGE-SOURCE_MAIN',         // 대표 이미지
] as const;

/**
 * naver - image-source 타입.
 */
export type AclosetNaverImageSourceCode = (typeof ACLOSET_NAVER_IMAGE_SOURCE_CODE_LIST)[number];

/**
 * naver - image-source Short 코드 리스트.
 */
export const ACLOSET_NAVER_IMAGE_SOURCE_SHORT_CODE_LIST = [
  'additional',   // 추가 이미지
  'description',  // 상세 페이지
  'main',         // 대표 이미지
] as const;

/**
 * naver - image-source Short 코드 타입.
 */
export type AclosetNaverImageSourceShortCode = (typeof ACLOSET_NAVER_IMAGE_SOURCE_SHORT_CODE_LIST)[number];

/**
 * naver - image-source Short 코드 매핑.
 */
export const ACLOSET_NAVER_IMAGE_SOURCE_SHORT_CODE_MAP: Readonly<Record<AclosetNaverImageSourceShortCode, AclosetNaverImageSourceCode>> = {
  'additional' : 'NAVER_IMAGE-SOURCE_ADDITIONAL',
  'description': 'NAVER_IMAGE-SOURCE_DESCRIPTION',
  'main'       : 'NAVER_IMAGE-SOURCE_MAIN',
};

/**
 * naver - image-source Short 코드 역매핑.
 */
export const ACLOSET_NAVER_IMAGE_SOURCE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNaverImageSourceCode, AclosetNaverImageSourceShortCode>> = {
  'NAVER_IMAGE-SOURCE_ADDITIONAL' : 'additional',
  'NAVER_IMAGE-SOURCE_DESCRIPTION': 'description',
  'NAVER_IMAGE-SOURCE_MAIN'       : 'main',
};

// ************************************************************************************************

/**
 * notification - type 리스트.
 */
export const ACLOSET_NOTIFICATION_TYPE_CODE_LIST = [
  'NOTIFICATION_TYPE_DELETE-PLATFROM-ERROR',    // 플랫폼 연동해제 실패
  'NOTIFICATION_TYPE_DELETE-PLATFROM-SUCCESS',  // 플랫폼 연동해제 성공
] as const;

/**
 * notification - type 타입.
 */
export type AclosetNotificationTypeCode = (typeof ACLOSET_NOTIFICATION_TYPE_CODE_LIST)[number];

/**
 * notification - type Short 코드 리스트.
 */
export const ACLOSET_NOTIFICATION_TYPE_SHORT_CODE_LIST = [
  'delete-platfrom-error',    // 플랫폼 연동해제 실패
  'delete-platfrom-success',  // 플랫폼 연동해제 성공
] as const;

/**
 * notification - type Short 코드 타입.
 */
export type AclosetNotificationTypeShortCode = (typeof ACLOSET_NOTIFICATION_TYPE_SHORT_CODE_LIST)[number];

/**
 * notification - type Short 코드 매핑.
 */
export const ACLOSET_NOTIFICATION_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetNotificationTypeShortCode, AclosetNotificationTypeCode>> = {
  'delete-platfrom-error'  : 'NOTIFICATION_TYPE_DELETE-PLATFROM-ERROR',
  'delete-platfrom-success': 'NOTIFICATION_TYPE_DELETE-PLATFROM-SUCCESS',
};

/**
 * notification - type Short 코드 역매핑.
 */
export const ACLOSET_NOTIFICATION_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNotificationTypeCode, AclosetNotificationTypeShortCode>> = {
  'NOTIFICATION_TYPE_DELETE-PLATFROM-ERROR'  : 'delete-platfrom-error',
  'NOTIFICATION_TYPE_DELETE-PLATFROM-SUCCESS': 'delete-platfrom-success',
};

// ************************************************************************************************

/**
 * notification - sale-type 리스트.
 */
export const ACLOSET_NOTIFICATION_SALE_TYPE_CODE_LIST = [
  'NOTIFICATION_SALE-TYPE_DELETE-ERROR',             // 상품 삭제 실패
  'NOTIFICATION_SALE-TYPE_DELETE-SUCCESS',           // 상품 삭제 성공
  'NOTIFICATION_SALE-TYPE_MODIFY-DISCOUNT-ERROR',    // 가격 할인 실패
  'NOTIFICATION_SALE-TYPE_MODIFY-DISCOUNT-SUCCESS',  // 가격 할인 성공
  'NOTIFICATION_SALE-TYPE_OPEN-ERROR',               // 판매 개시 실패
  'NOTIFICATION_SALE-TYPE_OPEN-SUCCESS',             // 판매 개시 성공
  'NOTIFICATION_SALE-TYPE_REOPEN-ERROR',             // 판매 재개 실패
  'NOTIFICATION_SALE-TYPE_REOPEN-SUCCESS',           // 판매 재개 성공
  'NOTIFICATION_SALE-TYPE_STOP-ERROR',               // 판매 중지 실패
  'NOTIFICATION_SALE-TYPE_STOP-SUCCESS',             // 판매 중지 성공
] as const;

/**
 * notification - sale-type 타입.
 */
export type AclosetNotificationSaleTypeCode = (typeof ACLOSET_NOTIFICATION_SALE_TYPE_CODE_LIST)[number];

/**
 * notification - sale-type Short 코드 리스트.
 */
export const ACLOSET_NOTIFICATION_SALE_TYPE_SHORT_CODE_LIST = [
  'delete-error',             // 상품 삭제 실패
  'delete-success',           // 상품 삭제 성공
  'modify-discount-error',    // 가격 할인 실패
  'modify-discount-success',  // 가격 할인 성공
  'open-error',               // 판매 개시 실패
  'open-success',             // 판매 개시 성공
  'reopen-error',             // 판매 재개 실패
  'reopen-success',           // 판매 재개 성공
  'stop-error',               // 판매 중지 실패
  'stop-success',             // 판매 중지 성공
] as const;

/**
 * notification - sale-type Short 코드 타입.
 */
export type AclosetNotificationSaleTypeShortCode = (typeof ACLOSET_NOTIFICATION_SALE_TYPE_SHORT_CODE_LIST)[number];

/**
 * notification - sale-type Short 코드 매핑.
 */
export const ACLOSET_NOTIFICATION_SALE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetNotificationSaleTypeShortCode, AclosetNotificationSaleTypeCode>> = {
  'delete-error'           : 'NOTIFICATION_SALE-TYPE_DELETE-ERROR',
  'delete-success'         : 'NOTIFICATION_SALE-TYPE_DELETE-SUCCESS',
  'modify-discount-error'  : 'NOTIFICATION_SALE-TYPE_MODIFY-DISCOUNT-ERROR',
  'modify-discount-success': 'NOTIFICATION_SALE-TYPE_MODIFY-DISCOUNT-SUCCESS',
  'open-error'             : 'NOTIFICATION_SALE-TYPE_OPEN-ERROR',
  'open-success'           : 'NOTIFICATION_SALE-TYPE_OPEN-SUCCESS',
  'reopen-error'           : 'NOTIFICATION_SALE-TYPE_REOPEN-ERROR',
  'reopen-success'         : 'NOTIFICATION_SALE-TYPE_REOPEN-SUCCESS',
  'stop-error'             : 'NOTIFICATION_SALE-TYPE_STOP-ERROR',
  'stop-success'           : 'NOTIFICATION_SALE-TYPE_STOP-SUCCESS',
};

/**
 * notification - sale-type Short 코드 역매핑.
 */
export const ACLOSET_NOTIFICATION_SALE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNotificationSaleTypeCode, AclosetNotificationSaleTypeShortCode>> = {
  'NOTIFICATION_SALE-TYPE_DELETE-ERROR'           : 'delete-error',
  'NOTIFICATION_SALE-TYPE_DELETE-SUCCESS'         : 'delete-success',
  'NOTIFICATION_SALE-TYPE_MODIFY-DISCOUNT-ERROR'  : 'modify-discount-error',
  'NOTIFICATION_SALE-TYPE_MODIFY-DISCOUNT-SUCCESS': 'modify-discount-success',
  'NOTIFICATION_SALE-TYPE_OPEN-ERROR'             : 'open-error',
  'NOTIFICATION_SALE-TYPE_OPEN-SUCCESS'           : 'open-success',
  'NOTIFICATION_SALE-TYPE_REOPEN-ERROR'           : 'reopen-error',
  'NOTIFICATION_SALE-TYPE_REOPEN-SUCCESS'         : 'reopen-success',
  'NOTIFICATION_SALE-TYPE_STOP-ERROR'             : 'stop-error',
  'NOTIFICATION_SALE-TYPE_STOP-SUCCESS'           : 'stop-success',
};

// ************************************************************************************************

/**
 * notification - order-type 리스트.
 */
export const ACLOSET_NOTIFICATION_ORDER_TYPE_CODE_LIST = [
  'NOTIFICATION_ORDER-TYPE_APPROVE-CANCEL-ERROR',      // 주문 취소 승인 실패
  'NOTIFICATION_ORDER-TYPE_APPROVE-CANCEL-SUCCESS',    // 주문 취소 승인 성공
  'NOTIFICATION_ORDER-TYPE_CANCEL-ERROR',              // 주문 취소 실패
  'NOTIFICATION_ORDER-TYPE_CANCEL-SUCCESS',            // 주문 취소 성공
  'NOTIFICATION_ORDER-TYPE_CONFIRM-ERROR',             // 주문 확인 실패
  'NOTIFICATION_ORDER-TYPE_CONFIRM-PAYMENT-ERROR',     // 결제 확인 실패
  'NOTIFICATION_ORDER-TYPE_CONFIRM-PAYMENT-SUCCESS',   // 결제 확인 성공
  'NOTIFICATION_ORDER-TYPE_CONFIRM-SHIPPING-ERROR',    // 배송 확인 실패
  'NOTIFICATION_ORDER-TYPE_CONFIRM-SHIPPING-SUCCESS',  // 배송 확인 성공
  'NOTIFICATION_ORDER-TYPE_CONFIRM-SUCCESS',           // 주문 확인 성공
  'NOTIFICATION_ORDER-TYPE_INVOICE-REQUEST-ERROR',     // 운송장 번호 전송 실패
  'NOTIFICATION_ORDER-TYPE_INVOICE-REQUEST-SUCCESS',   // 운송장 번호 전송 성공
  'NOTIFICATION_ORDER-TYPE_REJECT-CANCEL-ERROR',       // 주문 취소 거부 실패
  'NOTIFICATION_ORDER-TYPE_REJECT-CANCEL-SUCCESS',     // 주문 취소 거부 성공
] as const;

/**
 * notification - order-type 타입.
 */
export type AclosetNotificationOrderTypeCode = (typeof ACLOSET_NOTIFICATION_ORDER_TYPE_CODE_LIST)[number];

/**
 * notification - order-type Short 코드 리스트.
 */
export const ACLOSET_NOTIFICATION_ORDER_TYPE_SHORT_CODE_LIST = [
  'approve-cancel-error',      // 주문 취소 승인 실패
  'approve-cancel-success',    // 주문 취소 승인 성공
  'cancel-error',              // 주문 취소 실패
  'cancel-success',            // 주문 취소 성공
  'confirm-error',             // 주문 확인 실패
  'confirm-payment-error',     // 결제 확인 실패
  'confirm-payment-success',   // 결제 확인 성공
  'confirm-shipping-error',    // 배송 확인 실패
  'confirm-shipping-success',  // 배송 확인 성공
  'confirm-success',           // 주문 확인 성공
  'invoice-request-error',     // 운송장 번호 전송 실패
  'invoice-request-success',   // 운송장 번호 전송 성공
  'reject-cancel-error',       // 주문 취소 거부 실패
  'reject-cancel-success',     // 주문 취소 거부 성공
] as const;

/**
 * notification - order-type Short 코드 타입.
 */
export type AclosetNotificationOrderTypeShortCode = (typeof ACLOSET_NOTIFICATION_ORDER_TYPE_SHORT_CODE_LIST)[number];

/**
 * notification - order-type Short 코드 매핑.
 */
export const ACLOSET_NOTIFICATION_ORDER_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetNotificationOrderTypeShortCode, AclosetNotificationOrderTypeCode>> = {
  'approve-cancel-error'    : 'NOTIFICATION_ORDER-TYPE_APPROVE-CANCEL-ERROR',
  'approve-cancel-success'  : 'NOTIFICATION_ORDER-TYPE_APPROVE-CANCEL-SUCCESS',
  'cancel-error'            : 'NOTIFICATION_ORDER-TYPE_CANCEL-ERROR',
  'cancel-success'          : 'NOTIFICATION_ORDER-TYPE_CANCEL-SUCCESS',
  'confirm-error'           : 'NOTIFICATION_ORDER-TYPE_CONFIRM-ERROR',
  'confirm-payment-error'   : 'NOTIFICATION_ORDER-TYPE_CONFIRM-PAYMENT-ERROR',
  'confirm-payment-success' : 'NOTIFICATION_ORDER-TYPE_CONFIRM-PAYMENT-SUCCESS',
  'confirm-shipping-error'  : 'NOTIFICATION_ORDER-TYPE_CONFIRM-SHIPPING-ERROR',
  'confirm-shipping-success': 'NOTIFICATION_ORDER-TYPE_CONFIRM-SHIPPING-SUCCESS',
  'confirm-success'         : 'NOTIFICATION_ORDER-TYPE_CONFIRM-SUCCESS',
  'invoice-request-error'   : 'NOTIFICATION_ORDER-TYPE_INVOICE-REQUEST-ERROR',
  'invoice-request-success' : 'NOTIFICATION_ORDER-TYPE_INVOICE-REQUEST-SUCCESS',
  'reject-cancel-error'     : 'NOTIFICATION_ORDER-TYPE_REJECT-CANCEL-ERROR',
  'reject-cancel-success'   : 'NOTIFICATION_ORDER-TYPE_REJECT-CANCEL-SUCCESS',
};

/**
 * notification - order-type Short 코드 역매핑.
 */
export const ACLOSET_NOTIFICATION_ORDER_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNotificationOrderTypeCode, AclosetNotificationOrderTypeShortCode>> = {
  'NOTIFICATION_ORDER-TYPE_APPROVE-CANCEL-ERROR'    : 'approve-cancel-error',
  'NOTIFICATION_ORDER-TYPE_APPROVE-CANCEL-SUCCESS'  : 'approve-cancel-success',
  'NOTIFICATION_ORDER-TYPE_CANCEL-ERROR'            : 'cancel-error',
  'NOTIFICATION_ORDER-TYPE_CANCEL-SUCCESS'          : 'cancel-success',
  'NOTIFICATION_ORDER-TYPE_CONFIRM-ERROR'           : 'confirm-error',
  'NOTIFICATION_ORDER-TYPE_CONFIRM-PAYMENT-ERROR'   : 'confirm-payment-error',
  'NOTIFICATION_ORDER-TYPE_CONFIRM-PAYMENT-SUCCESS' : 'confirm-payment-success',
  'NOTIFICATION_ORDER-TYPE_CONFIRM-SHIPPING-ERROR'  : 'confirm-shipping-error',
  'NOTIFICATION_ORDER-TYPE_CONFIRM-SHIPPING-SUCCESS': 'confirm-shipping-success',
  'NOTIFICATION_ORDER-TYPE_CONFIRM-SUCCESS'         : 'confirm-success',
  'NOTIFICATION_ORDER-TYPE_INVOICE-REQUEST-ERROR'   : 'invoice-request-error',
  'NOTIFICATION_ORDER-TYPE_INVOICE-REQUEST-SUCCESS' : 'invoice-request-success',
  'NOTIFICATION_ORDER-TYPE_REJECT-CANCEL-ERROR'     : 'reject-cancel-error',
  'NOTIFICATION_ORDER-TYPE_REJECT-CANCEL-SUCCESS'   : 'reject-cancel-success',
};

// ************************************************************************************************

/**
 * notification - acloset-order-type 리스트.
 */
export const ACLOSET_NOTIFICATION_ACLOSET_ORDER_TYPE_CODE_LIST = [
  'NOTIFICATION_ACLOSET-ORDER-TYPE_AUTO-CANCEL',           // 자동 취소
  'NOTIFICATION_ACLOSET-ORDER-TYPE_BUYER-CANCEL',          // 구매자 취소
  'NOTIFICATION_ACLOSET-ORDER-TYPE_BUYER-RETURN-REQUEST',  // 구매자 반품 요청
  'NOTIFICATION_ACLOSET-ORDER-TYPE_DAILY',                 // 일일 주문 요약
  'NOTIFICATION_ACLOSET-ORDER-TYPE_OFFER',                 // 할인 요청 주문
  'NOTIFICATION_ACLOSET-ORDER-TYPE_ORDER',                 // 일반 주문 (상품준비중)
] as const;

/**
 * notification - acloset-order-type 타입.
 */
export type AclosetNotificationAclosetOrderTypeCode = (typeof ACLOSET_NOTIFICATION_ACLOSET_ORDER_TYPE_CODE_LIST)[number];

/**
 * notification - acloset-order-type Short 코드 리스트.
 */
export const ACLOSET_NOTIFICATION_ACLOSET_ORDER_TYPE_SHORT_CODE_LIST = [
  'auto-cancel',           // 자동 취소
  'buyer-cancel',          // 구매자 취소
  'buyer-return-request',  // 구매자 반품 요청
  'daily',                 // 일일 주문 요약
  'offer',                 // 할인 요청 주문
  'order',                 // 일반 주문 (상품준비중)
] as const;

/**
 * notification - acloset-order-type Short 코드 타입.
 */
export type AclosetNotificationAclosetOrderTypeShortCode = (typeof ACLOSET_NOTIFICATION_ACLOSET_ORDER_TYPE_SHORT_CODE_LIST)[number];

/**
 * notification - acloset-order-type Short 코드 매핑.
 */
export const ACLOSET_NOTIFICATION_ACLOSET_ORDER_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetNotificationAclosetOrderTypeShortCode, AclosetNotificationAclosetOrderTypeCode>> = {
  'auto-cancel'         : 'NOTIFICATION_ACLOSET-ORDER-TYPE_AUTO-CANCEL',
  'buyer-cancel'        : 'NOTIFICATION_ACLOSET-ORDER-TYPE_BUYER-CANCEL',
  'buyer-return-request': 'NOTIFICATION_ACLOSET-ORDER-TYPE_BUYER-RETURN-REQUEST',
  'daily'               : 'NOTIFICATION_ACLOSET-ORDER-TYPE_DAILY',
  'offer'               : 'NOTIFICATION_ACLOSET-ORDER-TYPE_OFFER',
  'order'               : 'NOTIFICATION_ACLOSET-ORDER-TYPE_ORDER',
};

/**
 * notification - acloset-order-type Short 코드 역매핑.
 */
export const ACLOSET_NOTIFICATION_ACLOSET_ORDER_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetNotificationAclosetOrderTypeCode, AclosetNotificationAclosetOrderTypeShortCode>> = {
  'NOTIFICATION_ACLOSET-ORDER-TYPE_AUTO-CANCEL'         : 'auto-cancel',
  'NOTIFICATION_ACLOSET-ORDER-TYPE_BUYER-CANCEL'        : 'buyer-cancel',
  'NOTIFICATION_ACLOSET-ORDER-TYPE_BUYER-RETURN-REQUEST': 'buyer-return-request',
  'NOTIFICATION_ACLOSET-ORDER-TYPE_DAILY'               : 'daily',
  'NOTIFICATION_ACLOSET-ORDER-TYPE_OFFER'               : 'offer',
  'NOTIFICATION_ACLOSET-ORDER-TYPE_ORDER'               : 'order',
};

// ************************************************************************************************

/**
 * order - status 리스트.
 */
export const ACLOSET_ORDER_STATUS_CODE_LIST = [
  'ORDER_STATUS_EXCHANGE-REQUEST',      // 교환 요청
  'ORDER_STATUS_ORDER-CANCEL',          // 주문 취소
  'ORDER_STATUS_PAYMENT-DONE',          // 결제 완료
  'ORDER_STATUS_PAYMENT-PENDING',       // 결제 대기
  'ORDER_STATUS_PURCHASE-DONE',         // 구매 확정
  'ORDER_STATUS_RETURN-REQUEST',        // 반품 요청
  'ORDER_STATUS_SHIPPING-DONE',         // 배송 완료
  'ORDER_STATUS_SHIPPING-IN-PROGRESS',  // 배송 중
  'ORDER_STATUS_SHIPPING-PENDING',      // 배송 준비 중
] as const;

/**
 * order - status 타입.
 */
export type AclosetOrderStatusCode = (typeof ACLOSET_ORDER_STATUS_CODE_LIST)[number];

/**
 * order - status Short 코드 리스트.
 */
export const ACLOSET_ORDER_STATUS_SHORT_CODE_LIST = [
  'exchange-request',      // 교환 요청
  'order-cancel',          // 주문 취소
  'payment-done',          // 결제 완료
  'payment-pending',       // 결제 대기
  'purchase-done',         // 구매 확정
  'return-request',        // 반품 요청
  'shipping-done',         // 배송 완료
  'shipping-in-progress',  // 배송 중
  'shipping-pending',      // 배송 준비 중
] as const;

/**
 * order - status Short 코드 타입.
 */
export type AclosetOrderStatusShortCode = (typeof ACLOSET_ORDER_STATUS_SHORT_CODE_LIST)[number];

/**
 * order - status Short 코드 매핑.
 */
export const ACLOSET_ORDER_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetOrderStatusShortCode, AclosetOrderStatusCode>> = {
  'exchange-request'    : 'ORDER_STATUS_EXCHANGE-REQUEST',
  'order-cancel'        : 'ORDER_STATUS_ORDER-CANCEL',
  'payment-done'        : 'ORDER_STATUS_PAYMENT-DONE',
  'payment-pending'     : 'ORDER_STATUS_PAYMENT-PENDING',
  'purchase-done'       : 'ORDER_STATUS_PURCHASE-DONE',
  'return-request'      : 'ORDER_STATUS_RETURN-REQUEST',
  'shipping-done'       : 'ORDER_STATUS_SHIPPING-DONE',
  'shipping-in-progress': 'ORDER_STATUS_SHIPPING-IN-PROGRESS',
  'shipping-pending'    : 'ORDER_STATUS_SHIPPING-PENDING',
};

/**
 * order - status Short 코드 역매핑.
 */
export const ACLOSET_ORDER_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetOrderStatusCode, AclosetOrderStatusShortCode>> = {
  'ORDER_STATUS_EXCHANGE-REQUEST'    : 'exchange-request',
  'ORDER_STATUS_ORDER-CANCEL'        : 'order-cancel',
  'ORDER_STATUS_PAYMENT-DONE'        : 'payment-done',
  'ORDER_STATUS_PAYMENT-PENDING'     : 'payment-pending',
  'ORDER_STATUS_PURCHASE-DONE'       : 'purchase-done',
  'ORDER_STATUS_RETURN-REQUEST'      : 'return-request',
  'ORDER_STATUS_SHIPPING-DONE'       : 'shipping-done',
  'ORDER_STATUS_SHIPPING-IN-PROGRESS': 'shipping-in-progress',
  'ORDER_STATUS_SHIPPING-PENDING'    : 'shipping-pending',
};

// ************************************************************************************************

/**
 * order - process-status 리스트.
 */
export const ACLOSET_ORDER_PROCESS_STATUS_CODE_LIST = [
  'ORDER_PROCESS-STATUS_CANCEL-IDLE',  // 미승인
  'ORDER_PROCESS-STATUS_CANCELED',     // 취소 완료
  'ORDER_PROCESS-STATUS_DONE',         // 완료
  'ORDER_PROCESS-STATUS_IDLE',         // 미완료
] as const;

/**
 * order - process-status 타입.
 */
export type AclosetOrderProcessStatusCode = (typeof ACLOSET_ORDER_PROCESS_STATUS_CODE_LIST)[number];

/**
 * order - process-status Short 코드 리스트.
 */
export const ACLOSET_ORDER_PROCESS_STATUS_SHORT_CODE_LIST = [
  'cancel-idle',  // 미승인
  'canceled',     // 취소 완료
  'done',         // 완료
  'idle',         // 미완료
] as const;

/**
 * order - process-status Short 코드 타입.
 */
export type AclosetOrderProcessStatusShortCode = (typeof ACLOSET_ORDER_PROCESS_STATUS_SHORT_CODE_LIST)[number];

/**
 * order - process-status Short 코드 매핑.
 */
export const ACLOSET_ORDER_PROCESS_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetOrderProcessStatusShortCode, AclosetOrderProcessStatusCode>> = {
  'cancel-idle': 'ORDER_PROCESS-STATUS_CANCEL-IDLE',
  'canceled'   : 'ORDER_PROCESS-STATUS_CANCELED',
  'done'       : 'ORDER_PROCESS-STATUS_DONE',
  'idle'       : 'ORDER_PROCESS-STATUS_IDLE',
};

/**
 * order - process-status Short 코드 역매핑.
 */
export const ACLOSET_ORDER_PROCESS_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetOrderProcessStatusCode, AclosetOrderProcessStatusShortCode>> = {
  'ORDER_PROCESS-STATUS_CANCEL-IDLE': 'cancel-idle',
  'ORDER_PROCESS-STATUS_CANCELED'   : 'canceled',
  'ORDER_PROCESS-STATUS_DONE'       : 'done',
  'ORDER_PROCESS-STATUS_IDLE'       : 'idle',
};

// ************************************************************************************************

/**
 * order - payment-type 리스트.
 */
export const ACLOSET_ORDER_PAYMENT_TYPE_CODE_LIST = [
  'ORDER_PAYMENT-TYPE_ONLINE',  // 온라인 결제
  'ORDER_PAYMENT-TYPE_STORE',   // 매장 결제
] as const;

/**
 * order - payment-type 타입.
 */
export type AclosetOrderPaymentTypeCode = (typeof ACLOSET_ORDER_PAYMENT_TYPE_CODE_LIST)[number];

/**
 * order - payment-type Short 코드 리스트.
 */
export const ACLOSET_ORDER_PAYMENT_TYPE_SHORT_CODE_LIST = [
  'online',  // 온라인 결제
  'store',   // 매장 결제
] as const;

/**
 * order - payment-type Short 코드 타입.
 */
export type AclosetOrderPaymentTypeShortCode = (typeof ACLOSET_ORDER_PAYMENT_TYPE_SHORT_CODE_LIST)[number];

/**
 * order - payment-type Short 코드 매핑.
 */
export const ACLOSET_ORDER_PAYMENT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetOrderPaymentTypeShortCode, AclosetOrderPaymentTypeCode>> = {
  'online': 'ORDER_PAYMENT-TYPE_ONLINE',
  'store' : 'ORDER_PAYMENT-TYPE_STORE',
};

/**
 * order - payment-type Short 코드 역매핑.
 */
export const ACLOSET_ORDER_PAYMENT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetOrderPaymentTypeCode, AclosetOrderPaymentTypeShortCode>> = {
  'ORDER_PAYMENT-TYPE_ONLINE': 'online',
  'ORDER_PAYMENT-TYPE_STORE' : 'store',
};

// ************************************************************************************************

/**
 * order - operation 리스트.
 */
export const ACLOSET_ORDER_OPERATION_CODE_LIST = [
  'ORDER_OPERATION_FAILED',       // 처리 실패
  'ORDER_OPERATION_IDLE',         // 처리 대기
  'ORDER_OPERATION_IN-PROGRESS',  // 처리 중
] as const;

/**
 * order - operation 타입.
 */
export type AclosetOrderOperationCode = (typeof ACLOSET_ORDER_OPERATION_CODE_LIST)[number];

/**
 * order - operation Short 코드 리스트.
 */
export const ACLOSET_ORDER_OPERATION_SHORT_CODE_LIST = [
  'failed',       // 처리 실패
  'idle',         // 처리 대기
  'in-progress',  // 처리 중
] as const;

/**
 * order - operation Short 코드 타입.
 */
export type AclosetOrderOperationShortCode = (typeof ACLOSET_ORDER_OPERATION_SHORT_CODE_LIST)[number];

/**
 * order - operation Short 코드 매핑.
 */
export const ACLOSET_ORDER_OPERATION_SHORT_CODE_MAP: Readonly<Record<AclosetOrderOperationShortCode, AclosetOrderOperationCode>> = {
  'failed'     : 'ORDER_OPERATION_FAILED',
  'idle'       : 'ORDER_OPERATION_IDLE',
  'in-progress': 'ORDER_OPERATION_IN-PROGRESS',
};

/**
 * order - operation Short 코드 역매핑.
 */
export const ACLOSET_ORDER_OPERATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetOrderOperationCode, AclosetOrderOperationShortCode>> = {
  'ORDER_OPERATION_FAILED'     : 'failed',
  'ORDER_OPERATION_IDLE'       : 'idle',
  'ORDER_OPERATION_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * order - cancel-type 리스트.
 */
export const ACLOSET_ORDER_CANCEL_TYPE_CODE_LIST = [
  'ORDER_CANCEL-TYPE_NON-PAYMENT',  // 결제대기(미결제취소)
  'ORDER_CANCEL-TYPE_PAYMENT',      // 결제완료(거래취소)
  'ORDER_CANCEL-TYPE_SHIPPING',     // 배송준비중(취소진행중)
] as const;

/**
 * order - cancel-type 타입.
 */
export type AclosetOrderCancelTypeCode = (typeof ACLOSET_ORDER_CANCEL_TYPE_CODE_LIST)[number];

/**
 * order - cancel-type Short 코드 리스트.
 */
export const ACLOSET_ORDER_CANCEL_TYPE_SHORT_CODE_LIST = [
  'non-payment',  // 결제대기(미결제취소)
  'payment',      // 결제완료(거래취소)
  'shipping',     // 배송준비중(취소진행중)
] as const;

/**
 * order - cancel-type Short 코드 타입.
 */
export type AclosetOrderCancelTypeShortCode = (typeof ACLOSET_ORDER_CANCEL_TYPE_SHORT_CODE_LIST)[number];

/**
 * order - cancel-type Short 코드 매핑.
 */
export const ACLOSET_ORDER_CANCEL_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetOrderCancelTypeShortCode, AclosetOrderCancelTypeCode>> = {
  'non-payment': 'ORDER_CANCEL-TYPE_NON-PAYMENT',
  'payment'    : 'ORDER_CANCEL-TYPE_PAYMENT',
  'shipping'   : 'ORDER_CANCEL-TYPE_SHIPPING',
};

/**
 * order - cancel-type Short 코드 역매핑.
 */
export const ACLOSET_ORDER_CANCEL_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetOrderCancelTypeCode, AclosetOrderCancelTypeShortCode>> = {
  'ORDER_CANCEL-TYPE_NON-PAYMENT': 'non-payment',
  'ORDER_CANCEL-TYPE_PAYMENT'    : 'payment',
  'ORDER_CANCEL-TYPE_SHIPPING'   : 'shipping',
};

// ************************************************************************************************

/**
 * order - acloset-cancel-type 리스트.
 */
export const ACLOSET_ORDER_ACLOSET_CANCEL_TYPE_CODE_LIST = [
  'ORDER_ACLOSET-CANCEL-TYPE_BUYER',      // 구매자 취소
  'ORDER_ACLOSET-CANCEL-TYPE_SCHEDULER',  // 시간 자동 취소
  'ORDER_ACLOSET-CANCEL-TYPE_SELLER',     // 판매자 거절
] as const;

/**
 * order - acloset-cancel-type 타입.
 */
export type AclosetOrderAclosetCancelTypeCode = (typeof ACLOSET_ORDER_ACLOSET_CANCEL_TYPE_CODE_LIST)[number];

/**
 * order - acloset-cancel-type Short 코드 리스트.
 */
export const ACLOSET_ORDER_ACLOSET_CANCEL_TYPE_SHORT_CODE_LIST = [
  'buyer',      // 구매자 취소
  'scheduler',  // 시간 자동 취소
  'seller',     // 판매자 거절
] as const;

/**
 * order - acloset-cancel-type Short 코드 타입.
 */
export type AclosetOrderAclosetCancelTypeShortCode = (typeof ACLOSET_ORDER_ACLOSET_CANCEL_TYPE_SHORT_CODE_LIST)[number];

/**
 * order - acloset-cancel-type Short 코드 매핑.
 */
export const ACLOSET_ORDER_ACLOSET_CANCEL_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetOrderAclosetCancelTypeShortCode, AclosetOrderAclosetCancelTypeCode>> = {
  'buyer'    : 'ORDER_ACLOSET-CANCEL-TYPE_BUYER',
  'scheduler': 'ORDER_ACLOSET-CANCEL-TYPE_SCHEDULER',
  'seller'   : 'ORDER_ACLOSET-CANCEL-TYPE_SELLER',
};

/**
 * order - acloset-cancel-type Short 코드 역매핑.
 */
export const ACLOSET_ORDER_ACLOSET_CANCEL_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetOrderAclosetCancelTypeCode, AclosetOrderAclosetCancelTypeShortCode>> = {
  'ORDER_ACLOSET-CANCEL-TYPE_BUYER'    : 'buyer',
  'ORDER_ACLOSET-CANCEL-TYPE_SCHEDULER': 'scheduler',
  'ORDER_ACLOSET-CANCEL-TYPE_SELLER'   : 'seller',
};

// ************************************************************************************************

/**
 * payment - type 리스트.
 */
export const ACLOSET_PAYMENT_TYPE_CODE_LIST = [
  'PAYMENT_TYPE_RETRY-MANUAL',  // 수동 재결제 (유저 결제 재시도)
  'PAYMENT_TYPE_RETRY-NORMAL',  // 일반 재결제
] as const;

/**
 * payment - type 타입.
 */
export type AclosetPaymentTypeCode = (typeof ACLOSET_PAYMENT_TYPE_CODE_LIST)[number];

/**
 * payment - type Short 코드 리스트.
 */
export const ACLOSET_PAYMENT_TYPE_SHORT_CODE_LIST = [
  'retry-manual',  // 수동 재결제 (유저 결제 재시도)
  'retry-normal',  // 일반 재결제
] as const;

/**
 * payment - type Short 코드 타입.
 */
export type AclosetPaymentTypeShortCode = (typeof ACLOSET_PAYMENT_TYPE_SHORT_CODE_LIST)[number];

/**
 * payment - type Short 코드 매핑.
 */
export const ACLOSET_PAYMENT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetPaymentTypeShortCode, AclosetPaymentTypeCode>> = {
  'retry-manual': 'PAYMENT_TYPE_RETRY-MANUAL',
  'retry-normal': 'PAYMENT_TYPE_RETRY-NORMAL',
};

/**
 * payment - type Short 코드 역매핑.
 */
export const ACLOSET_PAYMENT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetPaymentTypeCode, AclosetPaymentTypeShortCode>> = {
  'PAYMENT_TYPE_RETRY-MANUAL': 'retry-manual',
  'PAYMENT_TYPE_RETRY-NORMAL': 'retry-normal',
};

// ************************************************************************************************

/**
 * payment - status 리스트.
 */
export const ACLOSET_PAYMENT_STATUS_CODE_LIST = [
  'PAYMENT_STATUS_FAILED',   // 결제 실패
  'PAYMENT_STATUS_PENDING',  // 결제 대기
  'PAYMENT_STATUS_SUCCESS',  // 결제 완료
] as const;

/**
 * payment - status 타입.
 */
export type AclosetPaymentStatusCode = (typeof ACLOSET_PAYMENT_STATUS_CODE_LIST)[number];

/**
 * payment - status Short 코드 리스트.
 */
export const ACLOSET_PAYMENT_STATUS_SHORT_CODE_LIST = [
  'failed',   // 결제 실패
  'pending',  // 결제 대기
  'success',  // 결제 완료
] as const;

/**
 * payment - status Short 코드 타입.
 */
export type AclosetPaymentStatusShortCode = (typeof ACLOSET_PAYMENT_STATUS_SHORT_CODE_LIST)[number];

/**
 * payment - status Short 코드 매핑.
 */
export const ACLOSET_PAYMENT_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetPaymentStatusShortCode, AclosetPaymentStatusCode>> = {
  'failed' : 'PAYMENT_STATUS_FAILED',
  'pending': 'PAYMENT_STATUS_PENDING',
  'success': 'PAYMENT_STATUS_SUCCESS',
};

/**
 * payment - status Short 코드 역매핑.
 */
export const ACLOSET_PAYMENT_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetPaymentStatusCode, AclosetPaymentStatusShortCode>> = {
  'PAYMENT_STATUS_FAILED' : 'failed',
  'PAYMENT_STATUS_PENDING': 'pending',
  'PAYMENT_STATUS_SUCCESS': 'success',
};

// ************************************************************************************************

/**
 * plan - code 리스트.
 */
export const ACLOSET_PLAN_CODE_CODE_LIST = [
  'PLAN_CODE_BASIC',    // 기본 플랜
  'PLAN_CODE_FREE',     // 무료 플랜
  'PLAN_CODE_PREMIUM',  // 프리미엄 플랜
] as const;

/**
 * plan - code 타입.
 */
export type AclosetPlanCodeCode = (typeof ACLOSET_PLAN_CODE_CODE_LIST)[number];

/**
 * plan - code Short 코드 리스트.
 */
export const ACLOSET_PLAN_CODE_SHORT_CODE_LIST = [
  'basic',    // 기본 플랜
  'free',     // 무료 플랜
  'premium',  // 프리미엄 플랜
] as const;

/**
 * plan - code Short 코드 타입.
 */
export type AclosetPlanCodeShortCode = (typeof ACLOSET_PLAN_CODE_SHORT_CODE_LIST)[number];

/**
 * plan - code Short 코드 매핑.
 */
export const ACLOSET_PLAN_CODE_SHORT_CODE_MAP: Readonly<Record<AclosetPlanCodeShortCode, AclosetPlanCodeCode>> = {
  'basic'  : 'PLAN_CODE_BASIC',
  'free'   : 'PLAN_CODE_FREE',
  'premium': 'PLAN_CODE_PREMIUM',
};

/**
 * plan - code Short 코드 역매핑.
 */
export const ACLOSET_PLAN_CODE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetPlanCodeCode, AclosetPlanCodeShortCode>> = {
  'PLAN_CODE_BASIC'  : 'basic',
  'PLAN_CODE_FREE'   : 'free',
  'PLAN_CODE_PREMIUM': 'premium',
};

// ************************************************************************************************

/**
 * plan - action 리스트.
 */
export const ACLOSET_PLAN_ACTION_CODE_LIST = [
  'PLAN_ACTION_ADJUST-IMAGE-SIZE',                       // 이미지 크기 조정
  'PLAN_ACTION_AUTO-FLUIDIFY-IMAGE',                     // 자동 픽셀 유동화
  'PLAN_ACTION_AUTO-GENERATE-DETAIL-CUT',                // 디테일컷 자동 생성
  'PLAN_ACTION_AUTO-GENERATE-MERGED-IMAGE',              // 통합 이미지 자동 생성
  'PLAN_ACTION_AUTO-INPUT-PRODUCT-INFORMATION',          // 상품 정보 자동 입력
  'PLAN_ACTION_AUTO-MEASURE-SIZE',                       // 치수 자동 측정
  'PLAN_ACTION_AUTO-REMOVE-BACKGROUND',                  // 자동 배경 제거
  'PLAN_ACTION_AUTO-ROTATE-IMAGE',                       // 자동 수평 보정
  'PLAN_ACTION_BATCH-CALIBRATE-IMAGE',                   // 이미지 일괄 보정
  'PLAN_ACTION_BATCH-INPUT-INVOICE',                     // 송장번호 일괄 동시 입력
  'PLAN_ACTION_CONTACTING-AND-RESPONDING-TO-SOLUTIONS',  // 솔루션 문의 및 대응
  'PLAN_ACTION_CUSTOM-GENERATE-DETAIL-CUT',              // 디테일컷 직접 만들기
  'PLAN_ACTION_DECORATE-SHOPPING-MALL-DETAIL-PAGE',      // 쇼핑몰 상세페이지 꾸미기
  'PLAN_ACTION_DOWNLOAD-AND-MANAGE-EXCEL',               // 엑셀 다운로드 및 관리
  'PLAN_ACTION_DOWNLOAD-BUNJANG',                        // 번개장터 엑셀 다운로드
  'PLAN_ACTION_EDIT-IMAGE',                              // 이미지 편집
  'PLAN_ACTION_FILTER-IMAGE',                            // 이미지 필터 설정
  'PLAN_ACTION_FLUIDIFY-IMAGE',                          // 이미지 픽셀 유동화
  'PLAN_ACTION_HANDLE-CLOUD-FILE',                       // 클라우드 기반 파일 처리
  'PLAN_ACTION_MANAGE-BRAND',                            // 브랜드 관리
  'PLAN_ACTION_MANAGE-OFFLINE-SALE',                     // 오프라인 판매 관리
  'PLAN_ACTION_MANAGE-PRODUCT-ORDER',                    // 상품 주문 통합 관리
  'PLAN_ACTION_ON-SITE-INSTALLATION-AND-TRAINING',       // 방문 설치 및 교육
  'PLAN_ACTION_ONE-CLICK-EXTEND-SALE-PLATFORM',          // 원클릭 판매 플랫폼 자동 확장
  'PLAN_ACTION_OPEN-SALE-CAFE24',                        // 카페24 판매 개시
  'PLAN_ACTION_OPEN-SALE-INSTAGRAM',                     // 인스타그램 판매 개시
  'PLAN_ACTION_OPEN-SALE-NAVER',                         // 네이버 스마트스토어 판매 개시
  'PLAN_ACTION_OPEN-SALE-SECONDSOLD',                    // 세컨솔드 판매 개시
  'PLAN_ACTION_RESIZE-IMAGE',                            // 이미지 비율 설정
  'PLAN_ACTION_SYNC-SALE-PLATFORM',                      // 판매 플랫폼 연동
  'PLAN_ACTION_SYNCHRONIZE-ON-OFF-STOCK',                // 온/오프라인 재고 연동
  'PLAN_ACTION_SYNCHRONIZE-STOCK',                       // 온라인 재고연동
  'PLAN_ACTION_TELEPHONE-OR-REMOTE-CONSULTATION',        // 전화 또는 원격상담
  'PLAN_ACTION_UPLOAD-PRODUCT-LIMITATION',               // 업로드 가능 상품 수
] as const;

/**
 * plan - action 타입.
 */
export type AclosetPlanActionCode = (typeof ACLOSET_PLAN_ACTION_CODE_LIST)[number];

/**
 * plan - action Short 코드 리스트.
 */
export const ACLOSET_PLAN_ACTION_SHORT_CODE_LIST = [
  'adjust-image-size',                       // 이미지 크기 조정
  'auto-fluidify-image',                     // 자동 픽셀 유동화
  'auto-generate-detail-cut',                // 디테일컷 자동 생성
  'auto-generate-merged-image',              // 통합 이미지 자동 생성
  'auto-input-product-information',          // 상품 정보 자동 입력
  'auto-measure-size',                       // 치수 자동 측정
  'auto-remove-background',                  // 자동 배경 제거
  'auto-rotate-image',                       // 자동 수평 보정
  'batch-calibrate-image',                   // 이미지 일괄 보정
  'batch-input-invoice',                     // 송장번호 일괄 동시 입력
  'contacting-and-responding-to-solutions',  // 솔루션 문의 및 대응
  'custom-generate-detail-cut',              // 디테일컷 직접 만들기
  'decorate-shopping-mall-detail-page',      // 쇼핑몰 상세페이지 꾸미기
  'download-and-manage-excel',               // 엑셀 다운로드 및 관리
  'download-bunjang',                        // 번개장터 엑셀 다운로드
  'edit-image',                              // 이미지 편집
  'filter-image',                            // 이미지 필터 설정
  'fluidify-image',                          // 이미지 픽셀 유동화
  'handle-cloud-file',                       // 클라우드 기반 파일 처리
  'manage-brand',                            // 브랜드 관리
  'manage-offline-sale',                     // 오프라인 판매 관리
  'manage-product-order',                    // 상품 주문 통합 관리
  'on-site-installation-and-training',       // 방문 설치 및 교육
  'one-click-extend-sale-platform',          // 원클릭 판매 플랫폼 자동 확장
  'open-sale-cafe24',                        // 카페24 판매 개시
  'open-sale-instagram',                     // 인스타그램 판매 개시
  'open-sale-naver',                         // 네이버 스마트스토어 판매 개시
  'open-sale-secondsold',                    // 세컨솔드 판매 개시
  'resize-image',                            // 이미지 비율 설정
  'sync-sale-platform',                      // 판매 플랫폼 연동
  'synchronize-on-off-stock',                // 온/오프라인 재고 연동
  'synchronize-stock',                       // 온라인 재고연동
  'telephone-or-remote-consultation',        // 전화 또는 원격상담
  'upload-product-limitation',               // 업로드 가능 상품 수
] as const;

/**
 * plan - action Short 코드 타입.
 */
export type AclosetPlanActionShortCode = (typeof ACLOSET_PLAN_ACTION_SHORT_CODE_LIST)[number];

/**
 * plan - action Short 코드 매핑.
 */
export const ACLOSET_PLAN_ACTION_SHORT_CODE_MAP: Readonly<Record<AclosetPlanActionShortCode, AclosetPlanActionCode>> = {
  'adjust-image-size'                     : 'PLAN_ACTION_ADJUST-IMAGE-SIZE',
  'auto-fluidify-image'                   : 'PLAN_ACTION_AUTO-FLUIDIFY-IMAGE',
  'auto-generate-detail-cut'              : 'PLAN_ACTION_AUTO-GENERATE-DETAIL-CUT',
  'auto-generate-merged-image'            : 'PLAN_ACTION_AUTO-GENERATE-MERGED-IMAGE',
  'auto-input-product-information'        : 'PLAN_ACTION_AUTO-INPUT-PRODUCT-INFORMATION',
  'auto-measure-size'                     : 'PLAN_ACTION_AUTO-MEASURE-SIZE',
  'auto-remove-background'                : 'PLAN_ACTION_AUTO-REMOVE-BACKGROUND',
  'auto-rotate-image'                     : 'PLAN_ACTION_AUTO-ROTATE-IMAGE',
  'batch-calibrate-image'                 : 'PLAN_ACTION_BATCH-CALIBRATE-IMAGE',
  'batch-input-invoice'                   : 'PLAN_ACTION_BATCH-INPUT-INVOICE',
  'contacting-and-responding-to-solutions': 'PLAN_ACTION_CONTACTING-AND-RESPONDING-TO-SOLUTIONS',
  'custom-generate-detail-cut'            : 'PLAN_ACTION_CUSTOM-GENERATE-DETAIL-CUT',
  'decorate-shopping-mall-detail-page'    : 'PLAN_ACTION_DECORATE-SHOPPING-MALL-DETAIL-PAGE',
  'download-and-manage-excel'             : 'PLAN_ACTION_DOWNLOAD-AND-MANAGE-EXCEL',
  'download-bunjang'                      : 'PLAN_ACTION_DOWNLOAD-BUNJANG',
  'edit-image'                            : 'PLAN_ACTION_EDIT-IMAGE',
  'filter-image'                          : 'PLAN_ACTION_FILTER-IMAGE',
  'fluidify-image'                        : 'PLAN_ACTION_FLUIDIFY-IMAGE',
  'handle-cloud-file'                     : 'PLAN_ACTION_HANDLE-CLOUD-FILE',
  'manage-brand'                          : 'PLAN_ACTION_MANAGE-BRAND',
  'manage-offline-sale'                   : 'PLAN_ACTION_MANAGE-OFFLINE-SALE',
  'manage-product-order'                  : 'PLAN_ACTION_MANAGE-PRODUCT-ORDER',
  'on-site-installation-and-training'     : 'PLAN_ACTION_ON-SITE-INSTALLATION-AND-TRAINING',
  'one-click-extend-sale-platform'        : 'PLAN_ACTION_ONE-CLICK-EXTEND-SALE-PLATFORM',
  'open-sale-cafe24'                      : 'PLAN_ACTION_OPEN-SALE-CAFE24',
  'open-sale-instagram'                   : 'PLAN_ACTION_OPEN-SALE-INSTAGRAM',
  'open-sale-naver'                       : 'PLAN_ACTION_OPEN-SALE-NAVER',
  'open-sale-secondsold'                  : 'PLAN_ACTION_OPEN-SALE-SECONDSOLD',
  'resize-image'                          : 'PLAN_ACTION_RESIZE-IMAGE',
  'sync-sale-platform'                    : 'PLAN_ACTION_SYNC-SALE-PLATFORM',
  'synchronize-on-off-stock'              : 'PLAN_ACTION_SYNCHRONIZE-ON-OFF-STOCK',
  'synchronize-stock'                     : 'PLAN_ACTION_SYNCHRONIZE-STOCK',
  'telephone-or-remote-consultation'      : 'PLAN_ACTION_TELEPHONE-OR-REMOTE-CONSULTATION',
  'upload-product-limitation'             : 'PLAN_ACTION_UPLOAD-PRODUCT-LIMITATION',
};

/**
 * plan - action Short 코드 역매핑.
 */
export const ACLOSET_PLAN_ACTION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetPlanActionCode, AclosetPlanActionShortCode>> = {
  'PLAN_ACTION_ADJUST-IMAGE-SIZE'                     : 'adjust-image-size',
  'PLAN_ACTION_AUTO-FLUIDIFY-IMAGE'                   : 'auto-fluidify-image',
  'PLAN_ACTION_AUTO-GENERATE-DETAIL-CUT'              : 'auto-generate-detail-cut',
  'PLAN_ACTION_AUTO-GENERATE-MERGED-IMAGE'            : 'auto-generate-merged-image',
  'PLAN_ACTION_AUTO-INPUT-PRODUCT-INFORMATION'        : 'auto-input-product-information',
  'PLAN_ACTION_AUTO-MEASURE-SIZE'                     : 'auto-measure-size',
  'PLAN_ACTION_AUTO-REMOVE-BACKGROUND'                : 'auto-remove-background',
  'PLAN_ACTION_AUTO-ROTATE-IMAGE'                     : 'auto-rotate-image',
  'PLAN_ACTION_BATCH-CALIBRATE-IMAGE'                 : 'batch-calibrate-image',
  'PLAN_ACTION_BATCH-INPUT-INVOICE'                   : 'batch-input-invoice',
  'PLAN_ACTION_CONTACTING-AND-RESPONDING-TO-SOLUTIONS': 'contacting-and-responding-to-solutions',
  'PLAN_ACTION_CUSTOM-GENERATE-DETAIL-CUT'            : 'custom-generate-detail-cut',
  'PLAN_ACTION_DECORATE-SHOPPING-MALL-DETAIL-PAGE'    : 'decorate-shopping-mall-detail-page',
  'PLAN_ACTION_DOWNLOAD-AND-MANAGE-EXCEL'             : 'download-and-manage-excel',
  'PLAN_ACTION_DOWNLOAD-BUNJANG'                      : 'download-bunjang',
  'PLAN_ACTION_EDIT-IMAGE'                            : 'edit-image',
  'PLAN_ACTION_FILTER-IMAGE'                          : 'filter-image',
  'PLAN_ACTION_FLUIDIFY-IMAGE'                        : 'fluidify-image',
  'PLAN_ACTION_HANDLE-CLOUD-FILE'                     : 'handle-cloud-file',
  'PLAN_ACTION_MANAGE-BRAND'                          : 'manage-brand',
  'PLAN_ACTION_MANAGE-OFFLINE-SALE'                   : 'manage-offline-sale',
  'PLAN_ACTION_MANAGE-PRODUCT-ORDER'                  : 'manage-product-order',
  'PLAN_ACTION_ON-SITE-INSTALLATION-AND-TRAINING'     : 'on-site-installation-and-training',
  'PLAN_ACTION_ONE-CLICK-EXTEND-SALE-PLATFORM'        : 'one-click-extend-sale-platform',
  'PLAN_ACTION_OPEN-SALE-CAFE24'                      : 'open-sale-cafe24',
  'PLAN_ACTION_OPEN-SALE-INSTAGRAM'                   : 'open-sale-instagram',
  'PLAN_ACTION_OPEN-SALE-NAVER'                       : 'open-sale-naver',
  'PLAN_ACTION_OPEN-SALE-SECONDSOLD'                  : 'open-sale-secondsold',
  'PLAN_ACTION_RESIZE-IMAGE'                          : 'resize-image',
  'PLAN_ACTION_SYNC-SALE-PLATFORM'                    : 'sync-sale-platform',
  'PLAN_ACTION_SYNCHRONIZE-ON-OFF-STOCK'              : 'synchronize-on-off-stock',
  'PLAN_ACTION_SYNCHRONIZE-STOCK'                     : 'synchronize-stock',
  'PLAN_ACTION_TELEPHONE-OR-REMOTE-CONSULTATION'      : 'telephone-or-remote-consultation',
  'PLAN_ACTION_UPLOAD-PRODUCT-LIMITATION'             : 'upload-product-limitation',
};

// ************************************************************************************************

/**
 * popup - target 리스트.
 */
export const ACLOSET_POPUP_TARGET_CODE_LIST = [
  'POPUP_TARGET_ANDROID',  // 안드로이드
  'POPUP_TARGET_IOS',      // iOS
  'POPUP_TARGET_WEB',      // 웹
] as const;

/**
 * popup - target 타입.
 */
export type AclosetPopupTargetCode = (typeof ACLOSET_POPUP_TARGET_CODE_LIST)[number];

/**
 * popup - target Short 코드 리스트.
 */
export const ACLOSET_POPUP_TARGET_SHORT_CODE_LIST = [
  'android',  // 안드로이드
  'ios',      // iOS
  'web',      // 웹
] as const;

/**
 * popup - target Short 코드 타입.
 */
export type AclosetPopupTargetShortCode = (typeof ACLOSET_POPUP_TARGET_SHORT_CODE_LIST)[number];

/**
 * popup - target Short 코드 매핑.
 */
export const ACLOSET_POPUP_TARGET_SHORT_CODE_MAP: Readonly<Record<AclosetPopupTargetShortCode, AclosetPopupTargetCode>> = {
  'android': 'POPUP_TARGET_ANDROID',
  'ios'    : 'POPUP_TARGET_IOS',
  'web'    : 'POPUP_TARGET_WEB',
};

/**
 * popup - target Short 코드 역매핑.
 */
export const ACLOSET_POPUP_TARGET_SHORT_CODE_INV_MAP: Readonly<Record<AclosetPopupTargetCode, AclosetPopupTargetShortCode>> = {
  'POPUP_TARGET_ANDROID': 'android',
  'POPUP_TARGET_IOS'    : 'ios',
  'POPUP_TARGET_WEB'    : 'web',
};

// ************************************************************************************************

/**
 * proseller-info - target-gender-type 리스트.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_GENDER_TYPE_CODE_LIST = [
  'PROSELLER-INFO_TARGET-GENDER-TYPE_KIDS',    // 키즈
  'PROSELLER-INFO_TARGET-GENDER-TYPE_MEN',     // 남성
  'PROSELLER-INFO_TARGET-GENDER-TYPE_UNISEX',  // 유니섹스
  'PROSELLER-INFO_TARGET-GENDER-TYPE_WOMEN',   // 여성
] as const;

/**
 * proseller-info - target-gender-type 타입.
 */
export type AclosetProsellerInfoTargetGenderTypeCode = (typeof ACLOSET_PROSELLER_INFO_TARGET_GENDER_TYPE_CODE_LIST)[number];

/**
 * proseller-info - target-gender-type Short 코드 리스트.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_GENDER_TYPE_SHORT_CODE_LIST = [
  'kids',    // 키즈
  'men',     // 남성
  'unisex',  // 유니섹스
  'women',   // 여성
] as const;

/**
 * proseller-info - target-gender-type Short 코드 타입.
 */
export type AclosetProsellerInfoTargetGenderTypeShortCode = (typeof ACLOSET_PROSELLER_INFO_TARGET_GENDER_TYPE_SHORT_CODE_LIST)[number];

/**
 * proseller-info - target-gender-type Short 코드 매핑.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_GENDER_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetProsellerInfoTargetGenderTypeShortCode, AclosetProsellerInfoTargetGenderTypeCode>> = {
  'kids'  : 'PROSELLER-INFO_TARGET-GENDER-TYPE_KIDS',
  'men'   : 'PROSELLER-INFO_TARGET-GENDER-TYPE_MEN',
  'unisex': 'PROSELLER-INFO_TARGET-GENDER-TYPE_UNISEX',
  'women' : 'PROSELLER-INFO_TARGET-GENDER-TYPE_WOMEN',
};

/**
 * proseller-info - target-gender-type Short 코드 역매핑.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_GENDER_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetProsellerInfoTargetGenderTypeCode, AclosetProsellerInfoTargetGenderTypeShortCode>> = {
  'PROSELLER-INFO_TARGET-GENDER-TYPE_KIDS'  : 'kids',
  'PROSELLER-INFO_TARGET-GENDER-TYPE_MEN'   : 'men',
  'PROSELLER-INFO_TARGET-GENDER-TYPE_UNISEX': 'unisex',
  'PROSELLER-INFO_TARGET-GENDER-TYPE_WOMEN' : 'women',
};

// ************************************************************************************************

/**
 * proseller-info - target-age-type 리스트.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_AGE_TYPE_CODE_LIST = [
  'PROSELLER-INFO_TARGET-AGE-TYPE_FORTIES-AND-ABOVE',  // 40대 이상
  'PROSELLER-INFO_TARGET-AGE-TYPE_INFANTS-CHILDREN',   // 유아동
  'PROSELLER-INFO_TARGET-AGE-TYPE_TEENS-TWENTIES',     // 10-20대
  'PROSELLER-INFO_TARGET-AGE-TYPE_THIRTIES-FORTIES',   // 30-40대
  'PROSELLER-INFO_TARGET-AGE-TYPE_TWENTIES-THIRTIES',  // 20-30대
] as const;

/**
 * proseller-info - target-age-type 타입.
 */
export type AclosetProsellerInfoTargetAgeTypeCode = (typeof ACLOSET_PROSELLER_INFO_TARGET_AGE_TYPE_CODE_LIST)[number];

/**
 * proseller-info - target-age-type Short 코드 리스트.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_AGE_TYPE_SHORT_CODE_LIST = [
  'forties-and-above',  // 40대 이상
  'infants-children',   // 유아동
  'teens-twenties',     // 10-20대
  'thirties-forties',   // 30-40대
  'twenties-thirties',  // 20-30대
] as const;

/**
 * proseller-info - target-age-type Short 코드 타입.
 */
export type AclosetProsellerInfoTargetAgeTypeShortCode = (typeof ACLOSET_PROSELLER_INFO_TARGET_AGE_TYPE_SHORT_CODE_LIST)[number];

/**
 * proseller-info - target-age-type Short 코드 매핑.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_AGE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetProsellerInfoTargetAgeTypeShortCode, AclosetProsellerInfoTargetAgeTypeCode>> = {
  'forties-and-above': 'PROSELLER-INFO_TARGET-AGE-TYPE_FORTIES-AND-ABOVE',
  'infants-children' : 'PROSELLER-INFO_TARGET-AGE-TYPE_INFANTS-CHILDREN',
  'teens-twenties'   : 'PROSELLER-INFO_TARGET-AGE-TYPE_TEENS-TWENTIES',
  'thirties-forties' : 'PROSELLER-INFO_TARGET-AGE-TYPE_THIRTIES-FORTIES',
  'twenties-thirties': 'PROSELLER-INFO_TARGET-AGE-TYPE_TWENTIES-THIRTIES',
};

/**
 * proseller-info - target-age-type Short 코드 역매핑.
 */
export const ACLOSET_PROSELLER_INFO_TARGET_AGE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetProsellerInfoTargetAgeTypeCode, AclosetProsellerInfoTargetAgeTypeShortCode>> = {
  'PROSELLER-INFO_TARGET-AGE-TYPE_FORTIES-AND-ABOVE': 'forties-and-above',
  'PROSELLER-INFO_TARGET-AGE-TYPE_INFANTS-CHILDREN' : 'infants-children',
  'PROSELLER-INFO_TARGET-AGE-TYPE_TEENS-TWENTIES'   : 'teens-twenties',
  'PROSELLER-INFO_TARGET-AGE-TYPE_THIRTIES-FORTIES' : 'thirties-forties',
  'PROSELLER-INFO_TARGET-AGE-TYPE_TWENTIES-THIRTIES': 'twenties-thirties',
};

// ************************************************************************************************

/**
 * proseller-info - service-options-type 리스트.
 */
export const ACLOSET_PROSELLER_INFO_SERVICE_OPTIONS_TYPE_CODE_LIST = [
  'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_LAUNDRY',  // 상품을 세탁해요
  'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_STEAM',    // 상품을 스팀 살균해요
] as const;

/**
 * proseller-info - service-options-type 타입.
 */
export type AclosetProsellerInfoServiceOptionsTypeCode = (typeof ACLOSET_PROSELLER_INFO_SERVICE_OPTIONS_TYPE_CODE_LIST)[number];

/**
 * proseller-info - service-options-type Short 코드 리스트.
 */
export const ACLOSET_PROSELLER_INFO_SERVICE_OPTIONS_TYPE_SHORT_CODE_LIST = [
  'laundry',  // 상품을 세탁해요
  'steam',    // 상품을 스팀 살균해요
] as const;

/**
 * proseller-info - service-options-type Short 코드 타입.
 */
export type AclosetProsellerInfoServiceOptionsTypeShortCode = (typeof ACLOSET_PROSELLER_INFO_SERVICE_OPTIONS_TYPE_SHORT_CODE_LIST)[number];

/**
 * proseller-info - service-options-type Short 코드 매핑.
 */
export const ACLOSET_PROSELLER_INFO_SERVICE_OPTIONS_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetProsellerInfoServiceOptionsTypeShortCode, AclosetProsellerInfoServiceOptionsTypeCode>> = {
  'laundry': 'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_LAUNDRY',
  'steam'  : 'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_STEAM',
};

/**
 * proseller-info - service-options-type Short 코드 역매핑.
 */
export const ACLOSET_PROSELLER_INFO_SERVICE_OPTIONS_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetProsellerInfoServiceOptionsTypeCode, AclosetProsellerInfoServiceOptionsTypeShortCode>> = {
  'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_LAUNDRY': 'laundry',
  'PROSELLER-INFO_SERVICE-OPTIONS-TYPE_STEAM'  : 'steam',
};

// ************************************************************************************************

/**
 * proseller-info - product-focus-type 리스트.
 */
export const ACLOSET_PROSELLER_INFO_PRODUCT_FOCUS_TYPE_CODE_LIST = [
  'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_COST-EFFECTIVE',  // 가성비 있는 상품을 판매해요
  'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_LUXURY',          // 트루빈티지 또는 한정판 등 유니크 패션 아이템을 판매해요
  'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_UNIQUE',          // 주로 명품을 취급해요
] as const;

/**
 * proseller-info - product-focus-type 타입.
 */
export type AclosetProsellerInfoProductFocusTypeCode = (typeof ACLOSET_PROSELLER_INFO_PRODUCT_FOCUS_TYPE_CODE_LIST)[number];

/**
 * proseller-info - product-focus-type Short 코드 리스트.
 */
export const ACLOSET_PROSELLER_INFO_PRODUCT_FOCUS_TYPE_SHORT_CODE_LIST = [
  'cost-effective',  // 가성비 있는 상품을 판매해요
  'luxury',          // 트루빈티지 또는 한정판 등 유니크 패션 아이템을 판매해요
  'unique',          // 주로 명품을 취급해요
] as const;

/**
 * proseller-info - product-focus-type Short 코드 타입.
 */
export type AclosetProsellerInfoProductFocusTypeShortCode = (typeof ACLOSET_PROSELLER_INFO_PRODUCT_FOCUS_TYPE_SHORT_CODE_LIST)[number];

/**
 * proseller-info - product-focus-type Short 코드 매핑.
 */
export const ACLOSET_PROSELLER_INFO_PRODUCT_FOCUS_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetProsellerInfoProductFocusTypeShortCode, AclosetProsellerInfoProductFocusTypeCode>> = {
  'cost-effective': 'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_COST-EFFECTIVE',
  'luxury'        : 'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_LUXURY',
  'unique'        : 'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_UNIQUE',
};

/**
 * proseller-info - product-focus-type Short 코드 역매핑.
 */
export const ACLOSET_PROSELLER_INFO_PRODUCT_FOCUS_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetProsellerInfoProductFocusTypeCode, AclosetProsellerInfoProductFocusTypeShortCode>> = {
  'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_COST-EFFECTIVE': 'cost-effective',
  'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_LUXURY'        : 'luxury',
  'PROSELLER-INFO_PRODUCT-FOCUS-TYPE_UNIQUE'        : 'unique',
};

// ************************************************************************************************

/**
 * proseller-info - origin-country-type 리스트.
 */
export const ACLOSET_PROSELLER_INFO_ORIGIN_COUNTRY_TYPE_CODE_LIST = [
  'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_EUROPE',  // 유럽
  'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_JAPAN',   // 일본
  'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_USA',     // 미국
] as const;

/**
 * proseller-info - origin-country-type 타입.
 */
export type AclosetProsellerInfoOriginCountryTypeCode = (typeof ACLOSET_PROSELLER_INFO_ORIGIN_COUNTRY_TYPE_CODE_LIST)[number];

/**
 * proseller-info - origin-country-type Short 코드 리스트.
 */
export const ACLOSET_PROSELLER_INFO_ORIGIN_COUNTRY_TYPE_SHORT_CODE_LIST = [
  'europe',  // 유럽
  'japan',   // 일본
  'usa',     // 미국
] as const;

/**
 * proseller-info - origin-country-type Short 코드 타입.
 */
export type AclosetProsellerInfoOriginCountryTypeShortCode = (typeof ACLOSET_PROSELLER_INFO_ORIGIN_COUNTRY_TYPE_SHORT_CODE_LIST)[number];

/**
 * proseller-info - origin-country-type Short 코드 매핑.
 */
export const ACLOSET_PROSELLER_INFO_ORIGIN_COUNTRY_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetProsellerInfoOriginCountryTypeShortCode, AclosetProsellerInfoOriginCountryTypeCode>> = {
  'europe': 'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_EUROPE',
  'japan' : 'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_JAPAN',
  'usa'   : 'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_USA',
};

/**
 * proseller-info - origin-country-type Short 코드 역매핑.
 */
export const ACLOSET_PROSELLER_INFO_ORIGIN_COUNTRY_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetProsellerInfoOriginCountryTypeCode, AclosetProsellerInfoOriginCountryTypeShortCode>> = {
  'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_EUROPE': 'europe',
  'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_JAPAN' : 'japan',
  'PROSELLER-INFO_ORIGIN-COUNTRY-TYPE_USA'   : 'usa',
};

// ************************************************************************************************

/**
 * proseller-info - keywords-type 리스트.
 */
export const ACLOSET_PROSELLER_INFO_KEYWORDS_TYPE_CODE_LIST = [
  'PROSELLER-INFO_KEYWORDS-TYPE_BASIC',     // 심플베이직
  'PROSELLER-INFO_KEYWORDS-TYPE_CASUAL',    // 캐주얼
  'PROSELLER-INFO_KEYWORDS-TYPE_CLASSIC',   // 클래식
  'PROSELLER-INFO_KEYWORDS-TYPE_FEMININE',  // 페미닌
  'PROSELLER-INFO_KEYWORDS-TYPE_FUNKY',     // 펑키
  'PROSELLER-INFO_KEYWORDS-TYPE_MILITARY',  // 밀리터리
  'PROSELLER-INFO_KEYWORDS-TYPE_SPORTY',    // 스포티
  'PROSELLER-INFO_KEYWORDS-TYPE_STREET',    // 스트리트
  'PROSELLER-INFO_KEYWORDS-TYPE_VINTAGE',   // 트루빈티지
] as const;

/**
 * proseller-info - keywords-type 타입.
 */
export type AclosetProsellerInfoKeywordsTypeCode = (typeof ACLOSET_PROSELLER_INFO_KEYWORDS_TYPE_CODE_LIST)[number];

/**
 * proseller-info - keywords-type Short 코드 리스트.
 */
export const ACLOSET_PROSELLER_INFO_KEYWORDS_TYPE_SHORT_CODE_LIST = [
  'basic',     // 심플베이직
  'casual',    // 캐주얼
  'classic',   // 클래식
  'feminine',  // 페미닌
  'funky',     // 펑키
  'military',  // 밀리터리
  'sporty',    // 스포티
  'street',    // 스트리트
  'vintage',   // 트루빈티지
] as const;

/**
 * proseller-info - keywords-type Short 코드 타입.
 */
export type AclosetProsellerInfoKeywordsTypeShortCode = (typeof ACLOSET_PROSELLER_INFO_KEYWORDS_TYPE_SHORT_CODE_LIST)[number];

/**
 * proseller-info - keywords-type Short 코드 매핑.
 */
export const ACLOSET_PROSELLER_INFO_KEYWORDS_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetProsellerInfoKeywordsTypeShortCode, AclosetProsellerInfoKeywordsTypeCode>> = {
  'basic'   : 'PROSELLER-INFO_KEYWORDS-TYPE_BASIC',
  'casual'  : 'PROSELLER-INFO_KEYWORDS-TYPE_CASUAL',
  'classic' : 'PROSELLER-INFO_KEYWORDS-TYPE_CLASSIC',
  'feminine': 'PROSELLER-INFO_KEYWORDS-TYPE_FEMININE',
  'funky'   : 'PROSELLER-INFO_KEYWORDS-TYPE_FUNKY',
  'military': 'PROSELLER-INFO_KEYWORDS-TYPE_MILITARY',
  'sporty'  : 'PROSELLER-INFO_KEYWORDS-TYPE_SPORTY',
  'street'  : 'PROSELLER-INFO_KEYWORDS-TYPE_STREET',
  'vintage' : 'PROSELLER-INFO_KEYWORDS-TYPE_VINTAGE',
};

/**
 * proseller-info - keywords-type Short 코드 역매핑.
 */
export const ACLOSET_PROSELLER_INFO_KEYWORDS_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetProsellerInfoKeywordsTypeCode, AclosetProsellerInfoKeywordsTypeShortCode>> = {
  'PROSELLER-INFO_KEYWORDS-TYPE_BASIC'   : 'basic',
  'PROSELLER-INFO_KEYWORDS-TYPE_CASUAL'  : 'casual',
  'PROSELLER-INFO_KEYWORDS-TYPE_CLASSIC' : 'classic',
  'PROSELLER-INFO_KEYWORDS-TYPE_FEMININE': 'feminine',
  'PROSELLER-INFO_KEYWORDS-TYPE_FUNKY'   : 'funky',
  'PROSELLER-INFO_KEYWORDS-TYPE_MILITARY': 'military',
  'PROSELLER-INFO_KEYWORDS-TYPE_SPORTY'  : 'sporty',
  'PROSELLER-INFO_KEYWORDS-TYPE_STREET'  : 'street',
  'PROSELLER-INFO_KEYWORDS-TYPE_VINTAGE' : 'vintage',
};

// ************************************************************************************************

/**
 * sale - task-status 리스트.
 */
export const ACLOSET_SALE_TASK_STATUS_CODE_LIST = [
  'SALE_TASK-STATUS_DONE',         // 처리 완료
  'SALE_TASK-STATUS_IDLE',         // 대기
  'SALE_TASK-STATUS_IN-PROGRESS',  // 처리 중
] as const;

/**
 * sale - task-status 타입.
 */
export type AclosetSaleTaskStatusCode = (typeof ACLOSET_SALE_TASK_STATUS_CODE_LIST)[number];

/**
 * sale - task-status Short 코드 리스트.
 */
export const ACLOSET_SALE_TASK_STATUS_SHORT_CODE_LIST = [
  'done',         // 처리 완료
  'idle',         // 대기
  'in-progress',  // 처리 중
] as const;

/**
 * sale - task-status Short 코드 타입.
 */
export type AclosetSaleTaskStatusShortCode = (typeof ACLOSET_SALE_TASK_STATUS_SHORT_CODE_LIST)[number];

/**
 * sale - task-status Short 코드 매핑.
 */
export const ACLOSET_SALE_TASK_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetSaleTaskStatusShortCode, AclosetSaleTaskStatusCode>> = {
  'done'       : 'SALE_TASK-STATUS_DONE',
  'idle'       : 'SALE_TASK-STATUS_IDLE',
  'in-progress': 'SALE_TASK-STATUS_IN-PROGRESS',
};

/**
 * sale - task-status Short 코드 역매핑.
 */
export const ACLOSET_SALE_TASK_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleTaskStatusCode, AclosetSaleTaskStatusShortCode>> = {
  'SALE_TASK-STATUS_DONE'       : 'done',
  'SALE_TASK-STATUS_IDLE'       : 'idle',
  'SALE_TASK-STATUS_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * sale - task-detail-status 리스트.
 */
export const ACLOSET_SALE_TASK_DETAIL_STATUS_CODE_LIST = [
  'SALE_TASK-DETAIL-STATUS_FAILED',       // 처리 실패
  'SALE_TASK-DETAIL-STATUS_IDLE',         // 처리 대기
  'SALE_TASK-DETAIL-STATUS_IN-PROGRESS',  // 처리 중
  'SALE_TASK-DETAIL-STATUS_SUCCESS',      // 처리 성공
] as const;

/**
 * sale - task-detail-status 타입.
 */
export type AclosetSaleTaskDetailStatusCode = (typeof ACLOSET_SALE_TASK_DETAIL_STATUS_CODE_LIST)[number];

/**
 * sale - task-detail-status Short 코드 리스트.
 */
export const ACLOSET_SALE_TASK_DETAIL_STATUS_SHORT_CODE_LIST = [
  'failed',       // 처리 실패
  'idle',         // 처리 대기
  'in-progress',  // 처리 중
  'success',      // 처리 성공
] as const;

/**
 * sale - task-detail-status Short 코드 타입.
 */
export type AclosetSaleTaskDetailStatusShortCode = (typeof ACLOSET_SALE_TASK_DETAIL_STATUS_SHORT_CODE_LIST)[number];

/**
 * sale - task-detail-status Short 코드 매핑.
 */
export const ACLOSET_SALE_TASK_DETAIL_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetSaleTaskDetailStatusShortCode, AclosetSaleTaskDetailStatusCode>> = {
  'failed'     : 'SALE_TASK-DETAIL-STATUS_FAILED',
  'idle'       : 'SALE_TASK-DETAIL-STATUS_IDLE',
  'in-progress': 'SALE_TASK-DETAIL-STATUS_IN-PROGRESS',
  'success'    : 'SALE_TASK-DETAIL-STATUS_SUCCESS',
};

/**
 * sale - task-detail-status Short 코드 역매핑.
 */
export const ACLOSET_SALE_TASK_DETAIL_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleTaskDetailStatusCode, AclosetSaleTaskDetailStatusShortCode>> = {
  'SALE_TASK-DETAIL-STATUS_FAILED'     : 'failed',
  'SALE_TASK-DETAIL-STATUS_IDLE'       : 'idle',
  'SALE_TASK-DETAIL-STATUS_IN-PROGRESS': 'in-progress',
  'SALE_TASK-DETAIL-STATUS_SUCCESS'    : 'success',
};

// ************************************************************************************************

/**
 * sale - task-action 리스트.
 */
export const ACLOSET_SALE_TASK_ACTION_CODE_LIST = [
  'SALE_TASK-ACTION_APPROVE-CANCEL-ORDER',  // 주문 취소 승인
  'SALE_TASK-ACTION_CANCEL-ORDER',          // 주문 취소
  'SALE_TASK-ACTION_CONFIRM-ORDER',         // 주문 확인
  'SALE_TASK-ACTION_CONFIRM-PAYMENT',       // 결제 확인
  'SALE_TASK-ACTION_CONFIRM-SHIPPING',      // 배송 확인
  'SALE_TASK-ACTION_DELETE-ITEM',           // 상품 삭제
  'SALE_TASK-ACTION_INVOICE-REQUEST',       // 운송장 번호 전송
  'SALE_TASK-ACTION_LOAD-BUNJANG-ITEM',     // 번개장터 상품 불러오기
  'SALE_TASK-ACTION_LOAD-CAFE24-ITEM',      // 카페24 상품 불러오기
  'SALE_TASK-ACTION_LOAD-NAVER-ITEM',       // 네이버 상품 불러오기
  'SALE_TASK-ACTION_MODIFY-DISCOUNT',       // 가격 할인
  'SALE_TASK-ACTION_OPEN-SALE',             // 판매 개시
  'SALE_TASK-ACTION_REJECT-CANCEL-ORDER',   // 주문 취소 거부
  'SALE_TASK-ACTION_REOPEN-SALE',           // 판매 재개시
  'SALE_TASK-ACTION_RETRY',                 // 재시도
  'SALE_TASK-ACTION_STOP-SALE',             // 판매 중지
] as const;

/**
 * sale - task-action 타입.
 */
export type AclosetSaleTaskActionCode = (typeof ACLOSET_SALE_TASK_ACTION_CODE_LIST)[number];

/**
 * sale - task-action Short 코드 리스트.
 */
export const ACLOSET_SALE_TASK_ACTION_SHORT_CODE_LIST = [
  'approve-cancel-order',  // 주문 취소 승인
  'cancel-order',          // 주문 취소
  'confirm-order',         // 주문 확인
  'confirm-payment',       // 결제 확인
  'confirm-shipping',      // 배송 확인
  'delete-item',           // 상품 삭제
  'invoice-request',       // 운송장 번호 전송
  'load-bunjang-item',     // 번개장터 상품 불러오기
  'load-cafe24-item',      // 카페24 상품 불러오기
  'load-naver-item',       // 네이버 상품 불러오기
  'modify-discount',       // 가격 할인
  'open-sale',             // 판매 개시
  'reject-cancel-order',   // 주문 취소 거부
  'reopen-sale',           // 판매 재개시
  'retry',                 // 재시도
  'stop-sale',             // 판매 중지
] as const;

/**
 * sale - task-action Short 코드 타입.
 */
export type AclosetSaleTaskActionShortCode = (typeof ACLOSET_SALE_TASK_ACTION_SHORT_CODE_LIST)[number];

/**
 * sale - task-action Short 코드 매핑.
 */
export const ACLOSET_SALE_TASK_ACTION_SHORT_CODE_MAP: Readonly<Record<AclosetSaleTaskActionShortCode, AclosetSaleTaskActionCode>> = {
  'approve-cancel-order': 'SALE_TASK-ACTION_APPROVE-CANCEL-ORDER',
  'cancel-order'        : 'SALE_TASK-ACTION_CANCEL-ORDER',
  'confirm-order'       : 'SALE_TASK-ACTION_CONFIRM-ORDER',
  'confirm-payment'     : 'SALE_TASK-ACTION_CONFIRM-PAYMENT',
  'confirm-shipping'    : 'SALE_TASK-ACTION_CONFIRM-SHIPPING',
  'delete-item'         : 'SALE_TASK-ACTION_DELETE-ITEM',
  'invoice-request'     : 'SALE_TASK-ACTION_INVOICE-REQUEST',
  'load-bunjang-item'   : 'SALE_TASK-ACTION_LOAD-BUNJANG-ITEM',
  'load-cafe24-item'    : 'SALE_TASK-ACTION_LOAD-CAFE24-ITEM',
  'load-naver-item'     : 'SALE_TASK-ACTION_LOAD-NAVER-ITEM',
  'modify-discount'     : 'SALE_TASK-ACTION_MODIFY-DISCOUNT',
  'open-sale'           : 'SALE_TASK-ACTION_OPEN-SALE',
  'reject-cancel-order' : 'SALE_TASK-ACTION_REJECT-CANCEL-ORDER',
  'reopen-sale'         : 'SALE_TASK-ACTION_REOPEN-SALE',
  'retry'               : 'SALE_TASK-ACTION_RETRY',
  'stop-sale'           : 'SALE_TASK-ACTION_STOP-SALE',
};

/**
 * sale - task-action Short 코드 역매핑.
 */
export const ACLOSET_SALE_TASK_ACTION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleTaskActionCode, AclosetSaleTaskActionShortCode>> = {
  'SALE_TASK-ACTION_APPROVE-CANCEL-ORDER': 'approve-cancel-order',
  'SALE_TASK-ACTION_CANCEL-ORDER'        : 'cancel-order',
  'SALE_TASK-ACTION_CONFIRM-ORDER'       : 'confirm-order',
  'SALE_TASK-ACTION_CONFIRM-PAYMENT'     : 'confirm-payment',
  'SALE_TASK-ACTION_CONFIRM-SHIPPING'    : 'confirm-shipping',
  'SALE_TASK-ACTION_DELETE-ITEM'         : 'delete-item',
  'SALE_TASK-ACTION_INVOICE-REQUEST'     : 'invoice-request',
  'SALE_TASK-ACTION_LOAD-BUNJANG-ITEM'   : 'load-bunjang-item',
  'SALE_TASK-ACTION_LOAD-CAFE24-ITEM'    : 'load-cafe24-item',
  'SALE_TASK-ACTION_LOAD-NAVER-ITEM'     : 'load-naver-item',
  'SALE_TASK-ACTION_MODIFY-DISCOUNT'     : 'modify-discount',
  'SALE_TASK-ACTION_OPEN-SALE'           : 'open-sale',
  'SALE_TASK-ACTION_REJECT-CANCEL-ORDER' : 'reject-cancel-order',
  'SALE_TASK-ACTION_REOPEN-SALE'         : 'reopen-sale',
  'SALE_TASK-ACTION_RETRY'               : 'retry',
  'SALE_TASK-ACTION_STOP-SALE'           : 'stop-sale',
};

// ************************************************************************************************

/**
 * sale - status 리스트.
 */
export const ACLOSET_SALE_STATUS_CODE_LIST = [
  'SALE_STATUS_DELETED',            // 상품 삭제
  'SALE_STATUS_IDLE',               // 판매 전
  'SALE_STATUS_ON-SALE',            // 판매 중
  'SALE_STATUS_ORDER-PROCESSING',   // 주문 처리 중
  'SALE_STATUS_PENDING-MODIFYING',  // 수정 대기
  'SALE_STATUS_SALE-DONE',          // 판매 완료
  'SALE_STATUS_STOP-SALE',          // 판매 중지
] as const;

/**
 * sale - status 타입.
 */
export type AclosetSaleStatusCode = (typeof ACLOSET_SALE_STATUS_CODE_LIST)[number];

/**
 * sale - status Short 코드 리스트.
 */
export const ACLOSET_SALE_STATUS_SHORT_CODE_LIST = [
  'deleted',            // 상품 삭제
  'idle',               // 판매 전
  'on-sale',            // 판매 중
  'order-processing',   // 주문 처리 중
  'pending-modifying',  // 수정 대기
  'sale-done',          // 판매 완료
  'stop-sale',          // 판매 중지
] as const;

/**
 * sale - status Short 코드 타입.
 */
export type AclosetSaleStatusShortCode = (typeof ACLOSET_SALE_STATUS_SHORT_CODE_LIST)[number];

/**
 * sale - status Short 코드 매핑.
 */
export const ACLOSET_SALE_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetSaleStatusShortCode, AclosetSaleStatusCode>> = {
  'deleted'          : 'SALE_STATUS_DELETED',
  'idle'             : 'SALE_STATUS_IDLE',
  'on-sale'          : 'SALE_STATUS_ON-SALE',
  'order-processing' : 'SALE_STATUS_ORDER-PROCESSING',
  'pending-modifying': 'SALE_STATUS_PENDING-MODIFYING',
  'sale-done'        : 'SALE_STATUS_SALE-DONE',
  'stop-sale'        : 'SALE_STATUS_STOP-SALE',
};

/**
 * sale - status Short 코드 역매핑.
 */
export const ACLOSET_SALE_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleStatusCode, AclosetSaleStatusShortCode>> = {
  'SALE_STATUS_DELETED'          : 'deleted',
  'SALE_STATUS_IDLE'             : 'idle',
  'SALE_STATUS_ON-SALE'          : 'on-sale',
  'SALE_STATUS_ORDER-PROCESSING' : 'order-processing',
  'SALE_STATUS_PENDING-MODIFYING': 'pending-modifying',
  'SALE_STATUS_SALE-DONE'        : 'sale-done',
  'SALE_STATUS_STOP-SALE'        : 'stop-sale',
};

// ************************************************************************************************

/**
 * sale - platform-status 리스트.
 */
export const ACLOSET_SALE_PLATFORM_STATUS_CODE_LIST = [
  'SALE_PLATFORM-STATUS_DELETED',            // 상품 삭제
  'SALE_PLATFORM-STATUS_IDLE',               // 판매 전
  'SALE_PLATFORM-STATUS_ON-SALE',            // 판매 중
  'SALE_PLATFORM-STATUS_ORDER-PROCESSING',   // 주문 처리 중
  'SALE_PLATFORM-STATUS_PENDING-MODIFYING',  // 수정 대기
  'SALE_PLATFORM-STATUS_SALE-DONE',          // 판매 완료
  'SALE_PLATFORM-STATUS_SOLD-OUT',           // 품절
  'SALE_PLATFORM-STATUS_STOP-SALE',          // 판매 중지
] as const;

/**
 * sale - platform-status 타입.
 */
export type AclosetSalePlatformStatusCode = (typeof ACLOSET_SALE_PLATFORM_STATUS_CODE_LIST)[number];

/**
 * sale - platform-status Short 코드 리스트.
 */
export const ACLOSET_SALE_PLATFORM_STATUS_SHORT_CODE_LIST = [
  'deleted',            // 상품 삭제
  'idle',               // 판매 전
  'on-sale',            // 판매 중
  'order-processing',   // 주문 처리 중
  'pending-modifying',  // 수정 대기
  'sale-done',          // 판매 완료
  'sold-out',           // 품절
  'stop-sale',          // 판매 중지
] as const;

/**
 * sale - platform-status Short 코드 타입.
 */
export type AclosetSalePlatformStatusShortCode = (typeof ACLOSET_SALE_PLATFORM_STATUS_SHORT_CODE_LIST)[number];

/**
 * sale - platform-status Short 코드 매핑.
 */
export const ACLOSET_SALE_PLATFORM_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetSalePlatformStatusShortCode, AclosetSalePlatformStatusCode>> = {
  'deleted'          : 'SALE_PLATFORM-STATUS_DELETED',
  'idle'             : 'SALE_PLATFORM-STATUS_IDLE',
  'on-sale'          : 'SALE_PLATFORM-STATUS_ON-SALE',
  'order-processing' : 'SALE_PLATFORM-STATUS_ORDER-PROCESSING',
  'pending-modifying': 'SALE_PLATFORM-STATUS_PENDING-MODIFYING',
  'sale-done'        : 'SALE_PLATFORM-STATUS_SALE-DONE',
  'sold-out'         : 'SALE_PLATFORM-STATUS_SOLD-OUT',
  'stop-sale'        : 'SALE_PLATFORM-STATUS_STOP-SALE',
};

/**
 * sale - platform-status Short 코드 역매핑.
 */
export const ACLOSET_SALE_PLATFORM_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSalePlatformStatusCode, AclosetSalePlatformStatusShortCode>> = {
  'SALE_PLATFORM-STATUS_DELETED'          : 'deleted',
  'SALE_PLATFORM-STATUS_IDLE'             : 'idle',
  'SALE_PLATFORM-STATUS_ON-SALE'          : 'on-sale',
  'SALE_PLATFORM-STATUS_ORDER-PROCESSING' : 'order-processing',
  'SALE_PLATFORM-STATUS_PENDING-MODIFYING': 'pending-modifying',
  'SALE_PLATFORM-STATUS_SALE-DONE'        : 'sale-done',
  'SALE_PLATFORM-STATUS_SOLD-OUT'         : 'sold-out',
  'SALE_PLATFORM-STATUS_STOP-SALE'        : 'stop-sale',
};

// ************************************************************************************************

/**
 * sale - platform-error 리스트.
 */
export const ACLOSET_SALE_PLATFORM_ERROR_CODE_LIST = [
  'SALE_PLATFORM-ERROR_ACLOSET-ITEM-DESCRIPTION-IS-EMPTY',   // 세컨솔드 상품 상세페이지에 들어갈 내용이 비어 있습니다. 설정 > 쇼핑몰 게시 설정 > 상세페이지 편집기에서 세컨솔드 상세페이지에 들어갈 내용을 설정해주세요.
  'SALE_PLATFORM-ERROR_CAFE24-MODEL-NAME-LIMIT-EXCEEDED',    // 해당 상품의 모델명이 100자를 초과하였습니다. 상품에 따라 모델명에 들어갈 정보의 글자수는 달라질 수 있습니다. 설정 > 쇼핑몰 연동 설정 > 카페24 추가항목 설정에서 모델명에 들어갈 항목을 편집하여, 글자수를 조정해주세요.
  'SALE_PLATFORM-ERROR_CAFE24-SUPPLIER-NOT-EXISTS',          // 카페24에 상품게시를 실패하였습니다. 상품에 입력된 공급사 코드가 카페24에 존재하지 않습니다. 카페24에 만들어진 공급사 코드를 본 솔루션의 공급사 설정에 올바르게 입력하였는지 확인해주세요
  'SALE_PLATFORM-ERROR_INSTAGRAM-ACCOUNT-DISCONNECTED',      // 페이스북 페이지와 인스타그램 계정 연결이 끊겨 인스타그램을 연동할 수 없습니다. 페이스북 페이지와 인스타그램 계정을 다시 연결해주세요.
  'SALE_PLATFORM-ERROR_INSTAGRAM-DETAIL-EXCEED-MAX-LENGTH',  // 상세 내용의 최대 글자 수를 초과했습니다. ‘미리보기/편집' 버튼을 눌러 글자 수와 태그 수를 확인해 수정한 후, 다시 시도해주세요.
                                                             // 
                                                             // 최대 글자 수 : 2,200자
                                                             // 최대 해시태그 수 : 30개
                                                             // 최대 @ 태그 : 20개
  'SALE_PLATFORM-ERROR_INSTAGRAM-PUBLISH-LIMIT-EXCEEDED',    // 하루동안 올릴 수 있는 최대 게시글 수에 도달했습니다.
                                                             // 인스타그램 정책 상, 24시간 이내에 최대 50개 게시글만 올릴 수 있습니다.
                                                             // 내일 다시 시도해주세요.
  'SALE_PLATFORM-ERROR_INSTAGRAM-TEMPOARY-ERROR',            // 일시적인 오류가 발생했습니다. 다시 시도해주세요.
  'SALE_PLATFORM-ERROR_INVALID_TEXT-IN_ITEM-SIZE',           // 사이즈에 허용하지 않는 문자가 있습니다. 특수문자, 기호, 깨지는 글씨 등이 없는지 확인해주세요. (맥을 사용하시는 경우, 보이지 않는 특수기호가 있을 수 있으니, 빈칸을 모두 지우고 다시 띄어쓰기를 수행한 뒤 저장해주세요)
  'SALE_PLATFORM-ERROR_INVALID-TEXT-IN-ITEM-TITLE',          // 상품명에 허용하지 않는 문자가 있습니다. 특수문자, 기호, 깨지는 글씨 등이 없는지 확인해주세요. (맥을 사용하시는 경우, 보이지 않는 특수기호가 있을 수 있으니, 빈칸을 모두 지우고 다시 띄어쓰기를 수행한 뒤 저장해주세요)
  'SALE_PLATFORM-ERROR_ITEM-ACLOSET-CATEGORY-IS-INVALID',    // 해당 상품의 세컨솔드 카테고리가 잘못되었습니다. 카테고리를 선택하시고 상품개시를 다시 시도해주세요.
  'SALE_PLATFORM-ERROR_ITEM-CAFE24-CATEGORY-IS-INVALID',     // 해당 상품의 카페24 카테고리가 잘못되었습니다. 카테고리를 선택하시고 상품개시를 다시 시도해주세요.
  'SALE_PLATFORM-ERROR_ITEM-NAVER-CATEGORY-IS-EMPTY',        // 해당 상품의 네이버 카테고리가 비어있습니다. 카테고리를 선택하시고 상품개시를 다시 시도해주세요.
  'SALE_PLATFORM-ERROR_NAVER_SUPPLIER-NOT-EXISTS',           // 네이버 스마트스토어에 상품게시를 실패하였습니다. 상품에 입력된 배송비 묶음그룹번호가 나의 스마트스토어 정보에 존재하지 않습니다. 네이버 스마트스토어에 만드신 묶음그룹번호를 본 솔루션의 공급사 설정에 올바르게 입력하였는지 확인해주세요
  'SALE_PLATFORM-ERROR_NAVER_UPLOAD-LIMIT-EXCEEDED',         // 네이버에 게시할 수 있는 상품수를 초과하였습니다. 네이버에 게시한 상품을 삭제한 뒤에 재시도해주세요.(판매자 등급별 상품수는 네이버의 정책을 참고해주세요)
  'SALE_PLATFORM-ERROR_NETWORK-ERROR',                       // 일시적인 네트워크 오류 또는 기타 이유로 판매 개시에 실패했습니다. 잠시 후 다시 시도해주세요. (만약, 여러번 시도 후에도 계속 실패한다면 채널톡으로 문의주세요.)
  'SALE_PLATFORM-ERROR_NO-ITEM-TITLE',                       // 상품명이 없습니다. 상품명을 입력해주세요.
] as const;

/**
 * sale - platform-error 타입.
 */
export type AclosetSalePlatformErrorCode = (typeof ACLOSET_SALE_PLATFORM_ERROR_CODE_LIST)[number];

/**
 * sale - platform-error Short 코드 리스트.
 */
export const ACLOSET_SALE_PLATFORM_ERROR_SHORT_CODE_LIST = [
  'acloset-item-description-is-empty',   // 세컨솔드 상품 상세페이지에 들어갈 내용이 비어 있습니다. 설정 > 쇼핑몰 게시 설정 > 상세페이지 편집기에서 세컨솔드 상세페이지에 들어갈 내용을 설정해주세요.
  'cafe24-model-name-limit-exceeded',    // 해당 상품의 모델명이 100자를 초과하였습니다. 상품에 따라 모델명에 들어갈 정보의 글자수는 달라질 수 있습니다. 설정 > 쇼핑몰 연동 설정 > 카페24 추가항목 설정에서 모델명에 들어갈 항목을 편집하여, 글자수를 조정해주세요.
  'cafe24-supplier-not-exists',          // 카페24에 상품게시를 실패하였습니다. 상품에 입력된 공급사 코드가 카페24에 존재하지 않습니다. 카페24에 만들어진 공급사 코드를 본 솔루션의 공급사 설정에 올바르게 입력하였는지 확인해주세요
  'instagram-account-disconnected',      // 페이스북 페이지와 인스타그램 계정 연결이 끊겨 인스타그램을 연동할 수 없습니다. 페이스북 페이지와 인스타그램 계정을 다시 연결해주세요.
  'instagram-detail-exceed-max-length',  // 상세 내용의 최대 글자 수를 초과했습니다. ‘미리보기/편집' 버튼을 눌러 글자 수와 태그 수를 확인해 수정한 후, 다시 시도해주세요.
                                         // 
                                         // 최대 글자 수 : 2,200자
                                         // 최대 해시태그 수 : 30개
                                         // 최대 @ 태그 : 20개
  'instagram-publish-limit-exceeded',    // 하루동안 올릴 수 있는 최대 게시글 수에 도달했습니다.
                                         // 인스타그램 정책 상, 24시간 이내에 최대 50개 게시글만 올릴 수 있습니다.
                                         // 내일 다시 시도해주세요.
  'instagram-tempoary-error',            // 일시적인 오류가 발생했습니다. 다시 시도해주세요.
  'invalid_text-in_item-size',           // 사이즈에 허용하지 않는 문자가 있습니다. 특수문자, 기호, 깨지는 글씨 등이 없는지 확인해주세요. (맥을 사용하시는 경우, 보이지 않는 특수기호가 있을 수 있으니, 빈칸을 모두 지우고 다시 띄어쓰기를 수행한 뒤 저장해주세요)
  'invalid-text-in-item-title',          // 상품명에 허용하지 않는 문자가 있습니다. 특수문자, 기호, 깨지는 글씨 등이 없는지 확인해주세요. (맥을 사용하시는 경우, 보이지 않는 특수기호가 있을 수 있으니, 빈칸을 모두 지우고 다시 띄어쓰기를 수행한 뒤 저장해주세요)
  'item-acloset-category-is-invalid',    // 해당 상품의 세컨솔드 카테고리가 잘못되었습니다. 카테고리를 선택하시고 상품개시를 다시 시도해주세요.
  'item-cafe24-category-is-invalid',     // 해당 상품의 카페24 카테고리가 잘못되었습니다. 카테고리를 선택하시고 상품개시를 다시 시도해주세요.
  'item-naver-category-is-empty',        // 해당 상품의 네이버 카테고리가 비어있습니다. 카테고리를 선택하시고 상품개시를 다시 시도해주세요.
  'naver_supplier-not-exists',           // 네이버 스마트스토어에 상품게시를 실패하였습니다. 상품에 입력된 배송비 묶음그룹번호가 나의 스마트스토어 정보에 존재하지 않습니다. 네이버 스마트스토어에 만드신 묶음그룹번호를 본 솔루션의 공급사 설정에 올바르게 입력하였는지 확인해주세요
  'naver_upload-limit-exceeded',         // 네이버에 게시할 수 있는 상품수를 초과하였습니다. 네이버에 게시한 상품을 삭제한 뒤에 재시도해주세요.(판매자 등급별 상품수는 네이버의 정책을 참고해주세요)
  'network-error',                       // 일시적인 네트워크 오류 또는 기타 이유로 판매 개시에 실패했습니다. 잠시 후 다시 시도해주세요. (만약, 여러번 시도 후에도 계속 실패한다면 채널톡으로 문의주세요.)
  'no-item-title',                       // 상품명이 없습니다. 상품명을 입력해주세요.
] as const;

/**
 * sale - platform-error Short 코드 타입.
 */
export type AclosetSalePlatformErrorShortCode = (typeof ACLOSET_SALE_PLATFORM_ERROR_SHORT_CODE_LIST)[number];

/**
 * sale - platform-error Short 코드 매핑.
 */
export const ACLOSET_SALE_PLATFORM_ERROR_SHORT_CODE_MAP: Readonly<Record<AclosetSalePlatformErrorShortCode, AclosetSalePlatformErrorCode>> = {
  'acloset-item-description-is-empty' : 'SALE_PLATFORM-ERROR_ACLOSET-ITEM-DESCRIPTION-IS-EMPTY',
  'cafe24-model-name-limit-exceeded'  : 'SALE_PLATFORM-ERROR_CAFE24-MODEL-NAME-LIMIT-EXCEEDED',
  'cafe24-supplier-not-exists'        : 'SALE_PLATFORM-ERROR_CAFE24-SUPPLIER-NOT-EXISTS',
  'instagram-account-disconnected'    : 'SALE_PLATFORM-ERROR_INSTAGRAM-ACCOUNT-DISCONNECTED',
  'instagram-detail-exceed-max-length': 'SALE_PLATFORM-ERROR_INSTAGRAM-DETAIL-EXCEED-MAX-LENGTH',
  'instagram-publish-limit-exceeded'  : 'SALE_PLATFORM-ERROR_INSTAGRAM-PUBLISH-LIMIT-EXCEEDED',
  'instagram-tempoary-error'          : 'SALE_PLATFORM-ERROR_INSTAGRAM-TEMPOARY-ERROR',
  'invalid_text-in_item-size'         : 'SALE_PLATFORM-ERROR_INVALID_TEXT-IN_ITEM-SIZE',
  'invalid-text-in-item-title'        : 'SALE_PLATFORM-ERROR_INVALID-TEXT-IN-ITEM-TITLE',
  'item-acloset-category-is-invalid'  : 'SALE_PLATFORM-ERROR_ITEM-ACLOSET-CATEGORY-IS-INVALID',
  'item-cafe24-category-is-invalid'   : 'SALE_PLATFORM-ERROR_ITEM-CAFE24-CATEGORY-IS-INVALID',
  'item-naver-category-is-empty'      : 'SALE_PLATFORM-ERROR_ITEM-NAVER-CATEGORY-IS-EMPTY',
  'naver_supplier-not-exists'         : 'SALE_PLATFORM-ERROR_NAVER_SUPPLIER-NOT-EXISTS',
  'naver_upload-limit-exceeded'       : 'SALE_PLATFORM-ERROR_NAVER_UPLOAD-LIMIT-EXCEEDED',
  'network-error'                     : 'SALE_PLATFORM-ERROR_NETWORK-ERROR',
  'no-item-title'                     : 'SALE_PLATFORM-ERROR_NO-ITEM-TITLE',
};

/**
 * sale - platform-error Short 코드 역매핑.
 */
export const ACLOSET_SALE_PLATFORM_ERROR_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSalePlatformErrorCode, AclosetSalePlatformErrorShortCode>> = {
  'SALE_PLATFORM-ERROR_ACLOSET-ITEM-DESCRIPTION-IS-EMPTY' : 'acloset-item-description-is-empty',
  'SALE_PLATFORM-ERROR_CAFE24-MODEL-NAME-LIMIT-EXCEEDED'  : 'cafe24-model-name-limit-exceeded',
  'SALE_PLATFORM-ERROR_CAFE24-SUPPLIER-NOT-EXISTS'        : 'cafe24-supplier-not-exists',
  'SALE_PLATFORM-ERROR_INSTAGRAM-ACCOUNT-DISCONNECTED'    : 'instagram-account-disconnected',
  'SALE_PLATFORM-ERROR_INSTAGRAM-DETAIL-EXCEED-MAX-LENGTH': 'instagram-detail-exceed-max-length',
  'SALE_PLATFORM-ERROR_INSTAGRAM-PUBLISH-LIMIT-EXCEEDED'  : 'instagram-publish-limit-exceeded',
  'SALE_PLATFORM-ERROR_INSTAGRAM-TEMPOARY-ERROR'          : 'instagram-tempoary-error',
  'SALE_PLATFORM-ERROR_INVALID_TEXT-IN_ITEM-SIZE'         : 'invalid_text-in_item-size',
  'SALE_PLATFORM-ERROR_INVALID-TEXT-IN-ITEM-TITLE'        : 'invalid-text-in-item-title',
  'SALE_PLATFORM-ERROR_ITEM-ACLOSET-CATEGORY-IS-INVALID'  : 'item-acloset-category-is-invalid',
  'SALE_PLATFORM-ERROR_ITEM-CAFE24-CATEGORY-IS-INVALID'   : 'item-cafe24-category-is-invalid',
  'SALE_PLATFORM-ERROR_ITEM-NAVER-CATEGORY-IS-EMPTY'      : 'item-naver-category-is-empty',
  'SALE_PLATFORM-ERROR_NAVER_SUPPLIER-NOT-EXISTS'         : 'naver_supplier-not-exists',
  'SALE_PLATFORM-ERROR_NAVER_UPLOAD-LIMIT-EXCEEDED'       : 'naver_upload-limit-exceeded',
  'SALE_PLATFORM-ERROR_NETWORK-ERROR'                     : 'network-error',
  'SALE_PLATFORM-ERROR_NO-ITEM-TITLE'                     : 'no-item-title',
};

// ************************************************************************************************

/**
 * sale - operation 리스트.
 */
export const ACLOSET_SALE_OPERATION_CODE_LIST = [
  'SALE_OPERATION_FAILED',       // 처리 실패
  'SALE_OPERATION_IDLE',         // 처리 대기
  'SALE_OPERATION_IN-PROGRESS',  // 처리 중
] as const;

/**
 * sale - operation 타입.
 */
export type AclosetSaleOperationCode = (typeof ACLOSET_SALE_OPERATION_CODE_LIST)[number];

/**
 * sale - operation Short 코드 리스트.
 */
export const ACLOSET_SALE_OPERATION_SHORT_CODE_LIST = [
  'failed',       // 처리 실패
  'idle',         // 처리 대기
  'in-progress',  // 처리 중
] as const;

/**
 * sale - operation Short 코드 타입.
 */
export type AclosetSaleOperationShortCode = (typeof ACLOSET_SALE_OPERATION_SHORT_CODE_LIST)[number];

/**
 * sale - operation Short 코드 매핑.
 */
export const ACLOSET_SALE_OPERATION_SHORT_CODE_MAP: Readonly<Record<AclosetSaleOperationShortCode, AclosetSaleOperationCode>> = {
  'failed'     : 'SALE_OPERATION_FAILED',
  'idle'       : 'SALE_OPERATION_IDLE',
  'in-progress': 'SALE_OPERATION_IN-PROGRESS',
};

/**
 * sale - operation Short 코드 역매핑.
 */
export const ACLOSET_SALE_OPERATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleOperationCode, AclosetSaleOperationShortCode>> = {
  'SALE_OPERATION_FAILED'     : 'failed',
  'SALE_OPERATION_IDLE'       : 'idle',
  'SALE_OPERATION_IN-PROGRESS': 'in-progress',
};

// ************************************************************************************************

/**
 * sale - item-price 리스트.
 */
export const ACLOSET_SALE_ITEM_PRICE_CODE_LIST = [
  'SALE_ITEM-PRICE_RETAIL-PRICE',  // 소비자가
  'SALE_ITEM-PRICE_SELLER-PRICE',  // 판매가
] as const;

/**
 * sale - item-price 타입.
 */
export type AclosetSaleItemPriceCode = (typeof ACLOSET_SALE_ITEM_PRICE_CODE_LIST)[number];

/**
 * sale - item-price Short 코드 리스트.
 */
export const ACLOSET_SALE_ITEM_PRICE_SHORT_CODE_LIST = [
  'retail-price',  // 소비자가
  'seller-price',  // 판매가
] as const;

/**
 * sale - item-price Short 코드 타입.
 */
export type AclosetSaleItemPriceShortCode = (typeof ACLOSET_SALE_ITEM_PRICE_SHORT_CODE_LIST)[number];

/**
 * sale - item-price Short 코드 매핑.
 */
export const ACLOSET_SALE_ITEM_PRICE_SHORT_CODE_MAP: Readonly<Record<AclosetSaleItemPriceShortCode, AclosetSaleItemPriceCode>> = {
  'retail-price': 'SALE_ITEM-PRICE_RETAIL-PRICE',
  'seller-price': 'SALE_ITEM-PRICE_SELLER-PRICE',
};

/**
 * sale - item-price Short 코드 역매핑.
 */
export const ACLOSET_SALE_ITEM_PRICE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleItemPriceCode, AclosetSaleItemPriceShortCode>> = {
  'SALE_ITEM-PRICE_RETAIL-PRICE': 'retail-price',
  'SALE_ITEM-PRICE_SELLER-PRICE': 'seller-price',
};

// ************************************************************************************************

/**
 * sale - easy-payment 리스트.
 */
export const ACLOSET_SALE_EASY_PAYMENT_CODE_LIST = [
  'SALE_EASY-PAYMENT_KAKAOPAY',  // 카카오페이
  'SALE_EASY-PAYMENT_NAVERPAY',  // 네이버페이
  'SALE_EASY-PAYMENT_TOSSPAY',   // 토스페이
] as const;

/**
 * sale - easy-payment 타입.
 */
export type AclosetSaleEasyPaymentCode = (typeof ACLOSET_SALE_EASY_PAYMENT_CODE_LIST)[number];

/**
 * sale - easy-payment Short 코드 리스트.
 */
export const ACLOSET_SALE_EASY_PAYMENT_SHORT_CODE_LIST = [
  'kakaopay',  // 카카오페이
  'naverpay',  // 네이버페이
  'tosspay',   // 토스페이
] as const;

/**
 * sale - easy-payment Short 코드 타입.
 */
export type AclosetSaleEasyPaymentShortCode = (typeof ACLOSET_SALE_EASY_PAYMENT_SHORT_CODE_LIST)[number];

/**
 * sale - easy-payment Short 코드 매핑.
 */
export const ACLOSET_SALE_EASY_PAYMENT_SHORT_CODE_MAP: Readonly<Record<AclosetSaleEasyPaymentShortCode, AclosetSaleEasyPaymentCode>> = {
  'kakaopay': 'SALE_EASY-PAYMENT_KAKAOPAY',
  'naverpay': 'SALE_EASY-PAYMENT_NAVERPAY',
  'tosspay' : 'SALE_EASY-PAYMENT_TOSSPAY',
};

/**
 * sale - easy-payment Short 코드 역매핑.
 */
export const ACLOSET_SALE_EASY_PAYMENT_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSaleEasyPaymentCode, AclosetSaleEasyPaymentShortCode>> = {
  'SALE_EASY-PAYMENT_KAKAOPAY': 'kakaopay',
  'SALE_EASY-PAYMENT_NAVERPAY': 'naverpay',
  'SALE_EASY-PAYMENT_TOSSPAY' : 'tosspay',
};

// ************************************************************************************************

/**
 * service-pricing - code 리스트.
 */
export const ACLOSET_SERVICE_PRICING_CODE_CODE_LIST = [
  'SERVICE-PRICING_CODE_AI-DESCRIPTION',  // AI 상품설명
  'SERVICE-PRICING_CODE_AI-INTEGRATION',  // AI 통합 서비스
  'SERVICE-PRICING_CODE_AUTO-INPUT',      // AI 상품 정보 자동 추출
  'SERVICE-PRICING_CODE_SALE-PLATFORM',   // 쇼핑몰 판매관리
] as const;

/**
 * service-pricing - code 타입.
 */
export type AclosetServicePricingCodeCode = (typeof ACLOSET_SERVICE_PRICING_CODE_CODE_LIST)[number];

/**
 * service-pricing - code Short 코드 리스트.
 */
export const ACLOSET_SERVICE_PRICING_CODE_SHORT_CODE_LIST = [
  'ai-description',  // AI 상품설명
  'ai-integration',  // AI 통합 서비스
  'auto-input',      // AI 상품 정보 자동 추출
  'sale-platform',   // 쇼핑몰 판매관리
] as const;

/**
 * service-pricing - code Short 코드 타입.
 */
export type AclosetServicePricingCodeShortCode = (typeof ACLOSET_SERVICE_PRICING_CODE_SHORT_CODE_LIST)[number];

/**
 * service-pricing - code Short 코드 매핑.
 */
export const ACLOSET_SERVICE_PRICING_CODE_SHORT_CODE_MAP: Readonly<Record<AclosetServicePricingCodeShortCode, AclosetServicePricingCodeCode>> = {
  'ai-description': 'SERVICE-PRICING_CODE_AI-DESCRIPTION',
  'ai-integration': 'SERVICE-PRICING_CODE_AI-INTEGRATION',
  'auto-input'    : 'SERVICE-PRICING_CODE_AUTO-INPUT',
  'sale-platform' : 'SERVICE-PRICING_CODE_SALE-PLATFORM',
};

/**
 * service-pricing - code Short 코드 역매핑.
 */
export const ACLOSET_SERVICE_PRICING_CODE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetServicePricingCodeCode, AclosetServicePricingCodeShortCode>> = {
  'SERVICE-PRICING_CODE_AI-DESCRIPTION': 'ai-description',
  'SERVICE-PRICING_CODE_AI-INTEGRATION': 'ai-integration',
  'SERVICE-PRICING_CODE_AUTO-INPUT'    : 'auto-input',
  'SERVICE-PRICING_CODE_SALE-PLATFORM' : 'sale-platform',
};

// ************************************************************************************************

/**
 * settlement - type 리스트.
 */
export const ACLOSET_SETTLEMENT_TYPE_CODE_LIST = [
  'SETTLEMENT_TYPE_MANUAL',  // 수동 정산 (중간 정산)
  'SETTLEMENT_TYPE_NORMAL',  // 일반 정산
] as const;

/**
 * settlement - type 타입.
 */
export type AclosetSettlementTypeCode = (typeof ACLOSET_SETTLEMENT_TYPE_CODE_LIST)[number];

/**
 * settlement - type Short 코드 리스트.
 */
export const ACLOSET_SETTLEMENT_TYPE_SHORT_CODE_LIST = [
  'manual',  // 수동 정산 (중간 정산)
  'normal',  // 일반 정산
] as const;

/**
 * settlement - type Short 코드 타입.
 */
export type AclosetSettlementTypeShortCode = (typeof ACLOSET_SETTLEMENT_TYPE_SHORT_CODE_LIST)[number];

/**
 * settlement - type Short 코드 매핑.
 */
export const ACLOSET_SETTLEMENT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetSettlementTypeShortCode, AclosetSettlementTypeCode>> = {
  'manual': 'SETTLEMENT_TYPE_MANUAL',
  'normal': 'SETTLEMENT_TYPE_NORMAL',
};

/**
 * settlement - type Short 코드 역매핑.
 */
export const ACLOSET_SETTLEMENT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSettlementTypeCode, AclosetSettlementTypeShortCode>> = {
  'SETTLEMENT_TYPE_MANUAL': 'manual',
  'SETTLEMENT_TYPE_NORMAL': 'normal',
};

// ************************************************************************************************

/**
 * settlement - status 리스트.
 */
export const ACLOSET_SETTLEMENT_STATUS_CODE_LIST = [
  'SETTLEMENT_STATUS_FREE-SUBSCRIPTION',       // 무료구독
  'SETTLEMENT_STATUS_FREE-TRIAL',              // 무료체험
  'SETTLEMENT_STATUS_PAID-SUBSCRIPTION',       // 유료구독
  'SETTLEMENT_STATUS_PROMOTION-SUBSCRIPTION',  // 유료구독(프로모션 할인)
  'SETTLEMENT_STATUS_USING-COUPON',            // 쿠폰사용
] as const;

/**
 * settlement - status 타입.
 */
export type AclosetSettlementStatusCode = (typeof ACLOSET_SETTLEMENT_STATUS_CODE_LIST)[number];

/**
 * settlement - status Short 코드 리스트.
 */
export const ACLOSET_SETTLEMENT_STATUS_SHORT_CODE_LIST = [
  'free-subscription',       // 무료구독
  'free-trial',              // 무료체험
  'paid-subscription',       // 유료구독
  'promotion-subscription',  // 유료구독(프로모션 할인)
  'using-coupon',            // 쿠폰사용
] as const;

/**
 * settlement - status Short 코드 타입.
 */
export type AclosetSettlementStatusShortCode = (typeof ACLOSET_SETTLEMENT_STATUS_SHORT_CODE_LIST)[number];

/**
 * settlement - status Short 코드 매핑.
 */
export const ACLOSET_SETTLEMENT_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetSettlementStatusShortCode, AclosetSettlementStatusCode>> = {
  'free-subscription'     : 'SETTLEMENT_STATUS_FREE-SUBSCRIPTION',
  'free-trial'            : 'SETTLEMENT_STATUS_FREE-TRIAL',
  'paid-subscription'     : 'SETTLEMENT_STATUS_PAID-SUBSCRIPTION',
  'promotion-subscription': 'SETTLEMENT_STATUS_PROMOTION-SUBSCRIPTION',
  'using-coupon'          : 'SETTLEMENT_STATUS_USING-COUPON',
};

/**
 * settlement - status Short 코드 역매핑.
 */
export const ACLOSET_SETTLEMENT_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSettlementStatusCode, AclosetSettlementStatusShortCode>> = {
  'SETTLEMENT_STATUS_FREE-SUBSCRIPTION'     : 'free-subscription',
  'SETTLEMENT_STATUS_FREE-TRIAL'            : 'free-trial',
  'SETTLEMENT_STATUS_PAID-SUBSCRIPTION'     : 'paid-subscription',
  'SETTLEMENT_STATUS_PROMOTION-SUBSCRIPTION': 'promotion-subscription',
  'SETTLEMENT_STATUS_USING-COUPON'          : 'using-coupon',
};

// ************************************************************************************************

/**
 * settlement - item-usage-type 리스트.
 */
export const ACLOSET_SETTLEMENT_ITEM_USAGE_TYPE_CODE_LIST = [
  'SETTLEMENT_ITEM-USAGE-TYPE_AI-DESCRIPTION',  // AI 상품 설명 생성
  'SETTLEMENT_ITEM-USAGE-TYPE_AI-INTEGRATION',  // AI 통합 서비스
  'SETTLEMENT_ITEM-USAGE-TYPE_AUTO-INPUT',      // AI 상품 정보 자동 추출
  'SETTLEMENT_ITEM-USAGE-TYPE_BUNJANG',         // 판매관리 - 번개장터
  'SETTLEMENT_ITEM-USAGE-TYPE_CAFE24',          // 판매관리 - 카페24
  'SETTLEMENT_ITEM-USAGE-TYPE_INSTAGRAM',       // 판매관리 - 인스타그램
  'SETTLEMENT_ITEM-USAGE-TYPE_NAVER',           // 판매관리 - 네이버
  'SETTLEMENT_ITEM-USAGE-TYPE_SECONDSOLD',      // 판매관리 - 세컨솔드
] as const;

/**
 * settlement - item-usage-type 타입.
 */
export type AclosetSettlementItemUsageTypeCode = (typeof ACLOSET_SETTLEMENT_ITEM_USAGE_TYPE_CODE_LIST)[number];

/**
 * settlement - item-usage-type Short 코드 리스트.
 */
export const ACLOSET_SETTLEMENT_ITEM_USAGE_TYPE_SHORT_CODE_LIST = [
  'ai-description',  // AI 상품 설명 생성
  'ai-integration',  // AI 통합 서비스
  'auto-input',      // AI 상품 정보 자동 추출
  'bunjang',         // 판매관리 - 번개장터
  'cafe24',          // 판매관리 - 카페24
  'instagram',       // 판매관리 - 인스타그램
  'naver',           // 판매관리 - 네이버
  'secondsold',      // 판매관리 - 세컨솔드
] as const;

/**
 * settlement - item-usage-type Short 코드 타입.
 */
export type AclosetSettlementItemUsageTypeShortCode = (typeof ACLOSET_SETTLEMENT_ITEM_USAGE_TYPE_SHORT_CODE_LIST)[number];

/**
 * settlement - item-usage-type Short 코드 매핑.
 */
export const ACLOSET_SETTLEMENT_ITEM_USAGE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetSettlementItemUsageTypeShortCode, AclosetSettlementItemUsageTypeCode>> = {
  'ai-description': 'SETTLEMENT_ITEM-USAGE-TYPE_AI-DESCRIPTION',
  'ai-integration': 'SETTLEMENT_ITEM-USAGE-TYPE_AI-INTEGRATION',
  'auto-input'    : 'SETTLEMENT_ITEM-USAGE-TYPE_AUTO-INPUT',
  'bunjang'       : 'SETTLEMENT_ITEM-USAGE-TYPE_BUNJANG',
  'cafe24'        : 'SETTLEMENT_ITEM-USAGE-TYPE_CAFE24',
  'instagram'     : 'SETTLEMENT_ITEM-USAGE-TYPE_INSTAGRAM',
  'naver'         : 'SETTLEMENT_ITEM-USAGE-TYPE_NAVER',
  'secondsold'    : 'SETTLEMENT_ITEM-USAGE-TYPE_SECONDSOLD',
};

/**
 * settlement - item-usage-type Short 코드 역매핑.
 */
export const ACLOSET_SETTLEMENT_ITEM_USAGE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetSettlementItemUsageTypeCode, AclosetSettlementItemUsageTypeShortCode>> = {
  'SETTLEMENT_ITEM-USAGE-TYPE_AI-DESCRIPTION': 'ai-description',
  'SETTLEMENT_ITEM-USAGE-TYPE_AI-INTEGRATION': 'ai-integration',
  'SETTLEMENT_ITEM-USAGE-TYPE_AUTO-INPUT'    : 'auto-input',
  'SETTLEMENT_ITEM-USAGE-TYPE_BUNJANG'       : 'bunjang',
  'SETTLEMENT_ITEM-USAGE-TYPE_CAFE24'        : 'cafe24',
  'SETTLEMENT_ITEM-USAGE-TYPE_INSTAGRAM'     : 'instagram',
  'SETTLEMENT_ITEM-USAGE-TYPE_NAVER'         : 'naver',
  'SETTLEMENT_ITEM-USAGE-TYPE_SECONDSOLD'    : 'secondsold',
};

// ************************************************************************************************

/**
 * shop - upload-onboarding-step 리스트.
 */
export const ACLOSET_SHOP_UPLOAD_ONBOARDING_STEP_CODE_LIST = [
  'SHOP_UPLOAD-ONBOARDING-STEP_CAFE24-SETTING',    // 카페24 기본 설정
  'SHOP_UPLOAD-ONBOARDING-STEP_CATEGORY-SETTING',  // 상품 분류 연결
  'SHOP_UPLOAD-ONBOARDING-STEP_TEMPLATE-SETTING',  // 상품글 양식 설정
  'SHOP_UPLOAD-ONBOARDING-STEP_UPLOAD-SETTING',    // 업로드 규칙 설정
] as const;

/**
 * shop - upload-onboarding-step 타입.
 */
export type AclosetShopUploadOnboardingStepCode = (typeof ACLOSET_SHOP_UPLOAD_ONBOARDING_STEP_CODE_LIST)[number];

/**
 * shop - upload-onboarding-step Short 코드 리스트.
 */
export const ACLOSET_SHOP_UPLOAD_ONBOARDING_STEP_SHORT_CODE_LIST = [
  'cafe24-setting',    // 카페24 기본 설정
  'category-setting',  // 상품 분류 연결
  'template-setting',  // 상품글 양식 설정
  'upload-setting',    // 업로드 규칙 설정
] as const;

/**
 * shop - upload-onboarding-step Short 코드 타입.
 */
export type AclosetShopUploadOnboardingStepShortCode = (typeof ACLOSET_SHOP_UPLOAD_ONBOARDING_STEP_SHORT_CODE_LIST)[number];

/**
 * shop - upload-onboarding-step Short 코드 매핑.
 */
export const ACLOSET_SHOP_UPLOAD_ONBOARDING_STEP_SHORT_CODE_MAP: Readonly<Record<AclosetShopUploadOnboardingStepShortCode, AclosetShopUploadOnboardingStepCode>> = {
  'cafe24-setting'  : 'SHOP_UPLOAD-ONBOARDING-STEP_CAFE24-SETTING',
  'category-setting': 'SHOP_UPLOAD-ONBOARDING-STEP_CATEGORY-SETTING',
  'template-setting': 'SHOP_UPLOAD-ONBOARDING-STEP_TEMPLATE-SETTING',
  'upload-setting'  : 'SHOP_UPLOAD-ONBOARDING-STEP_UPLOAD-SETTING',
};

/**
 * shop - upload-onboarding-step Short 코드 역매핑.
 */
export const ACLOSET_SHOP_UPLOAD_ONBOARDING_STEP_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopUploadOnboardingStepCode, AclosetShopUploadOnboardingStepShortCode>> = {
  'SHOP_UPLOAD-ONBOARDING-STEP_CAFE24-SETTING'  : 'cafe24-setting',
  'SHOP_UPLOAD-ONBOARDING-STEP_CATEGORY-SETTING': 'category-setting',
  'SHOP_UPLOAD-ONBOARDING-STEP_TEMPLATE-SETTING': 'template-setting',
  'SHOP_UPLOAD-ONBOARDING-STEP_UPLOAD-SETTING'  : 'upload-setting',
};

// ************************************************************************************************

/**
 * shop - template-type 리스트.
 */
export const ACLOSET_SHOP_TEMPLATE_TYPE_CODE_LIST = [
  'SHOP_TEMPLATE-TYPE_EXCHANGE-INFO',  // 교환·반품 안내
  'SHOP_TEMPLATE-TYPE_NORMAL',         // 보통
  'SHOP_TEMPLATE-TYPE_PAYMENT-INFO',   // 상품 결제 안내
  'SHOP_TEMPLATE-TYPE_PLAIN',          // 플레인
  'SHOP_TEMPLATE-TYPE_SERVICE-INFO',   // 서비스 문의·안내
  'SHOP_TEMPLATE-TYPE_SHIPPING-INFO',  // 상품 배송 안내
  'SHOP_TEMPLATE-TYPE_SIMPLE',         // 심플
] as const;

/**
 * shop - template-type 타입.
 */
export type AclosetShopTemplateTypeCode = (typeof ACLOSET_SHOP_TEMPLATE_TYPE_CODE_LIST)[number];

/**
 * shop - template-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_TEMPLATE_TYPE_SHORT_CODE_LIST = [
  'exchange-info',  // 교환·반품 안내
  'normal',         // 보통
  'payment-info',   // 상품 결제 안내
  'plain',          // 플레인
  'service-info',   // 서비스 문의·안내
  'shipping-info',  // 상품 배송 안내
  'simple',         // 심플
] as const;

/**
 * shop - template-type Short 코드 타입.
 */
export type AclosetShopTemplateTypeShortCode = (typeof ACLOSET_SHOP_TEMPLATE_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - template-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_TEMPLATE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopTemplateTypeShortCode, AclosetShopTemplateTypeCode>> = {
  'exchange-info': 'SHOP_TEMPLATE-TYPE_EXCHANGE-INFO',
  'normal'       : 'SHOP_TEMPLATE-TYPE_NORMAL',
  'payment-info' : 'SHOP_TEMPLATE-TYPE_PAYMENT-INFO',
  'plain'        : 'SHOP_TEMPLATE-TYPE_PLAIN',
  'service-info' : 'SHOP_TEMPLATE-TYPE_SERVICE-INFO',
  'shipping-info': 'SHOP_TEMPLATE-TYPE_SHIPPING-INFO',
  'simple'       : 'SHOP_TEMPLATE-TYPE_SIMPLE',
};

/**
 * shop - template-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_TEMPLATE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopTemplateTypeCode, AclosetShopTemplateTypeShortCode>> = {
  'SHOP_TEMPLATE-TYPE_EXCHANGE-INFO': 'exchange-info',
  'SHOP_TEMPLATE-TYPE_NORMAL'       : 'normal',
  'SHOP_TEMPLATE-TYPE_PAYMENT-INFO' : 'payment-info',
  'SHOP_TEMPLATE-TYPE_PLAIN'        : 'plain',
  'SHOP_TEMPLATE-TYPE_SERVICE-INFO' : 'service-info',
  'SHOP_TEMPLATE-TYPE_SHIPPING-INFO': 'shipping-info',
  'SHOP_TEMPLATE-TYPE_SIMPLE'       : 'simple',
};

// ************************************************************************************************

/**
 * shop - task-status 리스트.
 */
export const ACLOSET_SHOP_TASK_STATUS_CODE_LIST = [
  'SHOP_TASK-STATUS_ACLOSET-CATEGORY-INSPECTING-DONE',    // 세컨솔드 카테고리 검수 완료
  'SHOP_TASK-STATUS_BACKGROUND-REMOVAL-INSPECTING-DONE',  // 배경제거 검수 완료
  'SHOP_TASK-STATUS_BRAND-INSPECTING-DONE',               // 브랜드 검수 완료
  'SHOP_TASK-STATUS_COLOR-INSPECTING-DONE',               // 색상 검수 완료
  'SHOP_TASK-STATUS_CREATE-FAILED',                       // 상품 등록 실패
  'SHOP_TASK-STATUS_CREATING-DONE',                       // 상품 등록 완료
  'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE',               // 치수 타입 도출 중
  'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE-DONE',          // 치수 타입 도출 완료
  'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE-FAILED',        // 치수 타입 도출 실패
  'SHOP_TASK-STATUS_DONE',                                // 처리 완료
  'SHOP_TASK-STATUS_FABRIC-INSPECTING-DONE',              // 재질 검수 완료
  'SHOP_TASK-STATUS_IDLE',                                // 상품 등록 중
  'SHOP_TASK-STATUS_IMAGE-INSPECTING-DONE',               // 이미지 검수 완료
  'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING',               // 이미지 후처리 중
  'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING-DONE',          // 이미지 후처리 완료
  'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING-FAILED',        // 이미지 후처리 실패
  'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING',                // 이미지 전처리 중
  'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING-DONE',           // 이미지 전처리 완료
  'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING-FAILED',         // 이미지 전처리 실패
  'SHOP_TASK-STATUS_IN-CREATING',                         // 상품 등록 중
  'SHOP_TASK-STATUS_INFERENCING',                         // AI 분석 대기 중
  'SHOP_TASK-STATUS_INFERENCING-DONE',                    // AI 분석 완료
  'SHOP_TASK-STATUS_INFERENCING-FAILED',                  // AI 분석 실패
  'SHOP_TASK-STATUS_KEYPOINT-INSPECTING-DONE',            // 키포인트 검수 완료
  'SHOP_TASK-STATUS_POSTING',                             // 상품 등록 중
  'SHOP_TASK-STATUS_POSTING-DONE',                        // 상품 등록 완료
  'SHOP_TASK-STATUS_POSTING-FAILED',                      // 상품 등록 실패
] as const;

/**
 * shop - task-status 타입.
 */
export type AclosetShopTaskStatusCode = (typeof ACLOSET_SHOP_TASK_STATUS_CODE_LIST)[number];

/**
 * shop - task-status Short 코드 리스트.
 */
export const ACLOSET_SHOP_TASK_STATUS_SHORT_CODE_LIST = [
  'acloset-category-inspecting-done',    // 세컨솔드 카테고리 검수 완료
  'background-removal-inspecting-done',  // 배경제거 검수 완료
  'brand-inspecting-done',               // 브랜드 검수 완료
  'color-inspecting-done',               // 색상 검수 완료
  'create-failed',                       // 상품 등록 실패
  'creating-done',                       // 상품 등록 완료
  'deriving-clothes-type',               // 치수 타입 도출 중
  'deriving-clothes-type-done',          // 치수 타입 도출 완료
  'deriving-clothes-type-failed',        // 치수 타입 도출 실패
  'done',                                // 처리 완료
  'fabric-inspecting-done',              // 재질 검수 완료
  'idle',                                // 상품 등록 중
  'image-inspecting-done',               // 이미지 검수 완료
  'image-post-processing',               // 이미지 후처리 중
  'image-post-processing-done',          // 이미지 후처리 완료
  'image-post-processing-failed',        // 이미지 후처리 실패
  'image-pre-processing',                // 이미지 전처리 중
  'image-pre-processing-done',           // 이미지 전처리 완료
  'image-pre-processing-failed',         // 이미지 전처리 실패
  'in-creating',                         // 상품 등록 중
  'inferencing',                         // AI 분석 대기 중
  'inferencing-done',                    // AI 분석 완료
  'inferencing-failed',                  // AI 분석 실패
  'keypoint-inspecting-done',            // 키포인트 검수 완료
  'posting',                             // 상품 등록 중
  'posting-done',                        // 상품 등록 완료
  'posting-failed',                      // 상품 등록 실패
] as const;

/**
 * shop - task-status Short 코드 타입.
 */
export type AclosetShopTaskStatusShortCode = (typeof ACLOSET_SHOP_TASK_STATUS_SHORT_CODE_LIST)[number];

/**
 * shop - task-status Short 코드 매핑.
 */
export const ACLOSET_SHOP_TASK_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetShopTaskStatusShortCode, AclosetShopTaskStatusCode>> = {
  'acloset-category-inspecting-done'  : 'SHOP_TASK-STATUS_ACLOSET-CATEGORY-INSPECTING-DONE',
  'background-removal-inspecting-done': 'SHOP_TASK-STATUS_BACKGROUND-REMOVAL-INSPECTING-DONE',
  'brand-inspecting-done'             : 'SHOP_TASK-STATUS_BRAND-INSPECTING-DONE',
  'color-inspecting-done'             : 'SHOP_TASK-STATUS_COLOR-INSPECTING-DONE',
  'create-failed'                     : 'SHOP_TASK-STATUS_CREATE-FAILED',
  'creating-done'                     : 'SHOP_TASK-STATUS_CREATING-DONE',
  'deriving-clothes-type'             : 'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE',
  'deriving-clothes-type-done'        : 'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE-DONE',
  'deriving-clothes-type-failed'      : 'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE-FAILED',
  'done'                              : 'SHOP_TASK-STATUS_DONE',
  'fabric-inspecting-done'            : 'SHOP_TASK-STATUS_FABRIC-INSPECTING-DONE',
  'idle'                              : 'SHOP_TASK-STATUS_IDLE',
  'image-inspecting-done'             : 'SHOP_TASK-STATUS_IMAGE-INSPECTING-DONE',
  'image-post-processing'             : 'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING',
  'image-post-processing-done'        : 'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING-DONE',
  'image-post-processing-failed'      : 'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING-FAILED',
  'image-pre-processing'              : 'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING',
  'image-pre-processing-done'         : 'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING-DONE',
  'image-pre-processing-failed'       : 'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING-FAILED',
  'in-creating'                       : 'SHOP_TASK-STATUS_IN-CREATING',
  'inferencing'                       : 'SHOP_TASK-STATUS_INFERENCING',
  'inferencing-done'                  : 'SHOP_TASK-STATUS_INFERENCING-DONE',
  'inferencing-failed'                : 'SHOP_TASK-STATUS_INFERENCING-FAILED',
  'keypoint-inspecting-done'          : 'SHOP_TASK-STATUS_KEYPOINT-INSPECTING-DONE',
  'posting'                           : 'SHOP_TASK-STATUS_POSTING',
  'posting-done'                      : 'SHOP_TASK-STATUS_POSTING-DONE',
  'posting-failed'                    : 'SHOP_TASK-STATUS_POSTING-FAILED',
};

/**
 * shop - task-status Short 코드 역매핑.
 */
export const ACLOSET_SHOP_TASK_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopTaskStatusCode, AclosetShopTaskStatusShortCode>> = {
  'SHOP_TASK-STATUS_ACLOSET-CATEGORY-INSPECTING-DONE'  : 'acloset-category-inspecting-done',
  'SHOP_TASK-STATUS_BACKGROUND-REMOVAL-INSPECTING-DONE': 'background-removal-inspecting-done',
  'SHOP_TASK-STATUS_BRAND-INSPECTING-DONE'             : 'brand-inspecting-done',
  'SHOP_TASK-STATUS_COLOR-INSPECTING-DONE'             : 'color-inspecting-done',
  'SHOP_TASK-STATUS_CREATE-FAILED'                     : 'create-failed',
  'SHOP_TASK-STATUS_CREATING-DONE'                     : 'creating-done',
  'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE'             : 'deriving-clothes-type',
  'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE-DONE'        : 'deriving-clothes-type-done',
  'SHOP_TASK-STATUS_DERIVING-CLOTHES-TYPE-FAILED'      : 'deriving-clothes-type-failed',
  'SHOP_TASK-STATUS_DONE'                              : 'done',
  'SHOP_TASK-STATUS_FABRIC-INSPECTING-DONE'            : 'fabric-inspecting-done',
  'SHOP_TASK-STATUS_IDLE'                              : 'idle',
  'SHOP_TASK-STATUS_IMAGE-INSPECTING-DONE'             : 'image-inspecting-done',
  'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING'             : 'image-post-processing',
  'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING-DONE'        : 'image-post-processing-done',
  'SHOP_TASK-STATUS_IMAGE-POST-PROCESSING-FAILED'      : 'image-post-processing-failed',
  'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING'              : 'image-pre-processing',
  'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING-DONE'         : 'image-pre-processing-done',
  'SHOP_TASK-STATUS_IMAGE-PRE-PROCESSING-FAILED'       : 'image-pre-processing-failed',
  'SHOP_TASK-STATUS_IN-CREATING'                       : 'in-creating',
  'SHOP_TASK-STATUS_INFERENCING'                       : 'inferencing',
  'SHOP_TASK-STATUS_INFERENCING-DONE'                  : 'inferencing-done',
  'SHOP_TASK-STATUS_INFERENCING-FAILED'                : 'inferencing-failed',
  'SHOP_TASK-STATUS_KEYPOINT-INSPECTING-DONE'          : 'keypoint-inspecting-done',
  'SHOP_TASK-STATUS_POSTING'                           : 'posting',
  'SHOP_TASK-STATUS_POSTING-DONE'                      : 'posting-done',
  'SHOP_TASK-STATUS_POSTING-FAILED'                    : 'posting-failed',
};

// ************************************************************************************************

/**
 * shop - task-platform-status 리스트.
 */
export const ACLOSET_SHOP_TASK_PLATFORM_STATUS_CODE_LIST = [
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-DONE',         // 상품 업로드 완료
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-FAILED',       // 상품 업로드 실패
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-IDLE',         // 상품 업로드 대기
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-IN-PROGRESS',  // 상품 업로드 중
] as const;

/**
 * shop - task-platform-status 타입.
 */
export type AclosetShopTaskPlatformStatusCode = (typeof ACLOSET_SHOP_TASK_PLATFORM_STATUS_CODE_LIST)[number];

/**
 * shop - task-platform-status Short 코드 리스트.
 */
export const ACLOSET_SHOP_TASK_PLATFORM_STATUS_SHORT_CODE_LIST = [
  'upload-done',         // 상품 업로드 완료
  'upload-failed',       // 상품 업로드 실패
  'upload-idle',         // 상품 업로드 대기
  'upload-in-progress',  // 상품 업로드 중
] as const;

/**
 * shop - task-platform-status Short 코드 타입.
 */
export type AclosetShopTaskPlatformStatusShortCode = (typeof ACLOSET_SHOP_TASK_PLATFORM_STATUS_SHORT_CODE_LIST)[number];

/**
 * shop - task-platform-status Short 코드 매핑.
 */
export const ACLOSET_SHOP_TASK_PLATFORM_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetShopTaskPlatformStatusShortCode, AclosetShopTaskPlatformStatusCode>> = {
  'upload-done'       : 'SHOP_TASK-PLATFORM-STATUS_UPLOAD-DONE',
  'upload-failed'     : 'SHOP_TASK-PLATFORM-STATUS_UPLOAD-FAILED',
  'upload-idle'       : 'SHOP_TASK-PLATFORM-STATUS_UPLOAD-IDLE',
  'upload-in-progress': 'SHOP_TASK-PLATFORM-STATUS_UPLOAD-IN-PROGRESS',
};

/**
 * shop - task-platform-status Short 코드 역매핑.
 */
export const ACLOSET_SHOP_TASK_PLATFORM_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopTaskPlatformStatusCode, AclosetShopTaskPlatformStatusShortCode>> = {
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-DONE'       : 'upload-done',
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-FAILED'     : 'upload-failed',
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-IDLE'       : 'upload-idle',
  'SHOP_TASK-PLATFORM-STATUS_UPLOAD-IN-PROGRESS': 'upload-in-progress',
};

// ************************************************************************************************

/**
 * shop - task-inspection 리스트.
 */
export const ACLOSET_SHOP_TASK_INSPECTION_CODE_LIST = [
  'SHOP_TASK-INSPECTION_IMAGE',  // 이미지
] as const;

/**
 * shop - task-inspection 타입.
 */
export type AclosetShopTaskInspectionCode = (typeof ACLOSET_SHOP_TASK_INSPECTION_CODE_LIST)[number];

/**
 * shop - task-inspection Short 코드 리스트.
 */
export const ACLOSET_SHOP_TASK_INSPECTION_SHORT_CODE_LIST = [
  'image',  // 이미지
] as const;

/**
 * shop - task-inspection Short 코드 타입.
 */
export type AclosetShopTaskInspectionShortCode = (typeof ACLOSET_SHOP_TASK_INSPECTION_SHORT_CODE_LIST)[number];

/**
 * shop - task-inspection Short 코드 매핑.
 */
export const ACLOSET_SHOP_TASK_INSPECTION_SHORT_CODE_MAP: Readonly<Record<AclosetShopTaskInspectionShortCode, AclosetShopTaskInspectionCode>> = {
  'image': 'SHOP_TASK-INSPECTION_IMAGE',
};

/**
 * shop - task-inspection Short 코드 역매핑.
 */
export const ACLOSET_SHOP_TASK_INSPECTION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopTaskInspectionCode, AclosetShopTaskInspectionShortCode>> = {
  'SHOP_TASK-INSPECTION_IMAGE': 'image',
};

// ************************************************************************************************

/**
 * shop - special-size-notation 리스트.
 */
export const ACLOSET_SHOP_SPECIAL_SIZE_NOTATION_CODE_LIST = [
  'SHOP_SPECIAL-SIZE-NOTATION_CHEST-PAD',        // 가슴 치수와 함께 가슴패드 여부를 표기하고 싶어요
  'SHOP_SPECIAL-SIZE-NOTATION_LINER',            // 치수 마지막에 안감 여부를 표기하고 싶어요
  'SHOP_SPECIAL-SIZE-NOTATION_SHOULDER-PAD',     // 어깨 치수에 어깨패드 여부를 표기하고 싶어요
  'SHOP_SPECIAL-SIZE-NOTATION_SHOULDER-RAGLAN',  // 레글런 상품의 경우, 어깨 치수에 레글런으로 표기하고 싶어요
  'SHOP_SPECIAL-SIZE-NOTATION_WAIST-BANDING',    // 허리 치수에 허리 밴딩 여부를 표기하고 싶어요
] as const;

/**
 * shop - special-size-notation 타입.
 */
export type AclosetShopSpecialSizeNotationCode = (typeof ACLOSET_SHOP_SPECIAL_SIZE_NOTATION_CODE_LIST)[number];

/**
 * shop - special-size-notation Short 코드 리스트.
 */
export const ACLOSET_SHOP_SPECIAL_SIZE_NOTATION_SHORT_CODE_LIST = [
  'chest-pad',        // 가슴 치수와 함께 가슴패드 여부를 표기하고 싶어요
  'liner',            // 치수 마지막에 안감 여부를 표기하고 싶어요
  'shoulder-pad',     // 어깨 치수에 어깨패드 여부를 표기하고 싶어요
  'shoulder-raglan',  // 레글런 상품의 경우, 어깨 치수에 레글런으로 표기하고 싶어요
  'waist-banding',    // 허리 치수에 허리 밴딩 여부를 표기하고 싶어요
] as const;

/**
 * shop - special-size-notation Short 코드 타입.
 */
export type AclosetShopSpecialSizeNotationShortCode = (typeof ACLOSET_SHOP_SPECIAL_SIZE_NOTATION_SHORT_CODE_LIST)[number];

/**
 * shop - special-size-notation Short 코드 매핑.
 */
export const ACLOSET_SHOP_SPECIAL_SIZE_NOTATION_SHORT_CODE_MAP: Readonly<Record<AclosetShopSpecialSizeNotationShortCode, AclosetShopSpecialSizeNotationCode>> = {
  'chest-pad'      : 'SHOP_SPECIAL-SIZE-NOTATION_CHEST-PAD',
  'liner'          : 'SHOP_SPECIAL-SIZE-NOTATION_LINER',
  'shoulder-pad'   : 'SHOP_SPECIAL-SIZE-NOTATION_SHOULDER-PAD',
  'shoulder-raglan': 'SHOP_SPECIAL-SIZE-NOTATION_SHOULDER-RAGLAN',
  'waist-banding'  : 'SHOP_SPECIAL-SIZE-NOTATION_WAIST-BANDING',
};

/**
 * shop - special-size-notation Short 코드 역매핑.
 */
export const ACLOSET_SHOP_SPECIAL_SIZE_NOTATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopSpecialSizeNotationCode, AclosetShopSpecialSizeNotationShortCode>> = {
  'SHOP_SPECIAL-SIZE-NOTATION_CHEST-PAD'      : 'chest-pad',
  'SHOP_SPECIAL-SIZE-NOTATION_LINER'          : 'liner',
  'SHOP_SPECIAL-SIZE-NOTATION_SHOULDER-PAD'   : 'shoulder-pad',
  'SHOP_SPECIAL-SIZE-NOTATION_SHOULDER-RAGLAN': 'shoulder-raglan',
  'SHOP_SPECIAL-SIZE-NOTATION_WAIST-BANDING'  : 'waist-banding',
};

// ************************************************************************************************

/**
 * shop - sort-image-type 리스트.
 */
export const ACLOSET_SHOP_SORT_IMAGE_TYPE_CODE_LIST = [
  'SHOP_SORT-IMAGE-TYPE_AI',      // AI 정렬
  'SHOP_SORT-IMAGE-TYPE_MANUAL',  // 사용자 정렬
] as const;

/**
 * shop - sort-image-type 타입.
 */
export type AclosetShopSortImageTypeCode = (typeof ACLOSET_SHOP_SORT_IMAGE_TYPE_CODE_LIST)[number];

/**
 * shop - sort-image-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_SORT_IMAGE_TYPE_SHORT_CODE_LIST = [
  'ai',      // AI 정렬
  'manual',  // 사용자 정렬
] as const;

/**
 * shop - sort-image-type Short 코드 타입.
 */
export type AclosetShopSortImageTypeShortCode = (typeof ACLOSET_SHOP_SORT_IMAGE_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - sort-image-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_SORT_IMAGE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopSortImageTypeShortCode, AclosetShopSortImageTypeCode>> = {
  'ai'    : 'SHOP_SORT-IMAGE-TYPE_AI',
  'manual': 'SHOP_SORT-IMAGE-TYPE_MANUAL',
};

/**
 * shop - sort-image-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_SORT_IMAGE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopSortImageTypeCode, AclosetShopSortImageTypeShortCode>> = {
  'SHOP_SORT-IMAGE-TYPE_AI'    : 'ai',
  'SHOP_SORT-IMAGE-TYPE_MANUAL': 'manual',
};

// ************************************************************************************************

/**
 * shop - size-notation 리스트.
 */
export const ACLOSET_SHOP_SIZE_NOTATION_CODE_LIST = [
  'SHOP_SIZE-NOTATION_SIZE-AND-INCH',  // 치수와 함께 인치를 자동 계산하여 표기해주세요
  'SHOP_SIZE-NOTATION_SIZE-ONLY',      // 치수만 표기해주세요
] as const;

/**
 * shop - size-notation 타입.
 */
export type AclosetShopSizeNotationCode = (typeof ACLOSET_SHOP_SIZE_NOTATION_CODE_LIST)[number];

/**
 * shop - size-notation Short 코드 리스트.
 */
export const ACLOSET_SHOP_SIZE_NOTATION_SHORT_CODE_LIST = [
  'size-and-inch',  // 치수와 함께 인치를 자동 계산하여 표기해주세요
  'size-only',      // 치수만 표기해주세요
] as const;

/**
 * shop - size-notation Short 코드 타입.
 */
export type AclosetShopSizeNotationShortCode = (typeof ACLOSET_SHOP_SIZE_NOTATION_SHORT_CODE_LIST)[number];

/**
 * shop - size-notation Short 코드 매핑.
 */
export const ACLOSET_SHOP_SIZE_NOTATION_SHORT_CODE_MAP: Readonly<Record<AclosetShopSizeNotationShortCode, AclosetShopSizeNotationCode>> = {
  'size-and-inch': 'SHOP_SIZE-NOTATION_SIZE-AND-INCH',
  'size-only'    : 'SHOP_SIZE-NOTATION_SIZE-ONLY',
};

/**
 * shop - size-notation Short 코드 역매핑.
 */
export const ACLOSET_SHOP_SIZE_NOTATION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopSizeNotationCode, AclosetShopSizeNotationShortCode>> = {
  'SHOP_SIZE-NOTATION_SIZE-AND-INCH': 'size-and-inch',
  'SHOP_SIZE-NOTATION_SIZE-ONLY'    : 'size-only',
};

// ************************************************************************************************

/**
 * shop - sign-up-route 리스트.
 */
export const ACLOSET_SHOP_SIGN_UP_ROUTE_CODE_LIST = [
  'SHOP_SIGN-UP-ROUTE_CAFE24',  // 카페24 계정을 통한 회원가입
  'SHOP_SIGN-UP-ROUTE_NORMAL',  // 일반 회원가입
] as const;

/**
 * shop - sign-up-route 타입.
 */
export type AclosetShopSignUpRouteCode = (typeof ACLOSET_SHOP_SIGN_UP_ROUTE_CODE_LIST)[number];

/**
 * shop - sign-up-route Short 코드 리스트.
 */
export const ACLOSET_SHOP_SIGN_UP_ROUTE_SHORT_CODE_LIST = [
  'cafe24',  // 카페24 계정을 통한 회원가입
  'normal',  // 일반 회원가입
] as const;

/**
 * shop - sign-up-route Short 코드 타입.
 */
export type AclosetShopSignUpRouteShortCode = (typeof ACLOSET_SHOP_SIGN_UP_ROUTE_SHORT_CODE_LIST)[number];

/**
 * shop - sign-up-route Short 코드 매핑.
 */
export const ACLOSET_SHOP_SIGN_UP_ROUTE_SHORT_CODE_MAP: Readonly<Record<AclosetShopSignUpRouteShortCode, AclosetShopSignUpRouteCode>> = {
  'cafe24': 'SHOP_SIGN-UP-ROUTE_CAFE24',
  'normal': 'SHOP_SIGN-UP-ROUTE_NORMAL',
};

/**
 * shop - sign-up-route Short 코드 역매핑.
 */
export const ACLOSET_SHOP_SIGN_UP_ROUTE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopSignUpRouteCode, AclosetShopSignUpRouteShortCode>> = {
  'SHOP_SIGN-UP-ROUTE_CAFE24': 'cafe24',
  'SHOP_SIGN-UP-ROUTE_NORMAL': 'normal',
};

// ************************************************************************************************

/**
 * shop - shooting-environment 리스트.
 */
export const ACLOSET_SHOP_SHOOTING_ENVIRONMENT_CODE_LIST = [
  'SHOP_SHOOTING-ENVIRONMENT_DISABLE-BACKLIGHT',  // 백라이트 미사용
  'SHOP_SHOOTING-ENVIRONMENT_ENABLE-BACKLIGHT',   // 백라이트 사용
] as const;

/**
 * shop - shooting-environment 타입.
 */
export type AclosetShopShootingEnvironmentCode = (typeof ACLOSET_SHOP_SHOOTING_ENVIRONMENT_CODE_LIST)[number];

/**
 * shop - shooting-environment Short 코드 리스트.
 */
export const ACLOSET_SHOP_SHOOTING_ENVIRONMENT_SHORT_CODE_LIST = [
  'disable-backlight',  // 백라이트 미사용
  'enable-backlight',   // 백라이트 사용
] as const;

/**
 * shop - shooting-environment Short 코드 타입.
 */
export type AclosetShopShootingEnvironmentShortCode = (typeof ACLOSET_SHOP_SHOOTING_ENVIRONMENT_SHORT_CODE_LIST)[number];

/**
 * shop - shooting-environment Short 코드 매핑.
 */
export const ACLOSET_SHOP_SHOOTING_ENVIRONMENT_SHORT_CODE_MAP: Readonly<Record<AclosetShopShootingEnvironmentShortCode, AclosetShopShootingEnvironmentCode>> = {
  'disable-backlight': 'SHOP_SHOOTING-ENVIRONMENT_DISABLE-BACKLIGHT',
  'enable-backlight' : 'SHOP_SHOOTING-ENVIRONMENT_ENABLE-BACKLIGHT',
};

/**
 * shop - shooting-environment Short 코드 역매핑.
 */
export const ACLOSET_SHOP_SHOOTING_ENVIRONMENT_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopShootingEnvironmentCode, AclosetShopShootingEnvironmentShortCode>> = {
  'SHOP_SHOOTING-ENVIRONMENT_DISABLE-BACKLIGHT': 'disable-backlight',
  'SHOP_SHOOTING-ENVIRONMENT_ENABLE-BACKLIGHT' : 'enable-backlight',
};

// ************************************************************************************************

/**
 * shop - platform-type 리스트.
 */
export const ACLOSET_SHOP_PLATFORM_TYPE_CODE_LIST = [
  'SHOP_PLATFORM-TYPE_ACLOSET',            // 세컨솔드
  'SHOP_PLATFORM-TYPE_BUNJANG',            // 번개장터
  'SHOP_PLATFORM-TYPE_CAFE24',             // 카페24
  'SHOP_PLATFORM-TYPE_INSTAGRAM',          // 인스타그램
  'SHOP_PLATFORM-TYPE_NAVER-SMART-STORE',  // 네이버
  'SHOP_PLATFORM-TYPE_OKPOS',              // 오케이포스
  'SHOP_PLATFORM-TYPE_PLAYAUTO',           // 플레이오토
] as const;

/**
 * shop - platform-type 타입.
 */
export type AclosetShopPlatformTypeCode = (typeof ACLOSET_SHOP_PLATFORM_TYPE_CODE_LIST)[number];

/**
 * shop - platform-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_PLATFORM_TYPE_SHORT_CODE_LIST = [
  'acloset',            // 세컨솔드
  'bunjang',            // 번개장터
  'cafe24',             // 카페24
  'instagram',          // 인스타그램
  'naver-smart-store',  // 네이버
  'okpos',              // 오케이포스
  'playauto',           // 플레이오토
] as const;

/**
 * shop - platform-type Short 코드 타입.
 */
export type AclosetShopPlatformTypeShortCode = (typeof ACLOSET_SHOP_PLATFORM_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - platform-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_PLATFORM_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopPlatformTypeShortCode, AclosetShopPlatformTypeCode>> = {
  'acloset'          : 'SHOP_PLATFORM-TYPE_ACLOSET',
  'bunjang'          : 'SHOP_PLATFORM-TYPE_BUNJANG',
  'cafe24'           : 'SHOP_PLATFORM-TYPE_CAFE24',
  'instagram'        : 'SHOP_PLATFORM-TYPE_INSTAGRAM',
  'naver-smart-store': 'SHOP_PLATFORM-TYPE_NAVER-SMART-STORE',
  'okpos'            : 'SHOP_PLATFORM-TYPE_OKPOS',
  'playauto'         : 'SHOP_PLATFORM-TYPE_PLAYAUTO',
};

/**
 * shop - platform-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_PLATFORM_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopPlatformTypeCode, AclosetShopPlatformTypeShortCode>> = {
  'SHOP_PLATFORM-TYPE_ACLOSET'          : 'acloset',
  'SHOP_PLATFORM-TYPE_BUNJANG'          : 'bunjang',
  'SHOP_PLATFORM-TYPE_CAFE24'           : 'cafe24',
  'SHOP_PLATFORM-TYPE_INSTAGRAM'        : 'instagram',
  'SHOP_PLATFORM-TYPE_NAVER-SMART-STORE': 'naver-smart-store',
  'SHOP_PLATFORM-TYPE_OKPOS'            : 'okpos',
  'SHOP_PLATFORM-TYPE_PLAYAUTO'         : 'playauto',
};

// ************************************************************************************************

/**
 * shop - platform-image-ratio 리스트.
 */
export const ACLOSET_SHOP_PLATFORM_IMAGE_RATIO_CODE_LIST = [
  'SHOP_PLATFORM-IMAGE-RATIO_FIVE-TO-FOUR',   // 5:4
  'SHOP_PLATFORM-IMAGE-RATIO_FIVE-TO-SIX',    // 5:6
  'SHOP_PLATFORM-IMAGE-RATIO_FOUR-TO-FIVE',   // 4:5
  'SHOP_PLATFORM-IMAGE-RATIO_FOUR-TO-THREE',  // 4:3
  'SHOP_PLATFORM-IMAGE-RATIO_ONE-TO-ONE',     // 1:1
  'SHOP_PLATFORM-IMAGE-RATIO_SEVEN-TO-SIX',   // 7:6
  'SHOP_PLATFORM-IMAGE-RATIO_SIX-TO-FIVE',    // 6:5
  'SHOP_PLATFORM-IMAGE-RATIO_SIX-TO-SEVEN',   // 6:7
  'SHOP_PLATFORM-IMAGE-RATIO_THREE-TO-FOUR',  // 3:4
  'SHOP_PLATFORM-IMAGE-RATIO_THREE-TO-TWO',   // 3:2
  'SHOP_PLATFORM-IMAGE-RATIO_TWO-TO-THREE',   // 2:3
] as const;

/**
 * shop - platform-image-ratio 타입.
 */
export type AclosetShopPlatformImageRatioCode = (typeof ACLOSET_SHOP_PLATFORM_IMAGE_RATIO_CODE_LIST)[number];

/**
 * shop - platform-image-ratio Short 코드 리스트.
 */
export const ACLOSET_SHOP_PLATFORM_IMAGE_RATIO_SHORT_CODE_LIST = [
  'five-to-four',   // 5:4
  'five-to-six',    // 5:6
  'four-to-five',   // 4:5
  'four-to-three',  // 4:3
  'one-to-one',     // 1:1
  'seven-to-six',   // 7:6
  'six-to-five',    // 6:5
  'six-to-seven',   // 6:7
  'three-to-four',  // 3:4
  'three-to-two',   // 3:2
  'two-to-three',   // 2:3
] as const;

/**
 * shop - platform-image-ratio Short 코드 타입.
 */
export type AclosetShopPlatformImageRatioShortCode = (typeof ACLOSET_SHOP_PLATFORM_IMAGE_RATIO_SHORT_CODE_LIST)[number];

/**
 * shop - platform-image-ratio Short 코드 매핑.
 */
export const ACLOSET_SHOP_PLATFORM_IMAGE_RATIO_SHORT_CODE_MAP: Readonly<Record<AclosetShopPlatformImageRatioShortCode, AclosetShopPlatformImageRatioCode>> = {
  'five-to-four' : 'SHOP_PLATFORM-IMAGE-RATIO_FIVE-TO-FOUR',
  'five-to-six'  : 'SHOP_PLATFORM-IMAGE-RATIO_FIVE-TO-SIX',
  'four-to-five' : 'SHOP_PLATFORM-IMAGE-RATIO_FOUR-TO-FIVE',
  'four-to-three': 'SHOP_PLATFORM-IMAGE-RATIO_FOUR-TO-THREE',
  'one-to-one'   : 'SHOP_PLATFORM-IMAGE-RATIO_ONE-TO-ONE',
  'seven-to-six' : 'SHOP_PLATFORM-IMAGE-RATIO_SEVEN-TO-SIX',
  'six-to-five'  : 'SHOP_PLATFORM-IMAGE-RATIO_SIX-TO-FIVE',
  'six-to-seven' : 'SHOP_PLATFORM-IMAGE-RATIO_SIX-TO-SEVEN',
  'three-to-four': 'SHOP_PLATFORM-IMAGE-RATIO_THREE-TO-FOUR',
  'three-to-two' : 'SHOP_PLATFORM-IMAGE-RATIO_THREE-TO-TWO',
  'two-to-three' : 'SHOP_PLATFORM-IMAGE-RATIO_TWO-TO-THREE',
};

/**
 * shop - platform-image-ratio Short 코드 역매핑.
 */
export const ACLOSET_SHOP_PLATFORM_IMAGE_RATIO_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopPlatformImageRatioCode, AclosetShopPlatformImageRatioShortCode>> = {
  'SHOP_PLATFORM-IMAGE-RATIO_FIVE-TO-FOUR' : 'five-to-four',
  'SHOP_PLATFORM-IMAGE-RATIO_FIVE-TO-SIX'  : 'five-to-six',
  'SHOP_PLATFORM-IMAGE-RATIO_FOUR-TO-FIVE' : 'four-to-five',
  'SHOP_PLATFORM-IMAGE-RATIO_FOUR-TO-THREE': 'four-to-three',
  'SHOP_PLATFORM-IMAGE-RATIO_ONE-TO-ONE'   : 'one-to-one',
  'SHOP_PLATFORM-IMAGE-RATIO_SEVEN-TO-SIX' : 'seven-to-six',
  'SHOP_PLATFORM-IMAGE-RATIO_SIX-TO-FIVE'  : 'six-to-five',
  'SHOP_PLATFORM-IMAGE-RATIO_SIX-TO-SEVEN' : 'six-to-seven',
  'SHOP_PLATFORM-IMAGE-RATIO_THREE-TO-FOUR': 'three-to-four',
  'SHOP_PLATFORM-IMAGE-RATIO_THREE-TO-TWO' : 'three-to-two',
  'SHOP_PLATFORM-IMAGE-RATIO_TWO-TO-THREE' : 'two-to-three',
};

// ************************************************************************************************

/**
 * shop - origin-setting-notation-type 리스트.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_NOTATION_TYPE_CODE_LIST = [
  'SHOP_ORIGIN-SETTING-NOTATION-TYPE_ENGLISH-CAPITAL',          // 영문 대문자
  'SHOP_ORIGIN-SETTING-NOTATION-TYPE_KOREAN',                   // 한글
  'SHOP_ORIGIN-SETTING-NOTATION-TYPE_MADE-IN-ENGLISH-CAPITAL',  // Made in 영문 대문자
] as const;

/**
 * shop - origin-setting-notation-type 타입.
 */
export type AclosetShopOriginSettingNotationTypeCode = (typeof ACLOSET_SHOP_ORIGIN_SETTING_NOTATION_TYPE_CODE_LIST)[number];

/**
 * shop - origin-setting-notation-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_NOTATION_TYPE_SHORT_CODE_LIST = [
  'english-capital',          // 영문 대문자
  'korean',                   // 한글
  'made-in-english-capital',  // Made in 영문 대문자
] as const;

/**
 * shop - origin-setting-notation-type Short 코드 타입.
 */
export type AclosetShopOriginSettingNotationTypeShortCode = (typeof ACLOSET_SHOP_ORIGIN_SETTING_NOTATION_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - origin-setting-notation-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_NOTATION_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopOriginSettingNotationTypeShortCode, AclosetShopOriginSettingNotationTypeCode>> = {
  'english-capital'        : 'SHOP_ORIGIN-SETTING-NOTATION-TYPE_ENGLISH-CAPITAL',
  'korean'                 : 'SHOP_ORIGIN-SETTING-NOTATION-TYPE_KOREAN',
  'made-in-english-capital': 'SHOP_ORIGIN-SETTING-NOTATION-TYPE_MADE-IN-ENGLISH-CAPITAL',
};

/**
 * shop - origin-setting-notation-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_NOTATION_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopOriginSettingNotationTypeCode, AclosetShopOriginSettingNotationTypeShortCode>> = {
  'SHOP_ORIGIN-SETTING-NOTATION-TYPE_ENGLISH-CAPITAL'        : 'english-capital',
  'SHOP_ORIGIN-SETTING-NOTATION-TYPE_KOREAN'                 : 'korean',
  'SHOP_ORIGIN-SETTING-NOTATION-TYPE_MADE-IN-ENGLISH-CAPITAL': 'made-in-english-capital',
};

// ************************************************************************************************

/**
 * shop - origin-setting-auto-country-type 리스트.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_AUTO_COUNTRY_TYPE_CODE_LIST = [
  'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_ALL',                  // 전세계 모든 국가
  'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_DEVELOPED-AND-KOREA',  // 주요 해외 선진국과 대한민국만
  'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_DEVELOPED-ONLY',       // 주요 해외 선진국만
] as const;

/**
 * shop - origin-setting-auto-country-type 타입.
 */
export type AclosetShopOriginSettingAutoCountryTypeCode = (typeof ACLOSET_SHOP_ORIGIN_SETTING_AUTO_COUNTRY_TYPE_CODE_LIST)[number];

/**
 * shop - origin-setting-auto-country-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_AUTO_COUNTRY_TYPE_SHORT_CODE_LIST = [
  'all',                  // 전세계 모든 국가
  'developed-and-korea',  // 주요 해외 선진국과 대한민국만
  'developed-only',       // 주요 해외 선진국만
] as const;

/**
 * shop - origin-setting-auto-country-type Short 코드 타입.
 */
export type AclosetShopOriginSettingAutoCountryTypeShortCode = (typeof ACLOSET_SHOP_ORIGIN_SETTING_AUTO_COUNTRY_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - origin-setting-auto-country-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_AUTO_COUNTRY_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopOriginSettingAutoCountryTypeShortCode, AclosetShopOriginSettingAutoCountryTypeCode>> = {
  'all'                : 'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_ALL',
  'developed-and-korea': 'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_DEVELOPED-AND-KOREA',
  'developed-only'     : 'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_DEVELOPED-ONLY',
};

/**
 * shop - origin-setting-auto-country-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ORIGIN_SETTING_AUTO_COUNTRY_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopOriginSettingAutoCountryTypeCode, AclosetShopOriginSettingAutoCountryTypeShortCode>> = {
  'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_ALL'                : 'all',
  'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_DEVELOPED-AND-KOREA': 'developed-and-korea',
  'SHOP_ORIGIN-SETTING-AUTO-COUNTRY-TYPE_DEVELOPED-ONLY'     : 'developed-only',
};

// ************************************************************************************************

/**
 * shop - onboard-status 리스트.
 */
export const ACLOSET_SHOP_ONBOARD_STATUS_CODE_LIST = [
  'SHOP_ONBOARD-STATUS_FINISHED',      // 온보딩 설정 완료
  'SHOP_ONBOARD-STATUS_NOT-FINISHED',  // 온보딩 설정 미완료
] as const;

/**
 * shop - onboard-status 타입.
 */
export type AclosetShopOnboardStatusCode = (typeof ACLOSET_SHOP_ONBOARD_STATUS_CODE_LIST)[number];

/**
 * shop - onboard-status Short 코드 리스트.
 */
export const ACLOSET_SHOP_ONBOARD_STATUS_SHORT_CODE_LIST = [
  'finished',      // 온보딩 설정 완료
  'not-finished',  // 온보딩 설정 미완료
] as const;

/**
 * shop - onboard-status Short 코드 타입.
 */
export type AclosetShopOnboardStatusShortCode = (typeof ACLOSET_SHOP_ONBOARD_STATUS_SHORT_CODE_LIST)[number];

/**
 * shop - onboard-status Short 코드 매핑.
 */
export const ACLOSET_SHOP_ONBOARD_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetShopOnboardStatusShortCode, AclosetShopOnboardStatusCode>> = {
  'finished'    : 'SHOP_ONBOARD-STATUS_FINISHED',
  'not-finished': 'SHOP_ONBOARD-STATUS_NOT-FINISHED',
};

/**
 * shop - onboard-status Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ONBOARD_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopOnboardStatusCode, AclosetShopOnboardStatusShortCode>> = {
  'SHOP_ONBOARD-STATUS_FINISHED'    : 'finished',
  'SHOP_ONBOARD-STATUS_NOT-FINISHED': 'not-finished',
};

// ************************************************************************************************

/**
 * shop - item-upload-status 리스트.
 */
export const ACLOSET_SHOP_ITEM_UPLOAD_STATUS_CODE_LIST = [
  'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE',             // 치수 타입 도출 중
  'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE-DONE',        // 치수 타입 도출 완료
  'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE-FAILED',      // 치수 타입 도출 실패
  'SHOP_ITEM-UPLOAD-STATUS_DONE',                              // AI 분석 완료
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD',         // 검색 키워드 생성 중
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD-DONE',    // 검색 키워드 생성 완료
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD-FAILED',  // 검색 키워드 생성 실패
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE',                  // 상품명 생성 중
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE-DONE',             // 상품명 생성 완료
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE-FAILED',           // 상품명 생성 실패
  'SHOP_ITEM-UPLOAD-STATUS_IDLE',                              // 상품 생성 중
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING',             // 이미지 후처리 중
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING-DONE',        // 이미지 후처리 완료
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING-FAILED',      // 이미지 후처리 실패
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING',              // 이미지 전처리 중
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING-DONE',         // 이미지 전처리 완료
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING-FAILED',       // 이미지 전처리 실패
  'SHOP_ITEM-UPLOAD-STATUS_INFERENCING',                       // AI 추론 중
  'SHOP_ITEM-UPLOAD-STATUS_INFERENCING-DONE',                  // AI 추론 완료
  'SHOP_ITEM-UPLOAD-STATUS_INFERENCING-FAILED',                // AI 추론 실패
  'SHOP_ITEM-UPLOAD-STATUS_LOAD-FAILED',                       // 상품 불러오기 실패
  'SHOP_ITEM-UPLOAD-STATUS_LOADING',                           // 상품 불러오기 중
  'SHOP_ITEM-UPLOAD-STATUS_POSTING',                           // 상품 등록 중
  'SHOP_ITEM-UPLOAD-STATUS_POSTING-DONE',                      // 상품 등록 완료
  'SHOP_ITEM-UPLOAD-STATUS_POSTING-FAILED',                    // 상품 등록 실패
] as const;

/**
 * shop - item-upload-status 타입.
 */
export type AclosetShopItemUploadStatusCode = (typeof ACLOSET_SHOP_ITEM_UPLOAD_STATUS_CODE_LIST)[number];

/**
 * shop - item-upload-status Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_UPLOAD_STATUS_SHORT_CODE_LIST = [
  'deriving-clothes-type',             // 치수 타입 도출 중
  'deriving-clothes-type-done',        // 치수 타입 도출 완료
  'deriving-clothes-type-failed',      // 치수 타입 도출 실패
  'done',                              // AI 분석 완료
  'generating-search-keyword',         // 검색 키워드 생성 중
  'generating-search-keyword-done',    // 검색 키워드 생성 완료
  'generating-search-keyword-failed',  // 검색 키워드 생성 실패
  'generating-title',                  // 상품명 생성 중
  'generating-title-done',             // 상품명 생성 완료
  'generating-title-failed',           // 상품명 생성 실패
  'idle',                              // 상품 생성 중
  'image-post-processing',             // 이미지 후처리 중
  'image-post-processing-done',        // 이미지 후처리 완료
  'image-post-processing-failed',      // 이미지 후처리 실패
  'image-pre-processing',              // 이미지 전처리 중
  'image-pre-processing-done',         // 이미지 전처리 완료
  'image-pre-processing-failed',       // 이미지 전처리 실패
  'inferencing',                       // AI 추론 중
  'inferencing-done',                  // AI 추론 완료
  'inferencing-failed',                // AI 추론 실패
  'load-failed',                       // 상품 불러오기 실패
  'loading',                           // 상품 불러오기 중
  'posting',                           // 상품 등록 중
  'posting-done',                      // 상품 등록 완료
  'posting-failed',                    // 상품 등록 실패
] as const;

/**
 * shop - item-upload-status Short 코드 타입.
 */
export type AclosetShopItemUploadStatusShortCode = (typeof ACLOSET_SHOP_ITEM_UPLOAD_STATUS_SHORT_CODE_LIST)[number];

/**
 * shop - item-upload-status Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_UPLOAD_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemUploadStatusShortCode, AclosetShopItemUploadStatusCode>> = {
  'deriving-clothes-type'           : 'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE',
  'deriving-clothes-type-done'      : 'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE-DONE',
  'deriving-clothes-type-failed'    : 'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE-FAILED',
  'done'                            : 'SHOP_ITEM-UPLOAD-STATUS_DONE',
  'generating-search-keyword'       : 'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD',
  'generating-search-keyword-done'  : 'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD-DONE',
  'generating-search-keyword-failed': 'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD-FAILED',
  'generating-title'                : 'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE',
  'generating-title-done'           : 'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE-DONE',
  'generating-title-failed'         : 'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE-FAILED',
  'idle'                            : 'SHOP_ITEM-UPLOAD-STATUS_IDLE',
  'image-post-processing'           : 'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING',
  'image-post-processing-done'      : 'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING-DONE',
  'image-post-processing-failed'    : 'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING-FAILED',
  'image-pre-processing'            : 'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING',
  'image-pre-processing-done'       : 'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING-DONE',
  'image-pre-processing-failed'     : 'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING-FAILED',
  'inferencing'                     : 'SHOP_ITEM-UPLOAD-STATUS_INFERENCING',
  'inferencing-done'                : 'SHOP_ITEM-UPLOAD-STATUS_INFERENCING-DONE',
  'inferencing-failed'              : 'SHOP_ITEM-UPLOAD-STATUS_INFERENCING-FAILED',
  'load-failed'                     : 'SHOP_ITEM-UPLOAD-STATUS_LOAD-FAILED',
  'loading'                         : 'SHOP_ITEM-UPLOAD-STATUS_LOADING',
  'posting'                         : 'SHOP_ITEM-UPLOAD-STATUS_POSTING',
  'posting-done'                    : 'SHOP_ITEM-UPLOAD-STATUS_POSTING-DONE',
  'posting-failed'                  : 'SHOP_ITEM-UPLOAD-STATUS_POSTING-FAILED',
};

/**
 * shop - item-upload-status Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_UPLOAD_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemUploadStatusCode, AclosetShopItemUploadStatusShortCode>> = {
  'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE'           : 'deriving-clothes-type',
  'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE-DONE'      : 'deriving-clothes-type-done',
  'SHOP_ITEM-UPLOAD-STATUS_DERIVING-CLOTHES-TYPE-FAILED'    : 'deriving-clothes-type-failed',
  'SHOP_ITEM-UPLOAD-STATUS_DONE'                            : 'done',
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD'       : 'generating-search-keyword',
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD-DONE'  : 'generating-search-keyword-done',
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-SEARCH-KEYWORD-FAILED': 'generating-search-keyword-failed',
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE'                : 'generating-title',
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE-DONE'           : 'generating-title-done',
  'SHOP_ITEM-UPLOAD-STATUS_GENERATING-TITLE-FAILED'         : 'generating-title-failed',
  'SHOP_ITEM-UPLOAD-STATUS_IDLE'                            : 'idle',
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING'           : 'image-post-processing',
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING-DONE'      : 'image-post-processing-done',
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-POST-PROCESSING-FAILED'    : 'image-post-processing-failed',
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING'            : 'image-pre-processing',
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING-DONE'       : 'image-pre-processing-done',
  'SHOP_ITEM-UPLOAD-STATUS_IMAGE-PRE-PROCESSING-FAILED'     : 'image-pre-processing-failed',
  'SHOP_ITEM-UPLOAD-STATUS_INFERENCING'                     : 'inferencing',
  'SHOP_ITEM-UPLOAD-STATUS_INFERENCING-DONE'                : 'inferencing-done',
  'SHOP_ITEM-UPLOAD-STATUS_INFERENCING-FAILED'              : 'inferencing-failed',
  'SHOP_ITEM-UPLOAD-STATUS_LOAD-FAILED'                     : 'load-failed',
  'SHOP_ITEM-UPLOAD-STATUS_LOADING'                         : 'loading',
  'SHOP_ITEM-UPLOAD-STATUS_POSTING'                         : 'posting',
  'SHOP_ITEM-UPLOAD-STATUS_POSTING-DONE'                    : 'posting-done',
  'SHOP_ITEM-UPLOAD-STATUS_POSTING-FAILED'                  : 'posting-failed',
};

// ************************************************************************************************

/**
 * shop - item-input 리스트.
 */
export const ACLOSET_SHOP_ITEM_INPUT_CODE_LIST = [
  'SHOP_ITEM-INPUT_AI-DESCRIPTION',      // AI 상품설명
  'SHOP_ITEM-INPUT_COLOR',               // 색상
  'SHOP_ITEM-INPUT_CONDITION',           // 컨디션
  'SHOP_ITEM-INPUT_CUSTOM-INPUT-FIELD',  // 자유 입력란
  'SHOP_ITEM-INPUT_FABRIC',              // 소재
  'SHOP_ITEM-INPUT_KEYWORD',             // 키워드
  'SHOP_ITEM-INPUT_ORIGIN',              // 원산지
  'SHOP_ITEM-INPUT_RETAIL-PRICE',        // 소비자가
  'SHOP_ITEM-INPUT_SIZE',                // 사이즈
] as const;

/**
 * shop - item-input 타입.
 */
export type AclosetShopItemInputCode = (typeof ACLOSET_SHOP_ITEM_INPUT_CODE_LIST)[number];

/**
 * shop - item-input Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_INPUT_SHORT_CODE_LIST = [
  'ai-description',      // AI 상품설명
  'color',               // 색상
  'condition',           // 컨디션
  'custom-input-field',  // 자유 입력란
  'fabric',              // 소재
  'keyword',             // 키워드
  'origin',              // 원산지
  'retail-price',        // 소비자가
  'size',                // 사이즈
] as const;

/**
 * shop - item-input Short 코드 타입.
 */
export type AclosetShopItemInputShortCode = (typeof ACLOSET_SHOP_ITEM_INPUT_SHORT_CODE_LIST)[number];

/**
 * shop - item-input Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_INPUT_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemInputShortCode, AclosetShopItemInputCode>> = {
  'ai-description'    : 'SHOP_ITEM-INPUT_AI-DESCRIPTION',
  'color'             : 'SHOP_ITEM-INPUT_COLOR',
  'condition'         : 'SHOP_ITEM-INPUT_CONDITION',
  'custom-input-field': 'SHOP_ITEM-INPUT_CUSTOM-INPUT-FIELD',
  'fabric'            : 'SHOP_ITEM-INPUT_FABRIC',
  'keyword'           : 'SHOP_ITEM-INPUT_KEYWORD',
  'origin'            : 'SHOP_ITEM-INPUT_ORIGIN',
  'retail-price'      : 'SHOP_ITEM-INPUT_RETAIL-PRICE',
  'size'              : 'SHOP_ITEM-INPUT_SIZE',
};

/**
 * shop - item-input Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_INPUT_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemInputCode, AclosetShopItemInputShortCode>> = {
  'SHOP_ITEM-INPUT_AI-DESCRIPTION'    : 'ai-description',
  'SHOP_ITEM-INPUT_COLOR'             : 'color',
  'SHOP_ITEM-INPUT_CONDITION'         : 'condition',
  'SHOP_ITEM-INPUT_CUSTOM-INPUT-FIELD': 'custom-input-field',
  'SHOP_ITEM-INPUT_FABRIC'            : 'fabric',
  'SHOP_ITEM-INPUT_KEYWORD'           : 'keyword',
  'SHOP_ITEM-INPUT_ORIGIN'            : 'origin',
  'SHOP_ITEM-INPUT_RETAIL-PRICE'      : 'retail-price',
  'SHOP_ITEM-INPUT_SIZE'              : 'size',
};

// ************************************************************************************************

/**
 * shop - item-image-margin 리스트.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_MARGIN_CODE_LIST = [
  'SHOP_ITEM-IMAGE-MARGIN_MIDDLE',  // 중간
  'SHOP_ITEM-IMAGE-MARGIN_NARROW',  // 좁음
  'SHOP_ITEM-IMAGE-MARGIN_WIDE',    // 넓음
] as const;

/**
 * shop - item-image-margin 타입.
 */
export type AclosetShopItemImageMarginCode = (typeof ACLOSET_SHOP_ITEM_IMAGE_MARGIN_CODE_LIST)[number];

/**
 * shop - item-image-margin Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_MARGIN_SHORT_CODE_LIST = [
  'middle',  // 중간
  'narrow',  // 좁음
  'wide',    // 넓음
] as const;

/**
 * shop - item-image-margin Short 코드 타입.
 */
export type AclosetShopItemImageMarginShortCode = (typeof ACLOSET_SHOP_ITEM_IMAGE_MARGIN_SHORT_CODE_LIST)[number];

/**
 * shop - item-image-margin Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_MARGIN_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemImageMarginShortCode, AclosetShopItemImageMarginCode>> = {
  'middle': 'SHOP_ITEM-IMAGE-MARGIN_MIDDLE',
  'narrow': 'SHOP_ITEM-IMAGE-MARGIN_NARROW',
  'wide'  : 'SHOP_ITEM-IMAGE-MARGIN_WIDE',
};

/**
 * shop - item-image-margin Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_MARGIN_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemImageMarginCode, AclosetShopItemImageMarginShortCode>> = {
  'SHOP_ITEM-IMAGE-MARGIN_MIDDLE': 'middle',
  'SHOP_ITEM-IMAGE-MARGIN_NARROW': 'narrow',
  'SHOP_ITEM-IMAGE-MARGIN_WIDE'  : 'wide',
};

// ************************************************************************************************

/**
 * shop - item-image 리스트.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_CODE_LIST = [
  'SHOP_ITEM-IMAGE_ADDITIONAL-BOTTOM',  // 상단 고정 이미지
  'SHOP_ITEM-IMAGE_ADDITIONAL-TOP',     // 상단 고정 이미지
  'SHOP_ITEM-IMAGE_AI-DETAIL-BACK',     // AI 생성 디테일 컷 후면
  'SHOP_ITEM-IMAGE_AI-DETAIL-FRONT',    // AI 생성 디테일 컷 정면
  'SHOP_ITEM-IMAGE_ALL',                // 전체
  'SHOP_ITEM-IMAGE_BACK',               // 후면 이미지
  'SHOP_ITEM-IMAGE_BRAND',              // 브랜드 택
  'SHOP_ITEM-IMAGE_DETAIL',             // 디테일 컷
  'SHOP_ITEM-IMAGE_FRONT',              // 정면 이미지
  'SHOP_ITEM-IMAGE_LABEL',              // 세탁 라벨
  'SHOP_ITEM-IMAGE_MAIN',               // 대표 이미지
  'SHOP_ITEM-IMAGE_OTHER',              // 기타 촬영한 이미지
  'SHOP_ITEM-IMAGE_PERSON',             // 착용 이미지
  'SHOP_ITEM-IMAGE_REFINED-BACK',       // AI 커팅된 후면 이미지
  'SHOP_ITEM-IMAGE_REFINED-FRONT',      // AI 커팅된 정면 이미지
  'SHOP_ITEM-IMAGE_SHOP-BRAND',         // 샵 브랜드 이미지
  'SHOP_ITEM-IMAGE_SIZE',               // 사이즈
] as const;

/**
 * shop - item-image 타입.
 */
export type AclosetShopItemImageCode = (typeof ACLOSET_SHOP_ITEM_IMAGE_CODE_LIST)[number];

/**
 * shop - item-image Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_SHORT_CODE_LIST = [
  'additional-bottom',  // 상단 고정 이미지
  'additional-top',     // 상단 고정 이미지
  'ai-detail-back',     // AI 생성 디테일 컷 후면
  'ai-detail-front',    // AI 생성 디테일 컷 정면
  'all',                // 전체
  'back',               // 후면 이미지
  'brand',              // 브랜드 택
  'detail',             // 디테일 컷
  'front',              // 정면 이미지
  'label',              // 세탁 라벨
  'main',               // 대표 이미지
  'other',              // 기타 촬영한 이미지
  'person',             // 착용 이미지
  'refined-back',       // AI 커팅된 후면 이미지
  'refined-front',      // AI 커팅된 정면 이미지
  'shop-brand',         // 샵 브랜드 이미지
  'size',               // 사이즈
] as const;

/**
 * shop - item-image Short 코드 타입.
 */
export type AclosetShopItemImageShortCode = (typeof ACLOSET_SHOP_ITEM_IMAGE_SHORT_CODE_LIST)[number];

/**
 * shop - item-image Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemImageShortCode, AclosetShopItemImageCode>> = {
  'additional-bottom': 'SHOP_ITEM-IMAGE_ADDITIONAL-BOTTOM',
  'additional-top'   : 'SHOP_ITEM-IMAGE_ADDITIONAL-TOP',
  'ai-detail-back'   : 'SHOP_ITEM-IMAGE_AI-DETAIL-BACK',
  'ai-detail-front'  : 'SHOP_ITEM-IMAGE_AI-DETAIL-FRONT',
  'all'              : 'SHOP_ITEM-IMAGE_ALL',
  'back'             : 'SHOP_ITEM-IMAGE_BACK',
  'brand'            : 'SHOP_ITEM-IMAGE_BRAND',
  'detail'           : 'SHOP_ITEM-IMAGE_DETAIL',
  'front'            : 'SHOP_ITEM-IMAGE_FRONT',
  'label'            : 'SHOP_ITEM-IMAGE_LABEL',
  'main'             : 'SHOP_ITEM-IMAGE_MAIN',
  'other'            : 'SHOP_ITEM-IMAGE_OTHER',
  'person'           : 'SHOP_ITEM-IMAGE_PERSON',
  'refined-back'     : 'SHOP_ITEM-IMAGE_REFINED-BACK',
  'refined-front'    : 'SHOP_ITEM-IMAGE_REFINED-FRONT',
  'shop-brand'       : 'SHOP_ITEM-IMAGE_SHOP-BRAND',
  'size'             : 'SHOP_ITEM-IMAGE_SIZE',
};

/**
 * shop - item-image Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_IMAGE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemImageCode, AclosetShopItemImageShortCode>> = {
  'SHOP_ITEM-IMAGE_ADDITIONAL-BOTTOM': 'additional-bottom',
  'SHOP_ITEM-IMAGE_ADDITIONAL-TOP'   : 'additional-top',
  'SHOP_ITEM-IMAGE_AI-DETAIL-BACK'   : 'ai-detail-back',
  'SHOP_ITEM-IMAGE_AI-DETAIL-FRONT'  : 'ai-detail-front',
  'SHOP_ITEM-IMAGE_ALL'              : 'all',
  'SHOP_ITEM-IMAGE_BACK'             : 'back',
  'SHOP_ITEM-IMAGE_BRAND'            : 'brand',
  'SHOP_ITEM-IMAGE_DETAIL'           : 'detail',
  'SHOP_ITEM-IMAGE_FRONT'            : 'front',
  'SHOP_ITEM-IMAGE_LABEL'            : 'label',
  'SHOP_ITEM-IMAGE_MAIN'             : 'main',
  'SHOP_ITEM-IMAGE_OTHER'            : 'other',
  'SHOP_ITEM-IMAGE_PERSON'           : 'person',
  'SHOP_ITEM-IMAGE_REFINED-BACK'     : 'refined-back',
  'SHOP_ITEM-IMAGE_REFINED-FRONT'    : 'refined-front',
  'SHOP_ITEM-IMAGE_SHOP-BRAND'       : 'shop-brand',
  'SHOP_ITEM-IMAGE_SIZE'             : 'size',
};

// ************************************************************************************************

/**
 * shop - item-gender 리스트.
 */
export const ACLOSET_SHOP_ITEM_GENDER_CODE_LIST = [
  'SHOP_ITEM-GENDER_KIDS-MEN',     // 키즈 남
  'SHOP_ITEM-GENDER_KIDS-UNISEX',  // 키즈
  'SHOP_ITEM-GENDER_KIDS-WOMEN',   // 키즈 여
  'SHOP_ITEM-GENDER_MEN',          // 남성
  'SHOP_ITEM-GENDER_UNISEX',       // 유니섹스
  'SHOP_ITEM-GENDER_WOMEN',        // 여성
] as const;

/**
 * shop - item-gender 타입.
 */
export type AclosetShopItemGenderCode = (typeof ACLOSET_SHOP_ITEM_GENDER_CODE_LIST)[number];

/**
 * shop - item-gender Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_GENDER_SHORT_CODE_LIST = [
  'kids-men',     // 키즈 남
  'kids-unisex',  // 키즈
  'kids-women',   // 키즈 여
  'men',          // 남성
  'unisex',       // 유니섹스
  'women',        // 여성
] as const;

/**
 * shop - item-gender Short 코드 타입.
 */
export type AclosetShopItemGenderShortCode = (typeof ACLOSET_SHOP_ITEM_GENDER_SHORT_CODE_LIST)[number];

/**
 * shop - item-gender Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_GENDER_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemGenderShortCode, AclosetShopItemGenderCode>> = {
  'kids-men'   : 'SHOP_ITEM-GENDER_KIDS-MEN',
  'kids-unisex': 'SHOP_ITEM-GENDER_KIDS-UNISEX',
  'kids-women' : 'SHOP_ITEM-GENDER_KIDS-WOMEN',
  'men'        : 'SHOP_ITEM-GENDER_MEN',
  'unisex'     : 'SHOP_ITEM-GENDER_UNISEX',
  'women'      : 'SHOP_ITEM-GENDER_WOMEN',
};

/**
 * shop - item-gender Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_GENDER_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemGenderCode, AclosetShopItemGenderShortCode>> = {
  'SHOP_ITEM-GENDER_KIDS-MEN'   : 'kids-men',
  'SHOP_ITEM-GENDER_KIDS-UNISEX': 'kids-unisex',
  'SHOP_ITEM-GENDER_KIDS-WOMEN' : 'kids-women',
  'SHOP_ITEM-GENDER_MEN'        : 'men',
  'SHOP_ITEM-GENDER_UNISEX'     : 'unisex',
  'SHOP_ITEM-GENDER_WOMEN'      : 'women',
};

// ************************************************************************************************

/**
 * shop - item-clothes-type 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_TYPE_CODE_LIST = [
  'SHOP_ITEM-CLOTHES-TYPE_DRESS-NORMAL-NECK',          // 드레스 일반넥
  'SHOP_ITEM-CLOTHES-TYPE_DRESS-SLEEVELESS-NECK',      // 드레스 민소매
  'SHOP_ITEM-CLOTHES-TYPE_DRESS-STRAPLESS-NECK',       // 드레스 끈 없는 타입
  'SHOP_ITEM-CLOTHES-TYPE_INVALID',                    // 유효하지 않은 치수 타입
  'SHOP_ITEM-CLOTHES-TYPE_PANTS',                      // 바지
  'SHOP_ITEM-CLOTHES-TYPE_SKIRT',                      // 치마
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-DRESS-JUMPSUITS',  // 상의,아우터,드레스,점프수트
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-NORMAL-NECK',      // 상의/아우터 일반넥
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-SLEEVELESS-NECK',  // 상의/아우터 민소매
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-STRAPLESS-NECK',   // 상의/아우터 끈 없는 타입
] as const;

/**
 * shop - item-clothes-type 타입.
 */
export type AclosetShopItemClothesTypeCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_TYPE_CODE_LIST)[number];

/**
 * shop - item-clothes-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_TYPE_SHORT_CODE_LIST = [
  'dress-normal-neck',          // 드레스 일반넥
  'dress-sleeveless-neck',      // 드레스 민소매
  'dress-strapless-neck',       // 드레스 끈 없는 타입
  'invalid',                    // 유효하지 않은 치수 타입
  'pants',                      // 바지
  'skirt',                      // 치마
  'top-outer-dress-jumpsuits',  // 상의,아우터,드레스,점프수트
  'top-outer-normal-neck',      // 상의/아우터 일반넥
  'top-outer-sleeveless-neck',  // 상의/아우터 민소매
  'top-outer-strapless-neck',   // 상의/아우터 끈 없는 타입
] as const;

/**
 * shop - item-clothes-type Short 코드 타입.
 */
export type AclosetShopItemClothesTypeShortCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - item-clothes-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemClothesTypeShortCode, AclosetShopItemClothesTypeCode>> = {
  'dress-normal-neck'        : 'SHOP_ITEM-CLOTHES-TYPE_DRESS-NORMAL-NECK',
  'dress-sleeveless-neck'    : 'SHOP_ITEM-CLOTHES-TYPE_DRESS-SLEEVELESS-NECK',
  'dress-strapless-neck'     : 'SHOP_ITEM-CLOTHES-TYPE_DRESS-STRAPLESS-NECK',
  'invalid'                  : 'SHOP_ITEM-CLOTHES-TYPE_INVALID',
  'pants'                    : 'SHOP_ITEM-CLOTHES-TYPE_PANTS',
  'skirt'                    : 'SHOP_ITEM-CLOTHES-TYPE_SKIRT',
  'top-outer-dress-jumpsuits': 'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-DRESS-JUMPSUITS',
  'top-outer-normal-neck'    : 'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-NORMAL-NECK',
  'top-outer-sleeveless-neck': 'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-SLEEVELESS-NECK',
  'top-outer-strapless-neck' : 'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-STRAPLESS-NECK',
};

/**
 * shop - item-clothes-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemClothesTypeCode, AclosetShopItemClothesTypeShortCode>> = {
  'SHOP_ITEM-CLOTHES-TYPE_DRESS-NORMAL-NECK'        : 'dress-normal-neck',
  'SHOP_ITEM-CLOTHES-TYPE_DRESS-SLEEVELESS-NECK'    : 'dress-sleeveless-neck',
  'SHOP_ITEM-CLOTHES-TYPE_DRESS-STRAPLESS-NECK'     : 'dress-strapless-neck',
  'SHOP_ITEM-CLOTHES-TYPE_INVALID'                  : 'invalid',
  'SHOP_ITEM-CLOTHES-TYPE_PANTS'                    : 'pants',
  'SHOP_ITEM-CLOTHES-TYPE_SKIRT'                    : 'skirt',
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-DRESS-JUMPSUITS': 'top-outer-dress-jumpsuits',
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-NORMAL-NECK'    : 'top-outer-normal-neck',
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-SLEEVELESS-NECK': 'top-outer-sleeveless-neck',
  'SHOP_ITEM-CLOTHES-TYPE_TOP-OUTER-STRAPLESS-NECK' : 'top-outer-strapless-neck',
};

// ************************************************************************************************

/**
 * shop - item-clothes-size-type 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_CODE_LIST = [
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_DRESS',         // 원피스
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_HEADWEAR',      // 모자
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_JUMPSUITS',     // 점프수트
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_OTHER-ITEMS',   // 가방/기타
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_PANTS',         // 바지
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_SHOES',         // 신발
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_SKIRT',         // 치마
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-ONEPIECE',  // 세트(상의+원피스)
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-OUTER',     // 상의/아우터
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-PANTS',     // 세트(상의+바지)
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-SKIRT',     // 세트(상의+치마)
] as const;

/**
 * shop - item-clothes-size-type 타입.
 */
export type AclosetShopItemClothesSizeTypeCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_CODE_LIST)[number];

/**
 * shop - item-clothes-size-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_SHORT_CODE_LIST = [
  'dress',         // 원피스
  'headwear',      // 모자
  'jumpsuits',     // 점프수트
  'other-items',   // 가방/기타
  'pants',         // 바지
  'shoes',         // 신발
  'skirt',         // 치마
  'top-onepiece',  // 세트(상의+원피스)
  'top-outer',     // 상의/아우터
  'top-pants',     // 세트(상의+바지)
  'top-skirt',     // 세트(상의+치마)
] as const;

/**
 * shop - item-clothes-size-type Short 코드 타입.
 */
export type AclosetShopItemClothesSizeTypeShortCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - item-clothes-size-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemClothesSizeTypeShortCode, AclosetShopItemClothesSizeTypeCode>> = {
  'dress'       : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_DRESS',
  'headwear'    : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_HEADWEAR',
  'jumpsuits'   : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_JUMPSUITS',
  'other-items' : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_OTHER-ITEMS',
  'pants'       : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_PANTS',
  'shoes'       : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_SHOES',
  'skirt'       : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_SKIRT',
  'top-onepiece': 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-ONEPIECE',
  'top-outer'   : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-OUTER',
  'top-pants'   : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-PANTS',
  'top-skirt'   : 'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-SKIRT',
};

/**
 * shop - item-clothes-size-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemClothesSizeTypeCode, AclosetShopItemClothesSizeTypeShortCode>> = {
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_DRESS'       : 'dress',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_HEADWEAR'    : 'headwear',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_JUMPSUITS'   : 'jumpsuits',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_OTHER-ITEMS' : 'other-items',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_PANTS'       : 'pants',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_SHOES'       : 'shoes',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_SKIRT'       : 'skirt',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-ONEPIECE': 'top-onepiece',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-OUTER'   : 'top-outer',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-PANTS'   : 'top-pants',
  'SHOP_ITEM-CLOTHES-SIZE-TYPE_TOP-SKIRT'   : 'top-skirt',
};

// ************************************************************************************************

/**
 * shop - item-clothes-size-target 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TARGET_CODE_LIST = [
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ARMHOLE',                   // 암홀
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_BOTTOM-OPENING',            // 밑단
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_BOTTOM-TOTAL-LENGTH',       // 총장
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_CHEST',                     // 가슴
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_DEPTH',                     // 폭
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_FRONT-RISE',                // 밑위
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HAT-DEPTH',                 // 깊이
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HEEL-HEIGHT',               // 굽높이
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HEIGHT',                    // 세로
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HIP',                       // 엉덩이
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-ARMHOLE',          // 암홀
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-BOTTOM-OPENING',   // 밑단
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-CHEST',            // 가슴
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-HIP',              // 엉덩이
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-SHOULDER',         // 어깨
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-SLEEVE',           // 소매
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-TOTAL-LENGTH',     // 총장
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST',            // 허리
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST-MAX',        // 허리 최대
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST-MIN',        // 허리 최소
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_PANTS-BOTTOM-OPENING',      // 밑단
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SHOE-LENGTH',               // 길이
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SHOULDER',                  // 어깨
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SKIRT-BOTTOM-OPENING',      // 밑단
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SKIRT-TOTAL-LENGTH',        // 총장
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SLEEVE',                    // 소매
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_THIGH',                     // 허벅지
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-ARMHOLE',               // 암홀
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-BOTTOM-OPENING',        // 밑단
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-CHEST',                 // 가슴
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-OUTER-BOTTOM-OPENING',  // 밑단
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-SHOULDER',              // 어깨
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-SLEEVE',                // 소매
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-TOTAL-LENGTH',          // 총장
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOTAL-LENGTH',              // 총장
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_VISOR-LENGTH',              // 챙길이
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST',                     // 허리
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST-MAX',                 // 허리 최대
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST-MIN',                 // 허리 최소
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WIDTH',                     // 가로
] as const;

/**
 * shop - item-clothes-size-target 타입.
 */
export type AclosetShopItemClothesSizeTargetCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TARGET_CODE_LIST)[number];

/**
 * shop - item-clothes-size-target Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TARGET_SHORT_CODE_LIST = [
  'armhole',                   // 암홀
  'bottom-opening',            // 밑단
  'bottom-total-length',       // 총장
  'chest',                     // 가슴
  'depth',                     // 폭
  'front-rise',                // 밑위
  'hat-depth',                 // 깊이
  'heel-height',               // 굽높이
  'height',                    // 세로
  'hip',                       // 엉덩이
  'onepiece-armhole',          // 암홀
  'onepiece-bottom-opening',   // 밑단
  'onepiece-chest',            // 가슴
  'onepiece-hip',              // 엉덩이
  'onepiece-shoulder',         // 어깨
  'onepiece-sleeve',           // 소매
  'onepiece-total-length',     // 총장
  'onepiece-waist',            // 허리
  'onepiece-waist-max',        // 허리 최대
  'onepiece-waist-min',        // 허리 최소
  'pants-bottom-opening',      // 밑단
  'shoe-length',               // 길이
  'shoulder',                  // 어깨
  'skirt-bottom-opening',      // 밑단
  'skirt-total-length',        // 총장
  'sleeve',                    // 소매
  'thigh',                     // 허벅지
  'top-armhole',               // 암홀
  'top-bottom-opening',        // 밑단
  'top-chest',                 // 가슴
  'top-outer-bottom-opening',  // 밑단
  'top-shoulder',              // 어깨
  'top-sleeve',                // 소매
  'top-total-length',          // 총장
  'total-length',              // 총장
  'visor-length',              // 챙길이
  'waist',                     // 허리
  'waist-max',                 // 허리 최대
  'waist-min',                 // 허리 최소
  'width',                     // 가로
] as const;

/**
 * shop - item-clothes-size-target Short 코드 타입.
 */
export type AclosetShopItemClothesSizeTargetShortCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TARGET_SHORT_CODE_LIST)[number];

/**
 * shop - item-clothes-size-target Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TARGET_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemClothesSizeTargetShortCode, AclosetShopItemClothesSizeTargetCode>> = {
  'armhole'                 : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ARMHOLE',
  'bottom-opening'          : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_BOTTOM-OPENING',
  'bottom-total-length'     : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_BOTTOM-TOTAL-LENGTH',
  'chest'                   : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_CHEST',
  'depth'                   : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_DEPTH',
  'front-rise'              : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_FRONT-RISE',
  'hat-depth'               : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_HAT-DEPTH',
  'heel-height'             : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_HEEL-HEIGHT',
  'height'                  : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_HEIGHT',
  'hip'                     : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_HIP',
  'onepiece-armhole'        : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-ARMHOLE',
  'onepiece-bottom-opening' : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-BOTTOM-OPENING',
  'onepiece-chest'          : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-CHEST',
  'onepiece-hip'            : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-HIP',
  'onepiece-shoulder'       : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-SHOULDER',
  'onepiece-sleeve'         : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-SLEEVE',
  'onepiece-total-length'   : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-TOTAL-LENGTH',
  'onepiece-waist'          : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST',
  'onepiece-waist-max'      : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST-MAX',
  'onepiece-waist-min'      : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST-MIN',
  'pants-bottom-opening'    : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_PANTS-BOTTOM-OPENING',
  'shoe-length'             : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_SHOE-LENGTH',
  'shoulder'                : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_SHOULDER',
  'skirt-bottom-opening'    : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_SKIRT-BOTTOM-OPENING',
  'skirt-total-length'      : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_SKIRT-TOTAL-LENGTH',
  'sleeve'                  : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_SLEEVE',
  'thigh'                   : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_THIGH',
  'top-armhole'             : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-ARMHOLE',
  'top-bottom-opening'      : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-BOTTOM-OPENING',
  'top-chest'               : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-CHEST',
  'top-outer-bottom-opening': 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-OUTER-BOTTOM-OPENING',
  'top-shoulder'            : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-SHOULDER',
  'top-sleeve'              : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-SLEEVE',
  'top-total-length'        : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-TOTAL-LENGTH',
  'total-length'            : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOTAL-LENGTH',
  'visor-length'            : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_VISOR-LENGTH',
  'waist'                   : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST',
  'waist-max'               : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST-MAX',
  'waist-min'               : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST-MIN',
  'width'                   : 'SHOP_ITEM-CLOTHES-SIZE-TARGET_WIDTH',
};

/**
 * shop - item-clothes-size-target Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_SIZE_TARGET_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemClothesSizeTargetCode, AclosetShopItemClothesSizeTargetShortCode>> = {
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ARMHOLE'                 : 'armhole',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_BOTTOM-OPENING'          : 'bottom-opening',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_BOTTOM-TOTAL-LENGTH'     : 'bottom-total-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_CHEST'                   : 'chest',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_DEPTH'                   : 'depth',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_FRONT-RISE'              : 'front-rise',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HAT-DEPTH'               : 'hat-depth',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HEEL-HEIGHT'             : 'heel-height',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HEIGHT'                  : 'height',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_HIP'                     : 'hip',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-ARMHOLE'        : 'onepiece-armhole',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-BOTTOM-OPENING' : 'onepiece-bottom-opening',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-CHEST'          : 'onepiece-chest',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-HIP'            : 'onepiece-hip',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-SHOULDER'       : 'onepiece-shoulder',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-SLEEVE'         : 'onepiece-sleeve',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-TOTAL-LENGTH'   : 'onepiece-total-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST'          : 'onepiece-waist',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST-MAX'      : 'onepiece-waist-max',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_ONEPIECE-WAIST-MIN'      : 'onepiece-waist-min',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_PANTS-BOTTOM-OPENING'    : 'pants-bottom-opening',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SHOE-LENGTH'             : 'shoe-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SHOULDER'                : 'shoulder',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SKIRT-BOTTOM-OPENING'    : 'skirt-bottom-opening',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SKIRT-TOTAL-LENGTH'      : 'skirt-total-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_SLEEVE'                  : 'sleeve',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_THIGH'                   : 'thigh',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-ARMHOLE'             : 'top-armhole',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-BOTTOM-OPENING'      : 'top-bottom-opening',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-CHEST'               : 'top-chest',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-OUTER-BOTTOM-OPENING': 'top-outer-bottom-opening',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-SHOULDER'            : 'top-shoulder',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-SLEEVE'              : 'top-sleeve',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOP-TOTAL-LENGTH'        : 'top-total-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_TOTAL-LENGTH'            : 'total-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_VISOR-LENGTH'            : 'visor-length',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST'                   : 'waist',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST-MAX'               : 'waist-max',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WAIST-MIN'               : 'waist-min',
  'SHOP_ITEM-CLOTHES-SIZE-TARGET_WIDTH'                   : 'width',
};

// ************************************************************************************************

/**
 * shop - item-clothes-feature 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_FEATURE_CODE_LIST = [
  'SHOP_ITEM-CLOTHES-FEATURE_CHEST-PAD',              // 가슴패드
  'SHOP_ITEM-CLOTHES-FEATURE_LINER',                  // 안감
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-CHEST-PAD',     // 원피스 가슴패드
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-LINER',         // 원피스 안감
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-RAGLAN',        // 원피스 래글런
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-SHOULDER-PAD',  // 원피스 어깨패드
  'SHOP_ITEM-CLOTHES-FEATURE_PANTS-LINER',            // 바지 안감
  'SHOP_ITEM-CLOTHES-FEATURE_RAGLAN',                 // 래글런
  'SHOP_ITEM-CLOTHES-FEATURE_SHOULDER-PAD',           // 어깨패드
  'SHOP_ITEM-CLOTHES-FEATURE_SKIRT-LINER',            // 치마 안감
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-CHEST-PAD',          // 상의 가슴패드
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-LINER',              // 상의 안감
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-RAGLAN',             // 상의 래글런
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-SHOULDER-PAD',       // 상의 어깨패드
  'SHOP_ITEM-CLOTHES-FEATURE_WAIST-BANDING',          // 허리밴딩
] as const;

/**
 * shop - item-clothes-feature 타입.
 */
export type AclosetShopItemClothesFeatureCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_FEATURE_CODE_LIST)[number];

/**
 * shop - item-clothes-feature Short 코드 리스트.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_FEATURE_SHORT_CODE_LIST = [
  'chest-pad',              // 가슴패드
  'liner',                  // 안감
  'onepiece-chest-pad',     // 원피스 가슴패드
  'onepiece-liner',         // 원피스 안감
  'onepiece-raglan',        // 원피스 래글런
  'onepiece-shoulder-pad',  // 원피스 어깨패드
  'pants-liner',            // 바지 안감
  'raglan',                 // 래글런
  'shoulder-pad',           // 어깨패드
  'skirt-liner',            // 치마 안감
  'top-chest-pad',          // 상의 가슴패드
  'top-liner',              // 상의 안감
  'top-raglan',             // 상의 래글런
  'top-shoulder-pad',       // 상의 어깨패드
  'waist-banding',          // 허리밴딩
] as const;

/**
 * shop - item-clothes-feature Short 코드 타입.
 */
export type AclosetShopItemClothesFeatureShortCode = (typeof ACLOSET_SHOP_ITEM_CLOTHES_FEATURE_SHORT_CODE_LIST)[number];

/**
 * shop - item-clothes-feature Short 코드 매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_FEATURE_SHORT_CODE_MAP: Readonly<Record<AclosetShopItemClothesFeatureShortCode, AclosetShopItemClothesFeatureCode>> = {
  'chest-pad'            : 'SHOP_ITEM-CLOTHES-FEATURE_CHEST-PAD',
  'liner'                : 'SHOP_ITEM-CLOTHES-FEATURE_LINER',
  'onepiece-chest-pad'   : 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-CHEST-PAD',
  'onepiece-liner'       : 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-LINER',
  'onepiece-raglan'      : 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-RAGLAN',
  'onepiece-shoulder-pad': 'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-SHOULDER-PAD',
  'pants-liner'          : 'SHOP_ITEM-CLOTHES-FEATURE_PANTS-LINER',
  'raglan'               : 'SHOP_ITEM-CLOTHES-FEATURE_RAGLAN',
  'shoulder-pad'         : 'SHOP_ITEM-CLOTHES-FEATURE_SHOULDER-PAD',
  'skirt-liner'          : 'SHOP_ITEM-CLOTHES-FEATURE_SKIRT-LINER',
  'top-chest-pad'        : 'SHOP_ITEM-CLOTHES-FEATURE_TOP-CHEST-PAD',
  'top-liner'            : 'SHOP_ITEM-CLOTHES-FEATURE_TOP-LINER',
  'top-raglan'           : 'SHOP_ITEM-CLOTHES-FEATURE_TOP-RAGLAN',
  'top-shoulder-pad'     : 'SHOP_ITEM-CLOTHES-FEATURE_TOP-SHOULDER-PAD',
  'waist-banding'        : 'SHOP_ITEM-CLOTHES-FEATURE_WAIST-BANDING',
};

/**
 * shop - item-clothes-feature Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ITEM_CLOTHES_FEATURE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopItemClothesFeatureCode, AclosetShopItemClothesFeatureShortCode>> = {
  'SHOP_ITEM-CLOTHES-FEATURE_CHEST-PAD'            : 'chest-pad',
  'SHOP_ITEM-CLOTHES-FEATURE_LINER'                : 'liner',
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-CHEST-PAD'   : 'onepiece-chest-pad',
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-LINER'       : 'onepiece-liner',
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-RAGLAN'      : 'onepiece-raglan',
  'SHOP_ITEM-CLOTHES-FEATURE_ONEPIECE-SHOULDER-PAD': 'onepiece-shoulder-pad',
  'SHOP_ITEM-CLOTHES-FEATURE_PANTS-LINER'          : 'pants-liner',
  'SHOP_ITEM-CLOTHES-FEATURE_RAGLAN'               : 'raglan',
  'SHOP_ITEM-CLOTHES-FEATURE_SHOULDER-PAD'         : 'shoulder-pad',
  'SHOP_ITEM-CLOTHES-FEATURE_SKIRT-LINER'          : 'skirt-liner',
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-CHEST-PAD'        : 'top-chest-pad',
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-LINER'            : 'top-liner',
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-RAGLAN'           : 'top-raglan',
  'SHOP_ITEM-CLOTHES-FEATURE_TOP-SHOULDER-PAD'     : 'top-shoulder-pad',
  'SHOP_ITEM-CLOTHES-FEATURE_WAIST-BANDING'        : 'waist-banding',
};

// ************************************************************************************************

/**
 * shop - inflow-channel 리스트.
 */
export const ACLOSET_SHOP_INFLOW_CHANNEL_CODE_LIST = [
  'SHOP_INFLOW-CHANNEL_BUNJANG-LOAD',  // 번개장터 불러오기
] as const;

/**
 * shop - inflow-channel 타입.
 */
export type AclosetShopInflowChannelCode = (typeof ACLOSET_SHOP_INFLOW_CHANNEL_CODE_LIST)[number];

/**
 * shop - inflow-channel Short 코드 리스트.
 */
export const ACLOSET_SHOP_INFLOW_CHANNEL_SHORT_CODE_LIST = [
  'bunjang-load',  // 번개장터 불러오기
] as const;

/**
 * shop - inflow-channel Short 코드 타입.
 */
export type AclosetShopInflowChannelShortCode = (typeof ACLOSET_SHOP_INFLOW_CHANNEL_SHORT_CODE_LIST)[number];

/**
 * shop - inflow-channel Short 코드 매핑.
 */
export const ACLOSET_SHOP_INFLOW_CHANNEL_SHORT_CODE_MAP: Readonly<Record<AclosetShopInflowChannelShortCode, AclosetShopInflowChannelCode>> = {
  'bunjang-load': 'SHOP_INFLOW-CHANNEL_BUNJANG-LOAD',
};

/**
 * shop - inflow-channel Short 코드 역매핑.
 */
export const ACLOSET_SHOP_INFLOW_CHANNEL_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopInflowChannelCode, AclosetShopInflowChannelShortCode>> = {
  'SHOP_INFLOW-CHANNEL_BUNJANG-LOAD': 'bunjang-load',
};

// ************************************************************************************************

/**
 * shop - image-ratio 리스트.
 */
export const ACLOSET_SHOP_IMAGE_RATIO_CODE_LIST = [
  'SHOP_IMAGE-RATIO_FIVE-TO-SIX',     // 5:6
  'SHOP_IMAGE-RATIO_FOUR-TO-FIVE',    // 4:5
  'SHOP_IMAGE-RATIO_ONE-TO-ONE',      // 1:1
  'SHOP_IMAGE-RATIO_ORIGINAL-RATIO',  // 원본 비율 유지
  'SHOP_IMAGE-RATIO_SIX-TO-SEVEN',    // 6:7
  'SHOP_IMAGE-RATIO_THREE-TO-FOUR',   // 3:4
  'SHOP_IMAGE-RATIO_TWO-TO-THREE',    // 2:3
] as const;

/**
 * shop - image-ratio 타입.
 */
export type AclosetShopImageRatioCode = (typeof ACLOSET_SHOP_IMAGE_RATIO_CODE_LIST)[number];

/**
 * shop - image-ratio Short 코드 리스트.
 */
export const ACLOSET_SHOP_IMAGE_RATIO_SHORT_CODE_LIST = [
  'five-to-six',     // 5:6
  'four-to-five',    // 4:5
  'one-to-one',      // 1:1
  'original-ratio',  // 원본 비율 유지
  'six-to-seven',    // 6:7
  'three-to-four',   // 3:4
  'two-to-three',    // 2:3
] as const;

/**
 * shop - image-ratio Short 코드 타입.
 */
export type AclosetShopImageRatioShortCode = (typeof ACLOSET_SHOP_IMAGE_RATIO_SHORT_CODE_LIST)[number];

/**
 * shop - image-ratio Short 코드 매핑.
 */
export const ACLOSET_SHOP_IMAGE_RATIO_SHORT_CODE_MAP: Readonly<Record<AclosetShopImageRatioShortCode, AclosetShopImageRatioCode>> = {
  'five-to-six'   : 'SHOP_IMAGE-RATIO_FIVE-TO-SIX',
  'four-to-five'  : 'SHOP_IMAGE-RATIO_FOUR-TO-FIVE',
  'one-to-one'    : 'SHOP_IMAGE-RATIO_ONE-TO-ONE',
  'original-ratio': 'SHOP_IMAGE-RATIO_ORIGINAL-RATIO',
  'six-to-seven'  : 'SHOP_IMAGE-RATIO_SIX-TO-SEVEN',
  'three-to-four' : 'SHOP_IMAGE-RATIO_THREE-TO-FOUR',
  'two-to-three'  : 'SHOP_IMAGE-RATIO_TWO-TO-THREE',
};

/**
 * shop - image-ratio Short 코드 역매핑.
 */
export const ACLOSET_SHOP_IMAGE_RATIO_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopImageRatioCode, AclosetShopImageRatioShortCode>> = {
  'SHOP_IMAGE-RATIO_FIVE-TO-SIX'   : 'five-to-six',
  'SHOP_IMAGE-RATIO_FOUR-TO-FIVE'  : 'four-to-five',
  'SHOP_IMAGE-RATIO_ONE-TO-ONE'    : 'one-to-one',
  'SHOP_IMAGE-RATIO_ORIGINAL-RATIO': 'original-ratio',
  'SHOP_IMAGE-RATIO_SIX-TO-SEVEN'  : 'six-to-seven',
  'SHOP_IMAGE-RATIO_THREE-TO-FOUR' : 'three-to-four',
  'SHOP_IMAGE-RATIO_TWO-TO-THREE'  : 'two-to-three',
};

// ************************************************************************************************

/**
 * shop - html 리스트.
 */
export const ACLOSET_SHOP_HTML_CODE_LIST = [
  'SHOP_HTML_MAPPING-TYPE',  // 성별별 매핑 템플릿 사용
  'SHOP_HTML_SIMPLE',        // 전체 템플릿 사용
] as const;

/**
 * shop - html 타입.
 */
export type AclosetShopHtmlCode = (typeof ACLOSET_SHOP_HTML_CODE_LIST)[number];

/**
 * shop - html Short 코드 리스트.
 */
export const ACLOSET_SHOP_HTML_SHORT_CODE_LIST = [
  'mapping-type',  // 성별별 매핑 템플릿 사용
  'simple',        // 전체 템플릿 사용
] as const;

/**
 * shop - html Short 코드 타입.
 */
export type AclosetShopHtmlShortCode = (typeof ACLOSET_SHOP_HTML_SHORT_CODE_LIST)[number];

/**
 * shop - html Short 코드 매핑.
 */
export const ACLOSET_SHOP_HTML_SHORT_CODE_MAP: Readonly<Record<AclosetShopHtmlShortCode, AclosetShopHtmlCode>> = {
  'mapping-type': 'SHOP_HTML_MAPPING-TYPE',
  'simple'      : 'SHOP_HTML_SIMPLE',
};

/**
 * shop - html Short 코드 역매핑.
 */
export const ACLOSET_SHOP_HTML_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopHtmlCode, AclosetShopHtmlShortCode>> = {
  'SHOP_HTML_MAPPING-TYPE': 'mapping-type',
  'SHOP_HTML_SIMPLE'      : 'simple',
};

// ************************************************************************************************

/**
 * shop - fabric-order-priority 리스트.
 */
export const ACLOSET_SHOP_FABRIC_ORDER_PRIORITY_CODE_LIST = [
  'SHOP_FABRIC-ORDER-PRIORITY_START-ABOVE',                             // 케어라벨의 윗 부분에 표기된 소재가 먼저 인식되면 좋겠어요
  'SHOP_FABRIC-ORDER-PRIORITY_START-ABOVE-BUT-IMPORTANT-FIRST',         // 케어라벨의 윗부분에 표기된 소재 순서로 인식하되, 중요한 소재 (다운, 캐시미어, 알파카, 래빗퍼, 가죽류, 실크) 가 있는 경우, 이를 우선하여 인식하면 좋겠어요
  'SHOP_FABRIC-ORDER-PRIORITY_START-HIGH-PERCENT',                      // 함량이 높은 소재 순서대로 인식되면 좋겠어요
  'SHOP_FABRIC-ORDER-PRIORITY_START-HIGH-PERCENT-BUT-IMPORTANT-FIRST',  // 함량이 높은 소재 순서대로 인식하되, 중요한 소재 (다운, 캐시미어, 알파카, 래빗퍼, 가죽류, 실크) 가 있는 경우, 이를 우선하여 인식하면 좋겠어요
] as const;

/**
 * shop - fabric-order-priority 타입.
 */
export type AclosetShopFabricOrderPriorityCode = (typeof ACLOSET_SHOP_FABRIC_ORDER_PRIORITY_CODE_LIST)[number];

/**
 * shop - fabric-order-priority Short 코드 리스트.
 */
export const ACLOSET_SHOP_FABRIC_ORDER_PRIORITY_SHORT_CODE_LIST = [
  'start-above',                             // 케어라벨의 윗 부분에 표기된 소재가 먼저 인식되면 좋겠어요
  'start-above-but-important-first',         // 케어라벨의 윗부분에 표기된 소재 순서로 인식하되, 중요한 소재 (다운, 캐시미어, 알파카, 래빗퍼, 가죽류, 실크) 가 있는 경우, 이를 우선하여 인식하면 좋겠어요
  'start-high-percent',                      // 함량이 높은 소재 순서대로 인식되면 좋겠어요
  'start-high-percent-but-important-first',  // 함량이 높은 소재 순서대로 인식하되, 중요한 소재 (다운, 캐시미어, 알파카, 래빗퍼, 가죽류, 실크) 가 있는 경우, 이를 우선하여 인식하면 좋겠어요
] as const;

/**
 * shop - fabric-order-priority Short 코드 타입.
 */
export type AclosetShopFabricOrderPriorityShortCode = (typeof ACLOSET_SHOP_FABRIC_ORDER_PRIORITY_SHORT_CODE_LIST)[number];

/**
 * shop - fabric-order-priority Short 코드 매핑.
 */
export const ACLOSET_SHOP_FABRIC_ORDER_PRIORITY_SHORT_CODE_MAP: Readonly<Record<AclosetShopFabricOrderPriorityShortCode, AclosetShopFabricOrderPriorityCode>> = {
  'start-above'                           : 'SHOP_FABRIC-ORDER-PRIORITY_START-ABOVE',
  'start-above-but-important-first'       : 'SHOP_FABRIC-ORDER-PRIORITY_START-ABOVE-BUT-IMPORTANT-FIRST',
  'start-high-percent'                    : 'SHOP_FABRIC-ORDER-PRIORITY_START-HIGH-PERCENT',
  'start-high-percent-but-important-first': 'SHOP_FABRIC-ORDER-PRIORITY_START-HIGH-PERCENT-BUT-IMPORTANT-FIRST',
};

/**
 * shop - fabric-order-priority Short 코드 역매핑.
 */
export const ACLOSET_SHOP_FABRIC_ORDER_PRIORITY_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopFabricOrderPriorityCode, AclosetShopFabricOrderPriorityShortCode>> = {
  'SHOP_FABRIC-ORDER-PRIORITY_START-ABOVE'                           : 'start-above',
  'SHOP_FABRIC-ORDER-PRIORITY_START-ABOVE-BUT-IMPORTANT-FIRST'       : 'start-above-but-important-first',
  'SHOP_FABRIC-ORDER-PRIORITY_START-HIGH-PERCENT'                    : 'start-high-percent',
  'SHOP_FABRIC-ORDER-PRIORITY_START-HIGH-PERCENT-BUT-IMPORTANT-FIRST': 'start-high-percent-but-important-first',
};

// ************************************************************************************************

/**
 * shop - excel-download-mode 리스트.
 */
export const ACLOSET_SHOP_EXCEL_DOWNLOAD_MODE_CODE_LIST = [
  'SHOP_EXCEL-DOWNLOAD-MODE_GENERAL',  // 일반
  'SHOP_EXCEL-DOWNLOAD-MODE_QUICK',    // 빠른
] as const;

/**
 * shop - excel-download-mode 타입.
 */
export type AclosetShopExcelDownloadModeCode = (typeof ACLOSET_SHOP_EXCEL_DOWNLOAD_MODE_CODE_LIST)[number];

/**
 * shop - excel-download-mode Short 코드 리스트.
 */
export const ACLOSET_SHOP_EXCEL_DOWNLOAD_MODE_SHORT_CODE_LIST = [
  'general',  // 일반
  'quick',    // 빠른
] as const;

/**
 * shop - excel-download-mode Short 코드 타입.
 */
export type AclosetShopExcelDownloadModeShortCode = (typeof ACLOSET_SHOP_EXCEL_DOWNLOAD_MODE_SHORT_CODE_LIST)[number];

/**
 * shop - excel-download-mode Short 코드 매핑.
 */
export const ACLOSET_SHOP_EXCEL_DOWNLOAD_MODE_SHORT_CODE_MAP: Readonly<Record<AclosetShopExcelDownloadModeShortCode, AclosetShopExcelDownloadModeCode>> = {
  'general': 'SHOP_EXCEL-DOWNLOAD-MODE_GENERAL',
  'quick'  : 'SHOP_EXCEL-DOWNLOAD-MODE_QUICK',
};

/**
 * shop - excel-download-mode Short 코드 역매핑.
 */
export const ACLOSET_SHOP_EXCEL_DOWNLOAD_MODE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopExcelDownloadModeCode, AclosetShopExcelDownloadModeShortCode>> = {
  'SHOP_EXCEL-DOWNLOAD-MODE_GENERAL': 'general',
  'SHOP_EXCEL-DOWNLOAD-MODE_QUICK'  : 'quick',
};

// ************************************************************************************************

/**
 * shop - detail-image-type 리스트.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_TYPE_CODE_LIST = [
  'SHOP_DETAIL-IMAGE-TYPE_BOTTOM-LEFT',     // 밑단 좌측
  'SHOP_DETAIL-IMAGE-TYPE_CENTER',          // 중앙
  'SHOP_DETAIL-IMAGE-TYPE_NECK',            // 목
  'SHOP_DETAIL-IMAGE-TYPE_RIGHT-WAIST',     // 우측 허리
  'SHOP_DETAIL-IMAGE-TYPE_SLEEVE',          // 소매
  'SHOP_DETAIL-IMAGE-TYPE_VERTICAL-SPLIT',  // 상/하 2분할
  'SHOP_DETAIL-IMAGE-TYPE_WAIST',           // 허리
] as const;

/**
 * shop - detail-image-type 타입.
 */
export type AclosetShopDetailImageTypeCode = (typeof ACLOSET_SHOP_DETAIL_IMAGE_TYPE_CODE_LIST)[number];

/**
 * shop - detail-image-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_TYPE_SHORT_CODE_LIST = [
  'bottom-left',     // 밑단 좌측
  'center',          // 중앙
  'neck',            // 목
  'right-waist',     // 우측 허리
  'sleeve',          // 소매
  'vertical-split',  // 상/하 2분할
  'waist',           // 허리
] as const;

/**
 * shop - detail-image-type Short 코드 타입.
 */
export type AclosetShopDetailImageTypeShortCode = (typeof ACLOSET_SHOP_DETAIL_IMAGE_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - detail-image-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopDetailImageTypeShortCode, AclosetShopDetailImageTypeCode>> = {
  'bottom-left'   : 'SHOP_DETAIL-IMAGE-TYPE_BOTTOM-LEFT',
  'center'        : 'SHOP_DETAIL-IMAGE-TYPE_CENTER',
  'neck'          : 'SHOP_DETAIL-IMAGE-TYPE_NECK',
  'right-waist'   : 'SHOP_DETAIL-IMAGE-TYPE_RIGHT-WAIST',
  'sleeve'        : 'SHOP_DETAIL-IMAGE-TYPE_SLEEVE',
  'vertical-split': 'SHOP_DETAIL-IMAGE-TYPE_VERTICAL-SPLIT',
  'waist'         : 'SHOP_DETAIL-IMAGE-TYPE_WAIST',
};

/**
 * shop - detail-image-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopDetailImageTypeCode, AclosetShopDetailImageTypeShortCode>> = {
  'SHOP_DETAIL-IMAGE-TYPE_BOTTOM-LEFT'   : 'bottom-left',
  'SHOP_DETAIL-IMAGE-TYPE_CENTER'        : 'center',
  'SHOP_DETAIL-IMAGE-TYPE_NECK'          : 'neck',
  'SHOP_DETAIL-IMAGE-TYPE_RIGHT-WAIST'   : 'right-waist',
  'SHOP_DETAIL-IMAGE-TYPE_SLEEVE'        : 'sleeve',
  'SHOP_DETAIL-IMAGE-TYPE_VERTICAL-SPLIT': 'vertical-split',
  'SHOP_DETAIL-IMAGE-TYPE_WAIST'         : 'waist',
};

// ************************************************************************************************

/**
 * shop - detail-image-ratio 리스트.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_RATIO_CODE_LIST = [
  'SHOP_DETAIL-IMAGE-RATIO_FIVE-TO-FOUR',   // 5:4
  'SHOP_DETAIL-IMAGE-RATIO_FIVE-TO-SIX',    // 5:6
  'SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-FIVE',   // 4:5
  'SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-THREE',  // 4:3
  'SHOP_DETAIL-IMAGE-RATIO_ONE-TO-ONE',     // 1:1
  'SHOP_DETAIL-IMAGE-RATIO_SEVEN-TO-SIX',   // 7:6
  'SHOP_DETAIL-IMAGE-RATIO_SIX-TO-FIVE',    // 6:5
  'SHOP_DETAIL-IMAGE-RATIO_SIX-TO-SEVEN',   // 6:7
  'SHOP_DETAIL-IMAGE-RATIO_THREE-TO-FOUR',  // 3:4
  'SHOP_DETAIL-IMAGE-RATIO_THREE-TO-TWO',   // 3:2
  'SHOP_DETAIL-IMAGE-RATIO_TWO-TO-THREE',   // 2:3
] as const;

/**
 * shop - detail-image-ratio 타입.
 */
export type AclosetShopDetailImageRatioCode = (typeof ACLOSET_SHOP_DETAIL_IMAGE_RATIO_CODE_LIST)[number];

/**
 * shop - detail-image-ratio Short 코드 리스트.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_RATIO_SHORT_CODE_LIST = [
  'five-to-four',   // 5:4
  'five-to-six',    // 5:6
  'four-to-five',   // 4:5
  'four-to-three',  // 4:3
  'one-to-one',     // 1:1
  'seven-to-six',   // 7:6
  'six-to-five',    // 6:5
  'six-to-seven',   // 6:7
  'three-to-four',  // 3:4
  'three-to-two',   // 3:2
  'two-to-three',   // 2:3
] as const;

/**
 * shop - detail-image-ratio Short 코드 타입.
 */
export type AclosetShopDetailImageRatioShortCode = (typeof ACLOSET_SHOP_DETAIL_IMAGE_RATIO_SHORT_CODE_LIST)[number];

/**
 * shop - detail-image-ratio Short 코드 매핑.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_RATIO_SHORT_CODE_MAP: Readonly<Record<AclosetShopDetailImageRatioShortCode, AclosetShopDetailImageRatioCode>> = {
  'five-to-four' : 'SHOP_DETAIL-IMAGE-RATIO_FIVE-TO-FOUR',
  'five-to-six'  : 'SHOP_DETAIL-IMAGE-RATIO_FIVE-TO-SIX',
  'four-to-five' : 'SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-FIVE',
  'four-to-three': 'SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-THREE',
  'one-to-one'   : 'SHOP_DETAIL-IMAGE-RATIO_ONE-TO-ONE',
  'seven-to-six' : 'SHOP_DETAIL-IMAGE-RATIO_SEVEN-TO-SIX',
  'six-to-five'  : 'SHOP_DETAIL-IMAGE-RATIO_SIX-TO-FIVE',
  'six-to-seven' : 'SHOP_DETAIL-IMAGE-RATIO_SIX-TO-SEVEN',
  'three-to-four': 'SHOP_DETAIL-IMAGE-RATIO_THREE-TO-FOUR',
  'three-to-two' : 'SHOP_DETAIL-IMAGE-RATIO_THREE-TO-TWO',
  'two-to-three' : 'SHOP_DETAIL-IMAGE-RATIO_TWO-TO-THREE',
};

/**
 * shop - detail-image-ratio Short 코드 역매핑.
 */
export const ACLOSET_SHOP_DETAIL_IMAGE_RATIO_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopDetailImageRatioCode, AclosetShopDetailImageRatioShortCode>> = {
  'SHOP_DETAIL-IMAGE-RATIO_FIVE-TO-FOUR' : 'five-to-four',
  'SHOP_DETAIL-IMAGE-RATIO_FIVE-TO-SIX'  : 'five-to-six',
  'SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-FIVE' : 'four-to-five',
  'SHOP_DETAIL-IMAGE-RATIO_FOUR-TO-THREE': 'four-to-three',
  'SHOP_DETAIL-IMAGE-RATIO_ONE-TO-ONE'   : 'one-to-one',
  'SHOP_DETAIL-IMAGE-RATIO_SEVEN-TO-SIX' : 'seven-to-six',
  'SHOP_DETAIL-IMAGE-RATIO_SIX-TO-FIVE'  : 'six-to-five',
  'SHOP_DETAIL-IMAGE-RATIO_SIX-TO-SEVEN' : 'six-to-seven',
  'SHOP_DETAIL-IMAGE-RATIO_THREE-TO-FOUR': 'three-to-four',
  'SHOP_DETAIL-IMAGE-RATIO_THREE-TO-TWO' : 'three-to-two',
  'SHOP_DETAIL-IMAGE-RATIO_TWO-TO-THREE' : 'two-to-three',
};

// ************************************************************************************************

/**
 * shop - deriving-clothes-size-type 리스트.
 */
export const ACLOSET_SHOP_DERIVING_CLOTHES_SIZE_TYPE_CODE_LIST = [
  'SHOP_DERIVING-CLOTHES-SIZE-TYPE_ALL',         // 상품라벨 사진을 참조하고, 만약 라벨이 없다면 치수를 참조해주세요
  'SHOP_DERIVING-CLOTHES-SIZE-TYPE_IMAGE-ONLY',  // 상품라벨 사진을 참조해주세요
  'SHOP_DERIVING-CLOTHES-SIZE-TYPE_INPUT-ONLY',  // 입력한 치수를 참조해주세요
] as const;

/**
 * shop - deriving-clothes-size-type 타입.
 */
export type AclosetShopDerivingClothesSizeTypeCode = (typeof ACLOSET_SHOP_DERIVING_CLOTHES_SIZE_TYPE_CODE_LIST)[number];

/**
 * shop - deriving-clothes-size-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_DERIVING_CLOTHES_SIZE_TYPE_SHORT_CODE_LIST = [
  'all',         // 상품라벨 사진을 참조하고, 만약 라벨이 없다면 치수를 참조해주세요
  'image-only',  // 상품라벨 사진을 참조해주세요
  'input-only',  // 입력한 치수를 참조해주세요
] as const;

/**
 * shop - deriving-clothes-size-type Short 코드 타입.
 */
export type AclosetShopDerivingClothesSizeTypeShortCode = (typeof ACLOSET_SHOP_DERIVING_CLOTHES_SIZE_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - deriving-clothes-size-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_DERIVING_CLOTHES_SIZE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopDerivingClothesSizeTypeShortCode, AclosetShopDerivingClothesSizeTypeCode>> = {
  'all'       : 'SHOP_DERIVING-CLOTHES-SIZE-TYPE_ALL',
  'image-only': 'SHOP_DERIVING-CLOTHES-SIZE-TYPE_IMAGE-ONLY',
  'input-only': 'SHOP_DERIVING-CLOTHES-SIZE-TYPE_INPUT-ONLY',
};

/**
 * shop - deriving-clothes-size-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_DERIVING_CLOTHES_SIZE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopDerivingClothesSizeTypeCode, AclosetShopDerivingClothesSizeTypeShortCode>> = {
  'SHOP_DERIVING-CLOTHES-SIZE-TYPE_ALL'       : 'all',
  'SHOP_DERIVING-CLOTHES-SIZE-TYPE_IMAGE-ONLY': 'image-only',
  'SHOP_DERIVING-CLOTHES-SIZE-TYPE_INPUT-ONLY': 'input-only',
};

// ************************************************************************************************

/**
 * shop - custom-input-field-field-schema-type 리스트.
 */
export const ACLOSET_SHOP_CUSTOM_INPUT_FIELD_FIELD_SCHEMA_TYPE_CODE_LIST = [
  'SHOP_CUSTOM-INPUT-FIELD-FIELD-SCHEMA-TYPE_BUTTON',  // 버튼 선택형
  'SHOP_CUSTOM-INPUT-FIELD-FIELD-SCHEMA-TYPE_DIRECT',  // 직접 입력형
] as const;

/**
 * shop - custom-input-field-field-schema-type 타입.
 */
export type AclosetShopCustomInputFieldFieldSchemaTypeCode = (typeof ACLOSET_SHOP_CUSTOM_INPUT_FIELD_FIELD_SCHEMA_TYPE_CODE_LIST)[number];

/**
 * shop - custom-input-field-field-schema-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_CUSTOM_INPUT_FIELD_FIELD_SCHEMA_TYPE_SHORT_CODE_LIST = [
  'button',  // 버튼 선택형
  'direct',  // 직접 입력형
] as const;

/**
 * shop - custom-input-field-field-schema-type Short 코드 타입.
 */
export type AclosetShopCustomInputFieldFieldSchemaTypeShortCode = (typeof ACLOSET_SHOP_CUSTOM_INPUT_FIELD_FIELD_SCHEMA_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - custom-input-field-field-schema-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_CUSTOM_INPUT_FIELD_FIELD_SCHEMA_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopCustomInputFieldFieldSchemaTypeShortCode, AclosetShopCustomInputFieldFieldSchemaTypeCode>> = {
  'button': 'SHOP_CUSTOM-INPUT-FIELD-FIELD-SCHEMA-TYPE_BUTTON',
  'direct': 'SHOP_CUSTOM-INPUT-FIELD-FIELD-SCHEMA-TYPE_DIRECT',
};

/**
 * shop - custom-input-field-field-schema-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CUSTOM_INPUT_FIELD_FIELD_SCHEMA_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopCustomInputFieldFieldSchemaTypeCode, AclosetShopCustomInputFieldFieldSchemaTypeShortCode>> = {
  'SHOP_CUSTOM-INPUT-FIELD-FIELD-SCHEMA-TYPE_BUTTON': 'button',
  'SHOP_CUSTOM-INPUT-FIELD-FIELD-SCHEMA-TYPE_DIRECT': 'direct',
};

// ************************************************************************************************

/**
 * shop - contract-unit-type 리스트.
 */
export const ACLOSET_SHOP_CONTRACT_UNIT_TYPE_CODE_LIST = [
  'SHOP_CONTRACT-UNIT-TYPE_COUNT',  // 건당 요금
] as const;

/**
 * shop - contract-unit-type 타입.
 */
export type AclosetShopContractUnitTypeCode = (typeof ACLOSET_SHOP_CONTRACT_UNIT_TYPE_CODE_LIST)[number];

/**
 * shop - contract-unit-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_CONTRACT_UNIT_TYPE_SHORT_CODE_LIST = [
  'count',  // 건당 요금
] as const;

/**
 * shop - contract-unit-type Short 코드 타입.
 */
export type AclosetShopContractUnitTypeShortCode = (typeof ACLOSET_SHOP_CONTRACT_UNIT_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - contract-unit-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_CONTRACT_UNIT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopContractUnitTypeShortCode, AclosetShopContractUnitTypeCode>> = {
  'count': 'SHOP_CONTRACT-UNIT-TYPE_COUNT',
};

/**
 * shop - contract-unit-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CONTRACT_UNIT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopContractUnitTypeCode, AclosetShopContractUnitTypeShortCode>> = {
  'SHOP_CONTRACT-UNIT-TYPE_COUNT': 'count',
};

// ************************************************************************************************

/**
 * shop - contract-payment-status 리스트.
 */
export const ACLOSET_SHOP_CONTRACT_PAYMENT_STATUS_CODE_LIST = [
  'SHOP_CONTRACT-PAYMENT-STATUS_BEFORE-SETTLEMENT',  // 이용료 정산 전
  'SHOP_CONTRACT-PAYMENT-STATUS_NON-PAYMENT',        // 입금 대기중
  'SHOP_CONTRACT-PAYMENT-STATUS_PAYMENT-COMPLETED',  // 납부 완료
] as const;

/**
 * shop - contract-payment-status 타입.
 */
export type AclosetShopContractPaymentStatusCode = (typeof ACLOSET_SHOP_CONTRACT_PAYMENT_STATUS_CODE_LIST)[number];

/**
 * shop - contract-payment-status Short 코드 리스트.
 */
export const ACLOSET_SHOP_CONTRACT_PAYMENT_STATUS_SHORT_CODE_LIST = [
  'before-settlement',  // 이용료 정산 전
  'non-payment',        // 입금 대기중
  'payment-completed',  // 납부 완료
] as const;

/**
 * shop - contract-payment-status Short 코드 타입.
 */
export type AclosetShopContractPaymentStatusShortCode = (typeof ACLOSET_SHOP_CONTRACT_PAYMENT_STATUS_SHORT_CODE_LIST)[number];

/**
 * shop - contract-payment-status Short 코드 매핑.
 */
export const ACLOSET_SHOP_CONTRACT_PAYMENT_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetShopContractPaymentStatusShortCode, AclosetShopContractPaymentStatusCode>> = {
  'before-settlement': 'SHOP_CONTRACT-PAYMENT-STATUS_BEFORE-SETTLEMENT',
  'non-payment'      : 'SHOP_CONTRACT-PAYMENT-STATUS_NON-PAYMENT',
  'payment-completed': 'SHOP_CONTRACT-PAYMENT-STATUS_PAYMENT-COMPLETED',
};

/**
 * shop - contract-payment-status Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CONTRACT_PAYMENT_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopContractPaymentStatusCode, AclosetShopContractPaymentStatusShortCode>> = {
  'SHOP_CONTRACT-PAYMENT-STATUS_BEFORE-SETTLEMENT': 'before-settlement',
  'SHOP_CONTRACT-PAYMENT-STATUS_NON-PAYMENT'      : 'non-payment',
  'SHOP_CONTRACT-PAYMENT-STATUS_PAYMENT-COMPLETED': 'payment-completed',
};

// ************************************************************************************************

/**
 * shop - category 리스트.
 */
export const ACLOSET_SHOP_CATEGORY_CODE_LIST = [
  'SHOP_CATEGORY_RULE_STEP_CATEGORY-RULE',      // 상품 분류 연결
  'SHOP_CATEGORY_RULE_STEP_MAPPING-CATEGORY',   // 미연결 상품 분류 연결
  'SHOP_CATEGORY_RULE_STEP_MAPPING-GROUP',      // 상품군 선택
  'SHOP_CATEGORY_RULE_STEP_PLATFORM-CATEGORY',  // 상품 분류 정리
] as const;

/**
 * shop - category 타입.
 */
export type AclosetShopCategoryCode = (typeof ACLOSET_SHOP_CATEGORY_CODE_LIST)[number];

/**
 * shop - category Short 코드 리스트.
 */
export const ACLOSET_SHOP_CATEGORY_SHORT_CODE_LIST = [
  'rule_step_category-rule',      // 상품 분류 연결
  'rule_step_mapping-category',   // 미연결 상품 분류 연결
  'rule_step_mapping-group',      // 상품군 선택
  'rule_step_platform-category',  // 상품 분류 정리
] as const;

/**
 * shop - category Short 코드 타입.
 */
export type AclosetShopCategoryShortCode = (typeof ACLOSET_SHOP_CATEGORY_SHORT_CODE_LIST)[number];

/**
 * shop - category Short 코드 매핑.
 */
export const ACLOSET_SHOP_CATEGORY_SHORT_CODE_MAP: Readonly<Record<AclosetShopCategoryShortCode, AclosetShopCategoryCode>> = {
  'rule_step_category-rule'    : 'SHOP_CATEGORY_RULE_STEP_CATEGORY-RULE',
  'rule_step_mapping-category' : 'SHOP_CATEGORY_RULE_STEP_MAPPING-CATEGORY',
  'rule_step_mapping-group'    : 'SHOP_CATEGORY_RULE_STEP_MAPPING-GROUP',
  'rule_step_platform-category': 'SHOP_CATEGORY_RULE_STEP_PLATFORM-CATEGORY',
};

/**
 * shop - category Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CATEGORY_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopCategoryCode, AclosetShopCategoryShortCode>> = {
  'SHOP_CATEGORY_RULE_STEP_CATEGORY-RULE'    : 'rule_step_category-rule',
  'SHOP_CATEGORY_RULE_STEP_MAPPING-CATEGORY' : 'rule_step_mapping-category',
  'SHOP_CATEGORY_RULE_STEP_MAPPING-GROUP'    : 'rule_step_mapping-group',
  'SHOP_CATEGORY_RULE_STEP_PLATFORM-CATEGORY': 'rule_step_platform-category',
};

// ************************************************************************************************

/**
 * shop - cafe24-setting-request-type 리스트.
 */
export const ACLOSET_SHOP_CAFE_24_SETTING_REQUEST_TYPE_CODE_LIST = [
  'SHOP_CAFE24-SETTING-REQUEST-TYPE_DONE',       // 연동 완료
  'SHOP_CAFE24-SETTING-REQUEST-TYPE_NONE',       // 요청 없음
  'SHOP_CAFE24-SETTING-REQUEST-TYPE_REQUESTED',  // 연동 요청
] as const;

/**
 * shop - cafe24-setting-request-type 타입.
 */
export type AclosetShopCafe24SettingRequestTypeCode = (typeof ACLOSET_SHOP_CAFE_24_SETTING_REQUEST_TYPE_CODE_LIST)[number];

/**
 * shop - cafe24-setting-request-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_CAFE_24_SETTING_REQUEST_TYPE_SHORT_CODE_LIST = [
  'done',       // 연동 완료
  'none',       // 요청 없음
  'requested',  // 연동 요청
] as const;

/**
 * shop - cafe24-setting-request-type Short 코드 타입.
 */
export type AclosetShopCafe24SettingRequestTypeShortCode = (typeof ACLOSET_SHOP_CAFE_24_SETTING_REQUEST_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - cafe24-setting-request-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_CAFE_24_SETTING_REQUEST_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopCafe24SettingRequestTypeShortCode, AclosetShopCafe24SettingRequestTypeCode>> = {
  'done'     : 'SHOP_CAFE24-SETTING-REQUEST-TYPE_DONE',
  'none'     : 'SHOP_CAFE24-SETTING-REQUEST-TYPE_NONE',
  'requested': 'SHOP_CAFE24-SETTING-REQUEST-TYPE_REQUESTED',
};

/**
 * shop - cafe24-setting-request-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CAFE_24_SETTING_REQUEST_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopCafe24SettingRequestTypeCode, AclosetShopCafe24SettingRequestTypeShortCode>> = {
  'SHOP_CAFE24-SETTING-REQUEST-TYPE_DONE'     : 'done',
  'SHOP_CAFE24-SETTING-REQUEST-TYPE_NONE'     : 'none',
  'SHOP_CAFE24-SETTING-REQUEST-TYPE_REQUESTED': 'requested',
};

// ************************************************************************************************

/**
 * shop - cafe24-discount-method 리스트.
 */
export const ACLOSET_SHOP_CAFE_24_DISCOUNT_METHOD_CODE_LIST = [
  'SHOP_CAFE24-DISCOUNT-METHOD_COUPON',  // 할인 쿠폰을 만들고, 고객들이 쿠폰을 다운받아 적용하는 방식으로 할인가를 적용합니다.
  'SHOP_CAFE24-DISCOUNT-METHOD_PERIOD',  // 상품의 판매가를 직접 낮추거나, 기간할인 정책을 활용합니다.
] as const;

/**
 * shop - cafe24-discount-method 타입.
 */
export type AclosetShopCafe24DiscountMethodCode = (typeof ACLOSET_SHOP_CAFE_24_DISCOUNT_METHOD_CODE_LIST)[number];

/**
 * shop - cafe24-discount-method Short 코드 리스트.
 */
export const ACLOSET_SHOP_CAFE_24_DISCOUNT_METHOD_SHORT_CODE_LIST = [
  'coupon',  // 할인 쿠폰을 만들고, 고객들이 쿠폰을 다운받아 적용하는 방식으로 할인가를 적용합니다.
  'period',  // 상품의 판매가를 직접 낮추거나, 기간할인 정책을 활용합니다.
] as const;

/**
 * shop - cafe24-discount-method Short 코드 타입.
 */
export type AclosetShopCafe24DiscountMethodShortCode = (typeof ACLOSET_SHOP_CAFE_24_DISCOUNT_METHOD_SHORT_CODE_LIST)[number];

/**
 * shop - cafe24-discount-method Short 코드 매핑.
 */
export const ACLOSET_SHOP_CAFE_24_DISCOUNT_METHOD_SHORT_CODE_MAP: Readonly<Record<AclosetShopCafe24DiscountMethodShortCode, AclosetShopCafe24DiscountMethodCode>> = {
  'coupon': 'SHOP_CAFE24-DISCOUNT-METHOD_COUPON',
  'period': 'SHOP_CAFE24-DISCOUNT-METHOD_PERIOD',
};

/**
 * shop - cafe24-discount-method Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CAFE_24_DISCOUNT_METHOD_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopCafe24DiscountMethodCode, AclosetShopCafe24DiscountMethodShortCode>> = {
  'SHOP_CAFE24-DISCOUNT-METHOD_COUPON': 'coupon',
  'SHOP_CAFE24-DISCOUNT-METHOD_PERIOD': 'period',
};

// ************************************************************************************************

/**
 * shop - cafe24-brand-code-input-type 리스트.
 */
export const ACLOSET_SHOP_CAFE_24_BRAND_CODE_INPUT_TYPE_CODE_LIST = [
  'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_EXIST-BRAND-ONLY',          // 내가 카페24에서 관리하고 있는 브랜드에 대해서만 해당 브랜드 코드를 찾아 입력합니다.
  'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_EXIST-BRAND-OR-NEW-BRAND',  // 카페24에서의 관리 여부와 관계없이 모든 브랜드에 대하여 브랜드 코드를 입력합니다. (없었던 브랜드의 경우, 신규로 브랜드 코드를 발급받아 입력)
  'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_NONE',                      // 브랜드 코드를 따로 입력하지 않습니다. (브랜드 쇼핑 큐레이션 서비스를 활용하지 않는 경우, 대부분의 샵이 이에 해당합니다.)
] as const;

/**
 * shop - cafe24-brand-code-input-type 타입.
 */
export type AclosetShopCafe24BrandCodeInputTypeCode = (typeof ACLOSET_SHOP_CAFE_24_BRAND_CODE_INPUT_TYPE_CODE_LIST)[number];

/**
 * shop - cafe24-brand-code-input-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_CAFE_24_BRAND_CODE_INPUT_TYPE_SHORT_CODE_LIST = [
  'exist-brand-only',          // 내가 카페24에서 관리하고 있는 브랜드에 대해서만 해당 브랜드 코드를 찾아 입력합니다.
  'exist-brand-or-new-brand',  // 카페24에서의 관리 여부와 관계없이 모든 브랜드에 대하여 브랜드 코드를 입력합니다. (없었던 브랜드의 경우, 신규로 브랜드 코드를 발급받아 입력)
  'none',                      // 브랜드 코드를 따로 입력하지 않습니다. (브랜드 쇼핑 큐레이션 서비스를 활용하지 않는 경우, 대부분의 샵이 이에 해당합니다.)
] as const;

/**
 * shop - cafe24-brand-code-input-type Short 코드 타입.
 */
export type AclosetShopCafe24BrandCodeInputTypeShortCode = (typeof ACLOSET_SHOP_CAFE_24_BRAND_CODE_INPUT_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - cafe24-brand-code-input-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_CAFE_24_BRAND_CODE_INPUT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopCafe24BrandCodeInputTypeShortCode, AclosetShopCafe24BrandCodeInputTypeCode>> = {
  'exist-brand-only'        : 'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_EXIST-BRAND-ONLY',
  'exist-brand-or-new-brand': 'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_EXIST-BRAND-OR-NEW-BRAND',
  'none'                    : 'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_NONE',
};

/**
 * shop - cafe24-brand-code-input-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_CAFE_24_BRAND_CODE_INPUT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopCafe24BrandCodeInputTypeCode, AclosetShopCafe24BrandCodeInputTypeShortCode>> = {
  'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_EXIST-BRAND-ONLY'        : 'exist-brand-only',
  'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_EXIST-BRAND-OR-NEW-BRAND': 'exist-brand-or-new-brand',
  'SHOP_CAFE24-BRAND-CODE-INPUT-TYPE_NONE'                    : 'none',
};

// ************************************************************************************************

/**
 * shop - ai-precision 리스트.
 */
export const ACLOSET_SHOP_AI_PRECISION_CODE_LIST = [
  'SHOP_AI-PRECISION_PRECISE-ANALYSIS',  // 정밀 분석
  'SHOP_AI-PRECISION_SIMPLE-ANALYSIS',   // 간편 분석
] as const;

/**
 * shop - ai-precision 타입.
 */
export type AclosetShopAiPrecisionCode = (typeof ACLOSET_SHOP_AI_PRECISION_CODE_LIST)[number];

/**
 * shop - ai-precision Short 코드 리스트.
 */
export const ACLOSET_SHOP_AI_PRECISION_SHORT_CODE_LIST = [
  'precise-analysis',  // 정밀 분석
  'simple-analysis',   // 간편 분석
] as const;

/**
 * shop - ai-precision Short 코드 타입.
 */
export type AclosetShopAiPrecisionShortCode = (typeof ACLOSET_SHOP_AI_PRECISION_SHORT_CODE_LIST)[number];

/**
 * shop - ai-precision Short 코드 매핑.
 */
export const ACLOSET_SHOP_AI_PRECISION_SHORT_CODE_MAP: Readonly<Record<AclosetShopAiPrecisionShortCode, AclosetShopAiPrecisionCode>> = {
  'precise-analysis': 'SHOP_AI-PRECISION_PRECISE-ANALYSIS',
  'simple-analysis' : 'SHOP_AI-PRECISION_SIMPLE-ANALYSIS',
};

/**
 * shop - ai-precision Short 코드 역매핑.
 */
export const ACLOSET_SHOP_AI_PRECISION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopAiPrecisionCode, AclosetShopAiPrecisionShortCode>> = {
  'SHOP_AI-PRECISION_PRECISE-ANALYSIS': 'precise-analysis',
  'SHOP_AI-PRECISION_SIMPLE-ANALYSIS' : 'simple-analysis',
};

// ************************************************************************************************

/**
 * shop - ai-analysis 리스트.
 */
export const ACLOSET_SHOP_AI_ANALYSIS_CODE_LIST = [
  'SHOP_AI-ANALYSIS_BRAND',   // AI 브랜드 입력
  'SHOP_AI-ANALYSIS_FABRIC',  // AI 재질 분석
  'SHOP_AI-ANALYSIS_SIZE',    // AI 치수 입력
] as const;

/**
 * shop - ai-analysis 타입.
 */
export type AclosetShopAiAnalysisCode = (typeof ACLOSET_SHOP_AI_ANALYSIS_CODE_LIST)[number];

/**
 * shop - ai-analysis Short 코드 리스트.
 */
export const ACLOSET_SHOP_AI_ANALYSIS_SHORT_CODE_LIST = [
  'brand',   // AI 브랜드 입력
  'fabric',  // AI 재질 분석
  'size',    // AI 치수 입력
] as const;

/**
 * shop - ai-analysis Short 코드 타입.
 */
export type AclosetShopAiAnalysisShortCode = (typeof ACLOSET_SHOP_AI_ANALYSIS_SHORT_CODE_LIST)[number];

/**
 * shop - ai-analysis Short 코드 매핑.
 */
export const ACLOSET_SHOP_AI_ANALYSIS_SHORT_CODE_MAP: Readonly<Record<AclosetShopAiAnalysisShortCode, AclosetShopAiAnalysisCode>> = {
  'brand' : 'SHOP_AI-ANALYSIS_BRAND',
  'fabric': 'SHOP_AI-ANALYSIS_FABRIC',
  'size'  : 'SHOP_AI-ANALYSIS_SIZE',
};

/**
 * shop - ai-analysis Short 코드 역매핑.
 */
export const ACLOSET_SHOP_AI_ANALYSIS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopAiAnalysisCode, AclosetShopAiAnalysisShortCode>> = {
  'SHOP_AI-ANALYSIS_BRAND' : 'brand',
  'SHOP_AI-ANALYSIS_FABRIC': 'fabric',
  'SHOP_AI-ANALYSIS_SIZE'  : 'size',
};

// ************************************************************************************************

/**
 * shop - account-setting-type 리스트.
 */
export const ACLOSET_SHOP_ACCOUNT_SETTING_TYPE_CODE_LIST = [
  'SHOP_ACCOUNT-SETTING-TYPE_BUSINESS',   // 사업자 정보 확인
  'SHOP_ACCOUNT-SETTING-TYPE_PLATFORM',   // 쇼핑몰 연동
  'SHOP_ACCOUNT-SETTING-TYPE_SETTLMENT',  // 정산 정보 확인
  'SHOP_ACCOUNT-SETTING-TYPE_SHIPPING',   // 배송/반품 정보 화인
  'SHOP_ACCOUNT-SETTING-TYPE_SHOP',       // 샵정보 정보 입력
] as const;

/**
 * shop - account-setting-type 타입.
 */
export type AclosetShopAccountSettingTypeCode = (typeof ACLOSET_SHOP_ACCOUNT_SETTING_TYPE_CODE_LIST)[number];

/**
 * shop - account-setting-type Short 코드 리스트.
 */
export const ACLOSET_SHOP_ACCOUNT_SETTING_TYPE_SHORT_CODE_LIST = [
  'business',   // 사업자 정보 확인
  'platform',   // 쇼핑몰 연동
  'settlment',  // 정산 정보 확인
  'shipping',   // 배송/반품 정보 화인
  'shop',       // 샵정보 정보 입력
] as const;

/**
 * shop - account-setting-type Short 코드 타입.
 */
export type AclosetShopAccountSettingTypeShortCode = (typeof ACLOSET_SHOP_ACCOUNT_SETTING_TYPE_SHORT_CODE_LIST)[number];

/**
 * shop - account-setting-type Short 코드 매핑.
 */
export const ACLOSET_SHOP_ACCOUNT_SETTING_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetShopAccountSettingTypeShortCode, AclosetShopAccountSettingTypeCode>> = {
  'business' : 'SHOP_ACCOUNT-SETTING-TYPE_BUSINESS',
  'platform' : 'SHOP_ACCOUNT-SETTING-TYPE_PLATFORM',
  'settlment': 'SHOP_ACCOUNT-SETTING-TYPE_SETTLMENT',
  'shipping' : 'SHOP_ACCOUNT-SETTING-TYPE_SHIPPING',
  'shop'     : 'SHOP_ACCOUNT-SETTING-TYPE_SHOP',
};

/**
 * shop - account-setting-type Short 코드 역매핑.
 */
export const ACLOSET_SHOP_ACCOUNT_SETTING_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetShopAccountSettingTypeCode, AclosetShopAccountSettingTypeShortCode>> = {
  'SHOP_ACCOUNT-SETTING-TYPE_BUSINESS' : 'business',
  'SHOP_ACCOUNT-SETTING-TYPE_PLATFORM' : 'platform',
  'SHOP_ACCOUNT-SETTING-TYPE_SETTLMENT': 'settlment',
  'SHOP_ACCOUNT-SETTING-TYPE_SHIPPING' : 'shipping',
  'SHOP_ACCOUNT-SETTING-TYPE_SHOP'     : 'shop',
};

// ************************************************************************************************

/**
 * template - type 리스트.
 */
export const ACLOSET_TEMPLATE_TYPE_CODE_LIST = [
  'TEMPLATE_TYPE_INVOICE-FORM',  // 송장 양식
  'TEMPLATE_TYPE_ORDER-FORM',    // 주문 양식
  'TEMPLATE_TYPE_SALE-FORM',     // 상품 양식
] as const;

/**
 * template - type 타입.
 */
export type AclosetTemplateTypeCode = (typeof ACLOSET_TEMPLATE_TYPE_CODE_LIST)[number];

/**
 * template - type Short 코드 리스트.
 */
export const ACLOSET_TEMPLATE_TYPE_SHORT_CODE_LIST = [
  'invoice-form',  // 송장 양식
  'order-form',    // 주문 양식
  'sale-form',     // 상품 양식
] as const;

/**
 * template - type Short 코드 타입.
 */
export type AclosetTemplateTypeShortCode = (typeof ACLOSET_TEMPLATE_TYPE_SHORT_CODE_LIST)[number];

/**
 * template - type Short 코드 매핑.
 */
export const ACLOSET_TEMPLATE_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetTemplateTypeShortCode, AclosetTemplateTypeCode>> = {
  'invoice-form': 'TEMPLATE_TYPE_INVOICE-FORM',
  'order-form'  : 'TEMPLATE_TYPE_ORDER-FORM',
  'sale-form'   : 'TEMPLATE_TYPE_SALE-FORM',
};

/**
 * template - type Short 코드 역매핑.
 */
export const ACLOSET_TEMPLATE_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetTemplateTypeCode, AclosetTemplateTypeShortCode>> = {
  'TEMPLATE_TYPE_INVOICE-FORM': 'invoice-form',
  'TEMPLATE_TYPE_ORDER-FORM'  : 'order-form',
  'TEMPLATE_TYPE_SALE-FORM'   : 'sale-form',
};

// ************************************************************************************************

/**
 * template - extension 리스트.
 */
export const ACLOSET_TEMPLATE_EXTENSION_CODE_LIST = [
  'TEMPLATE_EXTENSION_CSV',   // CSV
  'TEMPLATE_EXTENSION_XLSX',  // XLSX
] as const;

/**
 * template - extension 타입.
 */
export type AclosetTemplateExtensionCode = (typeof ACLOSET_TEMPLATE_EXTENSION_CODE_LIST)[number];

/**
 * template - extension Short 코드 리스트.
 */
export const ACLOSET_TEMPLATE_EXTENSION_SHORT_CODE_LIST = [
  'csv',   // CSV
  'xlsx',  // XLSX
] as const;

/**
 * template - extension Short 코드 타입.
 */
export type AclosetTemplateExtensionShortCode = (typeof ACLOSET_TEMPLATE_EXTENSION_SHORT_CODE_LIST)[number];

/**
 * template - extension Short 코드 매핑.
 */
export const ACLOSET_TEMPLATE_EXTENSION_SHORT_CODE_MAP: Readonly<Record<AclosetTemplateExtensionShortCode, AclosetTemplateExtensionCode>> = {
  'csv' : 'TEMPLATE_EXTENSION_CSV',
  'xlsx': 'TEMPLATE_EXTENSION_XLSX',
};

/**
 * template - extension Short 코드 역매핑.
 */
export const ACLOSET_TEMPLATE_EXTENSION_SHORT_CODE_INV_MAP: Readonly<Record<AclosetTemplateExtensionCode, AclosetTemplateExtensionShortCode>> = {
  'TEMPLATE_EXTENSION_CSV' : 'csv',
  'TEMPLATE_EXTENSION_XLSX': 'xlsx',
};

// ************************************************************************************************

/**
 * template - export-type 리스트.
 */
export const ACLOSET_TEMPLATE_EXPORT_TYPE_CODE_LIST = [
  'TEMPLATE_EXPORT-TYPE_DESCRIPTION',  // 템플릿
  'TEMPLATE_EXPORT-TYPE_TITLE',        // 제목
] as const;

/**
 * template - export-type 타입.
 */
export type AclosetTemplateExportTypeCode = (typeof ACLOSET_TEMPLATE_EXPORT_TYPE_CODE_LIST)[number];

/**
 * template - export-type Short 코드 리스트.
 */
export const ACLOSET_TEMPLATE_EXPORT_TYPE_SHORT_CODE_LIST = [
  'description',  // 템플릿
  'title',        // 제목
] as const;

/**
 * template - export-type Short 코드 타입.
 */
export type AclosetTemplateExportTypeShortCode = (typeof ACLOSET_TEMPLATE_EXPORT_TYPE_SHORT_CODE_LIST)[number];

/**
 * template - export-type Short 코드 매핑.
 */
export const ACLOSET_TEMPLATE_EXPORT_TYPE_SHORT_CODE_MAP: Readonly<Record<AclosetTemplateExportTypeShortCode, AclosetTemplateExportTypeCode>> = {
  'description': 'TEMPLATE_EXPORT-TYPE_DESCRIPTION',
  'title'      : 'TEMPLATE_EXPORT-TYPE_TITLE',
};

/**
 * template - export-type Short 코드 역매핑.
 */
export const ACLOSET_TEMPLATE_EXPORT_TYPE_SHORT_CODE_INV_MAP: Readonly<Record<AclosetTemplateExportTypeCode, AclosetTemplateExportTypeShortCode>> = {
  'TEMPLATE_EXPORT-TYPE_DESCRIPTION': 'description',
  'TEMPLATE_EXPORT-TYPE_TITLE'      : 'title',
};

// ************************************************************************************************

/**
 * tx - status 리스트.
 */
export const ACLOSET_TX_STATUS_CODE_LIST = [
  'TX_STATUS_CANCELED',                    // 거래취소
  'TX_STATUS_PAYMENT-COMPLETED',           // 결제완료
  'TX_STATUS_PAYMENT-PENDING',             // 결제중
  'TX_STATUS_REFUND-COMPLETED',            // 반품완료
  'TX_STATUS_REFUND-REJECT',               // 환불거부
  'TX_STATUS_REFUND-REVIEW',               // 분쟁심사
  'TX_STATUS_REFUND-WAIT',                 // 합의환불대기
  'TX_STATUS_SHIPPING-COMPLETED',          // 배송완료
  'TX_STATUS_SHIPPING-IN-TRANSIT',         // 배송중
  'TX_STATUS_SHIPPING-PREPARING',          // 배송준비중
  'TX_STATUS_TRANSACTION-COMPLETED-SAFE',  // 안전결제 거래완료
] as const;

/**
 * tx - status 타입.
 */
export type AclosetTxStatusCode = (typeof ACLOSET_TX_STATUS_CODE_LIST)[number];

/**
 * tx - status Short 코드 리스트.
 */
export const ACLOSET_TX_STATUS_SHORT_CODE_LIST = [
  'canceled',                    // 거래취소
  'payment-completed',           // 결제완료
  'payment-pending',             // 결제중
  'refund-completed',            // 반품완료
  'refund-reject',               // 환불거부
  'refund-review',               // 분쟁심사
  'refund-wait',                 // 합의환불대기
  'shipping-completed',          // 배송완료
  'shipping-in-transit',         // 배송중
  'shipping-preparing',          // 배송준비중
  'transaction-completed-safe',  // 안전결제 거래완료
] as const;

/**
 * tx - status Short 코드 타입.
 */
export type AclosetTxStatusShortCode = (typeof ACLOSET_TX_STATUS_SHORT_CODE_LIST)[number];

/**
 * tx - status Short 코드 매핑.
 */
export const ACLOSET_TX_STATUS_SHORT_CODE_MAP: Readonly<Record<AclosetTxStatusShortCode, AclosetTxStatusCode>> = {
  'canceled'                  : 'TX_STATUS_CANCELED',
  'payment-completed'         : 'TX_STATUS_PAYMENT-COMPLETED',
  'payment-pending'           : 'TX_STATUS_PAYMENT-PENDING',
  'refund-completed'          : 'TX_STATUS_REFUND-COMPLETED',
  'refund-reject'             : 'TX_STATUS_REFUND-REJECT',
  'refund-review'             : 'TX_STATUS_REFUND-REVIEW',
  'refund-wait'               : 'TX_STATUS_REFUND-WAIT',
  'shipping-completed'        : 'TX_STATUS_SHIPPING-COMPLETED',
  'shipping-in-transit'       : 'TX_STATUS_SHIPPING-IN-TRANSIT',
  'shipping-preparing'        : 'TX_STATUS_SHIPPING-PREPARING',
  'transaction-completed-safe': 'TX_STATUS_TRANSACTION-COMPLETED-SAFE',
};

/**
 * tx - status Short 코드 역매핑.
 */
export const ACLOSET_TX_STATUS_SHORT_CODE_INV_MAP: Readonly<Record<AclosetTxStatusCode, AclosetTxStatusShortCode>> = {
  'TX_STATUS_CANCELED'                  : 'canceled',
  'TX_STATUS_PAYMENT-COMPLETED'         : 'payment-completed',
  'TX_STATUS_PAYMENT-PENDING'           : 'payment-pending',
  'TX_STATUS_REFUND-COMPLETED'          : 'refund-completed',
  'TX_STATUS_REFUND-REJECT'             : 'refund-reject',
  'TX_STATUS_REFUND-REVIEW'             : 'refund-review',
  'TX_STATUS_REFUND-WAIT'               : 'refund-wait',
  'TX_STATUS_SHIPPING-COMPLETED'        : 'shipping-completed',
  'TX_STATUS_SHIPPING-IN-TRANSIT'       : 'shipping-in-transit',
  'TX_STATUS_SHIPPING-PREPARING'        : 'shipping-preparing',
  'TX_STATUS_TRANSACTION-COMPLETED-SAFE': 'transaction-completed-safe',
};

